/* eslint-disable */
import { getLocale, experimentalStaticLocale } from "../runtime.js"

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Auth_BannedInputs */
/** @typedef {{}} Auth_Mail_Send_FailedInputs */
/** @typedef {{ seconds: NonNullable<unknown> }} Auth_Resend_Too_SoonInputs */
/** @typedef {{}} Cv_As_BroadcastInputs */
/** @typedef {{}} Cv_BroadcastInputs */
/** @typedef {{}} Cv_Broadcast_HintInputs */
/** @typedef {{}} Cv_Broadcast_No_ReplyInputs */
/** @typedef {{}} Cv_CancelInputs */
/** @typedef {{}} Cv_Cannot_PostInputs */
/** @typedef {{}} Cv_Col_Last_MessageInputs */
/** @typedef {{}} Cv_Col_NameInputs */
/** @typedef {{}} Cv_Col_SpaceInputs */
/** @typedef {{}} Cv_Col_UpdatedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Dm_EmptyInputs */
/** @typedef {{ names: NonNullable<unknown> }} Cv_Dm_Empty_GroupInputs */
/** @typedef {{}} Cv_Dm_Empty_SelfInputs */
/** @typedef {{}} Cv_Dm_Empty_UnknownInputs */
/** @typedef {{ when: NonNullable<unknown> }} Cv_Dm_LastInputs */
/** @typedef {{ count: NonNullable<unknown> }} Cv_Dm_MembersInputs */
/** @typedef {{}} Cv_Dm_MenuInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Dm_Self_NameInputs */
/** @typedef {{}} Cv_DmsInputs */
/** @typedef {{}} Cv_Dms_EmptyInputs */
/** @typedef {{}} Cv_Dms_None_MatchInputs */
/** @typedef {{}} Cv_Dms_None_UnreadInputs */
/** @typedef {{}} Cv_Dms_StartInputs */
/** @typedef {{}} Cv_EditInputs */
/** @typedef {{}} Cv_Edit_LabelInputs */
/** @typedef {{}} Cv_Emoji_AddInputs */
/** @typedef {{}} Cv_Emoji_Add_SectionInputs */
/** @typedef {{}} Cv_Emoji_Cannot_AddInputs */
/** @typedef {{}} Cv_Emoji_ChooseInputs */
/** @typedef {{}} Cv_Emoji_Choose_ImageInputs */
/** @typedef {{}} Cv_Emoji_EmptyInputs */
/** @typedef {{ max: NonNullable<unknown> }} Cv_Emoji_FullInputs */
/** @typedef {{}} Cv_Emoji_ImageInputs */
/** @typedef {{ kb: NonNullable<unknown> }} Cv_Emoji_Image_NoteInputs */
/** @typedef {{}} Cv_Emoji_ListInputs */
/** @typedef {{}} Cv_Emoji_NameInputs */
/** @typedef {{}} Cv_Emoji_Name_NoteInputs */
/** @typedef {{}} Cv_Emoji_Name_RuleInputs */
/** @typedef {{}} Cv_Emoji_No_ImageInputs */
/** @typedef {{}} Cv_Emoji_Pick_ImageInputs */
/** @typedef {{}} Cv_Emoji_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Emoji_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Emoji_Remove_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Emoji_Remove_TitleInputs */
/** @typedef {{ kb: NonNullable<unknown> }} Cv_Emoji_Too_LargeInputs */
/** @typedef {{}} Cv_FilterInputs */
/** @typedef {{}} Cv_Filter_AllInputs */
/** @typedef {{}} Cv_Filter_BroadcastsInputs */
/** @typedef {{}} Cv_Filter_SpaceInputs */
/** @typedef {{}} Cv_Filter_Space_AllInputs */
/** @typedef {{}} Cv_Filter_UnreadInputs */
/** @typedef {{}} Cv_InboxInputs */
/** @typedef {{}} Cv_Inbox_Reason_PostedInputs */
/** @typedef {{}} Cv_Load_FailedInputs */
/** @typedef {{}} Cv_Loading_OlderInputs */
/** @typedef {{}} Cv_Mark_ReadInputs */
/** @typedef {{}} Cv_Me_DmsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Cv_Members_CountInputs */
/** @typedef {{ count: NonNullable<unknown> }} Cv_Members_MoreInputs */
/** @typedef {{}} Cv_Mention_Cannot_SeeInputs */
/** @typedef {{}} Cv_Message_MenuInputs */
/** @typedef {{}} Cv_MoveInputs */
/** @typedef {{}} Cv_Move_ActionInputs */
/** @typedef {{}} Cv_NarrowInputs */
/** @typedef {{}} Cv_Narrow_NameInputs */
/** @typedef {{}} Cv_Narrow_TitleInputs */
/** @typedef {{}} Cv_New_DmInputs */
/** @typedef {{}} Cv_New_Dm_ChosenInputs */
/** @typedef {{ max: NonNullable<unknown> }} Cv_New_Dm_LimitInputs */
/** @typedef {{}} Cv_New_Dm_NobodyInputs */
/** @typedef {{}} Cv_New_Dm_PeopleInputs */
/** @typedef {{}} Cv_New_Dm_SearchInputs */
/** @typedef {{}} Cv_New_Dm_StartInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_New_Dm_UnpickInputs */
/** @typedef {{}} Cv_New_TopicInputs */
/** @typedef {{}} Cv_New_Topic_HintInputs */
/** @typedef {{}} Cv_New_Topic_InInputs */
/** @typedef {{}} Cv_No_DescriptionInputs */
/** @typedef {{}} Cv_No_SpaceInputs */
/** @typedef {{}} Cv_Not_FoundInputs */
/** @typedef {{}} Cv_PinInputs */
/** @typedef {{}} Cv_Pin_DownInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Pin_Down_LabelInputs */
/** @typedef {{}} Cv_Pin_GoneInputs */
/** @typedef {{}} Cv_Pin_UpInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Pin_Up_LabelInputs */
/** @typedef {{}} Cv_PinsInputs */
/** @typedef {{}} Cv_Pins_EmptyInputs */
/** @typedef {{}} Cv_Pins_Empty_CanInputs */
/** @typedef {{}} Cv_Post_LabelInputs */
/** @typedef {{}} Cv_Post_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Post_Placeholder_DmInputs */
/** @typedef {{ names: NonNullable<unknown> }} Cv_Post_Placeholder_Dm_GroupInputs */
/** @typedef {{}} Cv_Post_Placeholder_Dm_SelfInputs */
/** @typedef {{}} Cv_ReactInputs */
/** @typedef {{}} Cv_React_NoneInputs */
/** @typedef {{}} Cv_React_SearchInputs */
/** @typedef {{}} Cv_Reaction_CheckInputs */
/** @typedef {{}} Cv_Reaction_EyeInputs */
/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Cv_Reaction_LabelInputs */
/** @typedef {{}} Cv_ReactionsInputs */
/** @typedef {{}} Cv_Recent_TopicsInputs */
/** @typedef {{}} Cv_RemoveInputs */
/** @typedef {{}} Cv_Remove_BodyInputs */
/** @typedef {{}} Cv_Remove_TitleInputs */
/** @typedef {{}} Cv_RenameInputs */
/** @typedef {{}} Cv_Rename_ActionInputs */
/** @typedef {{}} Cv_SaveInputs */
/** @typedef {{}} Cv_Save_FailedInputs */
/** @typedef {{}} Cv_Send_FailedInputs */
/** @typedef {{}} Cv_Settings_EmojiInputs */
/** @typedef {{}} Cv_Settings_Emoji_DescriptionInputs */
/** @typedef {{}} Cv_Settings_Emoji_ShortInputs */
/** @typedef {{}} Cv_SpaceInputs */
/** @typedef {{}} Cv_Space_MissingInputs */
/** @typedef {{}} Cv_Space_OverviewInputs */
/** @typedef {{}} Cv_Start_HereInputs */
/** @typedef {{}} Cv_Suggest_EmojiInputs */
/** @typedef {{}} Cv_Suggest_LinksInputs */
/** @typedef {{}} Cv_Suggest_PeopleInputs */
/** @typedef {{ max: NonNullable<unknown> }} Cv_Too_LongInputs */
/** @typedef {{}} Cv_TopicInputs */
/** @typedef {{}} Cv_Topic_MenuInputs */
/** @typedef {{}} Cv_Topic_NameInputs */
/** @typedef {{}} Cv_Topic_Name_PlaceholderInputs */
/** @typedef {{}} Cv_TopicsInputs */
/** @typedef {{}} Cv_Topics_EmptyInputs */
/** @typedef {{}} Cv_Topics_None_MatchInputs */
/** @typedef {{}} Cv_Topics_StartInputs */
/** @typedef {{}} Cv_UnpinInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Unpin_LabelInputs */
/** @typedef {{}} Cv_Unread_DotInputs */
/** @typedef {{}} Desktop_Client_Not_AllowedInputs */
/** @typedef {{}} Desktop_Scope_MissingInputs */
/** @typedef {{}} Desktop_Token_ExpiredInputs */
/** @typedef {{}} Desktop_Token_InvalidInputs */
/** @typedef {{}} Desktop_Token_MissingInputs */
/** @typedef {{}} Desktop_Token_RevokedInputs */
/** @typedef {{}} Desktop_WaitlistedInputs */
/** @typedef {{}} Issues_ActivityInputs */
/** @typedef {{}} Issues_Activity_Assignee_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Assignee_SetInputs */
/** @typedef {{}} Issues_Activity_CreatedInputs */
/** @typedef {{}} Issues_Activity_Cycle_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Cycle_SetInputs */
/** @typedef {{}} Issues_Activity_Due_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Due_SetInputs */
/** @typedef {{ label: NonNullable<unknown> }} Issues_Activity_Label_AddedInputs */
/** @typedef {{ label: NonNullable<unknown> }} Issues_Activity_Label_RemovedInputs */
/** @typedef {{ text: NonNullable<unknown> }} Issues_Activity_LineInputs */
/** @typedef {{}} Issues_Activity_Milestone_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Milestone_SetInputs */
/** @typedef {{}} Issues_Activity_Project_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Project_SetInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_StateInputs */
/** @typedef {{}} Issues_Activity_Team_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Team_SetInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_TitleInputs */
/** @typedef {{}} Issues_Add_LabelInputs */
/** @typedef {{}} Issues_Ai_MemoInputs */
/** @typedef {{}} Issues_AllInputs */
/** @typedef {{}} Issues_CancelInputs */
/** @typedef {{}} Issues_Cannot_UndoInputs */
/** @typedef {{}} Issues_Change_AssigneeInputs */
/** @typedef {{}} Issues_Change_CycleInputs */
/** @typedef {{}} Issues_Change_DueInputs */
/** @typedef {{}} Issues_Change_MilestoneInputs */
/** @typedef {{}} Issues_Change_ProjectInputs */
/** @typedef {{}} Issues_Change_SpaceInputs */
/** @typedef {{}} Issues_Change_StateInputs */
/** @typedef {{}} Issues_Change_Target_DateInputs */
/** @typedef {{}} Issues_Change_TeamInputs */
/** @typedef {{}} Issues_Choose_MilestoneInputs */
/** @typedef {{}} Issues_Choose_Team_FirstInputs */
/** @typedef {{}} Issues_Clear_DueInputs */
/** @typedef {{}} Issues_CloseInputs */
/** @typedef {{}} Issues_Col_AssigneeInputs */
/** @typedef {{}} Issues_Col_DueInputs */
/** @typedef {{}} Issues_Col_NameInputs */
/** @typedef {{}} Issues_Col_ProjectInputs */
/** @typedef {{}} Issues_Col_SpaceInputs */
/** @typedef {{}} Issues_Col_StateInputs */
/** @typedef {{}} Issues_Col_UpdatedInputs */
/** @typedef {{}} Issues_Comment_Edit_LabelInputs */
/** @typedef {{}} Issues_Comment_FailedInputs */
/** @typedef {{}} Issues_Comment_LabelInputs */
/** @typedef {{}} Issues_Comment_MenuInputs */
/** @typedef {{}} Issues_Comment_PlaceholderInputs */
/** @typedef {{ excerpt: NonNullable<unknown> }} Issues_Comment_Remove_TitleInputs */
/** @typedef {{}} Issues_CommentsInputs */
/** @typedef {{}} Issues_CreateInputs */
/** @typedef {{}} Issues_Create_FailedInputs */
/** @typedef {{}} Issues_Create_HintInputs */
/** @typedef {{}} Issues_Cycle_Active_TagInputs */
/** @typedef {{}} Issues_Cycle_Add_NextInputs */
/** @typedef {{ n: NonNullable<unknown> }} Issues_Cycle_Days_LeftInputs */
/** @typedef {{}} Issues_Cycle_Done_TagInputs */
/** @typedef {{}} Issues_Cycle_EmptyInputs */
/** @typedef {{}} Issues_Cycle_LengthInputs */
/** @typedef {{}} Issues_Cycle_MenuInputs */
/** @typedef {{ left: NonNullable<unknown> }} Issues_Cycle_Meta_ActiveInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Issues_Cycle_Meta_DoneInputs */
/** @typedef {{ starts: NonNullable<unknown> }} Issues_Cycle_Meta_Not_StartedInputs */
/** @typedef {{}} Issues_Cycle_Not_FoundInputs */
/** @typedef {{}} Issues_Cycle_Planned_TagInputs */
/** @typedef {{}} Issues_Cycle_RemoveInputs */
/** @typedef {{}} Issues_Cycle_Remove_ActionInputs */
/** @typedef {{}} Issues_Cycle_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown>, team: NonNullable<unknown> }} Issues_Cycle_Remove_TitleInputs */
/** @typedef {{ starts: NonNullable<unknown>, pct: NonNullable<unknown>, count: NonNullable<unknown> }} Issues_Cycle_SubInputs */
/** @typedef {{ starts: NonNullable<unknown>, count: NonNullable<unknown> }} Issues_Cycle_Sub_PlannedInputs */
/** @typedef {{}} Issues_Cycles_EmptyInputs */
/** @typedef {{}} Issues_Cycles_None_MatchInputs */
/** @typedef {{}} Issues_Days_UnitInputs */
/** @typedef {{}} Issues_EditInputs */
/** @typedef {{}} Issues_EmptyInputs */
/** @typedef {{}} Issues_End_DateInputs */
/** @typedef {{}} Issues_Filter_SpaceInputs */
/** @typedef {{}} Issues_Filter_Space_AllInputs */
/** @typedef {{}} Issues_Filter_TeamInputs */
/** @typedef {{}} Issues_Former_MemberInputs */
/** @typedef {{}} Issues_Group_ByInputs */
/** @typedef {{}} Issues_Group_By_AssigneeInputs */
/** @typedef {{}} Issues_Group_By_ProjectInputs */
/** @typedef {{}} Issues_Group_By_StateInputs */
/** @typedef {{}} Issues_Group_By_TeamInputs */
/** @typedef {{}} Issues_Group_No_ProjectInputs */
/** @typedef {{}} Issues_Group_No_TeamInputs */
/** @typedef {{}} Issues_Load_FailedInputs */
/** @typedef {{}} Issues_Make_FirstInputs */
/** @typedef {{}} Issues_Make_ProjectInputs */
/** @typedef {{}} Issues_Make_TeamInputs */
/** @typedef {{}} Issues_MenuInputs */
/** @typedef {{}} Issues_Milestone_AddInputs */
/** @typedef {{}} Issues_Milestone_Add_RowInputs */
/** @typedef {{}} Issues_Milestone_NameInputs */
/** @typedef {{}} Issues_Milestone_Name_ExampleInputs */
/** @typedef {{}} Issues_Milestone_New_NameInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Milestone_RemoveInputs */
/** @typedef {{}} Issues_Milestone_Remove_BodyInputs */
/** @typedef {{}} Issues_Milestone_Remove_RowInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Milestone_Remove_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Milestone_RenameInputs */
/** @typedef {{}} Issues_Milestone_Row_PlaceholderInputs */
/** @typedef {{}} Issues_NarrowInputs */
/** @typedef {{}} Issues_Narrow_CyclesInputs */
/** @typedef {{}} Issues_Narrow_Cycles_PlaceholderInputs */
/** @typedef {{}} Issues_Narrow_PlaceholderInputs */
/** @typedef {{}} Issues_Narrow_ProjectsInputs */
/** @typedef {{}} Issues_Narrow_Projects_PlaceholderInputs */
/** @typedef {{}} Issues_NavInputs */
/** @typedef {{}} Issues_NewInputs */
/** @typedef {{}} Issues_New_ProjectInputs */
/** @typedef {{}} Issues_New_TeamInputs */
/** @typedef {{}} Issues_New_Team_Cycle_DaysInputs */
/** @typedef {{}} Issues_New_Team_Name_PlaceholderInputs */
/** @typedef {{}} Issues_New_Team_NoteInputs */
/** @typedef {{}} Issues_No_ActivityInputs */
/** @typedef {{}} Issues_No_CycleInputs */
/** @typedef {{}} Issues_No_DueInputs */
/** @typedef {{}} Issues_No_MilestoneInputs */
/** @typedef {{}} Issues_No_PermissionInputs */
/** @typedef {{}} Issues_No_Permission_ProjectInputs */
/** @typedef {{}} Issues_No_Permission_TeamInputs */
/** @typedef {{}} Issues_No_ProjectInputs */
/** @typedef {{}} Issues_No_SpaceInputs */
/** @typedef {{}} Issues_No_Space_ProjectInputs */
/** @typedef {{}} Issues_No_Space_TeamInputs */
/** @typedef {{}} Issues_No_TeamInputs */
/** @typedef {{}} Issues_NoneInputs */
/** @typedef {{}} Issues_None_MatchInputs */
/** @typedef {{}} Issues_Not_FoundInputs */
/** @typedef {{}} Issues_Not_SetInputs */
/** @typedef {{}} Issues_NoteInputs */
/** @typedef {{}} Issues_Note_New_PlaceholderInputs */
/** @typedef {{}} Issues_Note_PlaceholderInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Issues_Progress_DoneInputs */
/** @typedef {{}} Issues_Project_CreateInputs */
/** @typedef {{}} Issues_Project_Create_FailedInputs */
/** @typedef {{}} Issues_Project_DoneInputs */
/** @typedef {{ count: NonNullable<unknown> }} Issues_Project_Issue_CountInputs */
/** @typedef {{}} Issues_Project_MenuInputs */
/** @typedef {{}} Issues_Project_NameInputs */
/** @typedef {{}} Issues_Project_Name_PlaceholderInputs */
/** @typedef {{}} Issues_Project_Not_FoundInputs */
/** @typedef {{}} Issues_Project_Note_New_PlaceholderInputs */
/** @typedef {{}} Issues_Project_Note_PlaceholderInputs */
/** @typedef {{ pct: NonNullable<unknown> }} Issues_Project_Pct_TargetInputs */
/** @typedef {{}} Issues_Project_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Project_Remove_TitleInputs */
/** @typedef {{}} Issues_Project_ReopenInputs */
/** @typedef {{ pct: NonNullable<unknown>, due: NonNullable<unknown>, teams: NonNullable<unknown> }} Issues_Project_SubInputs */
/** @typedef {{ pct: NonNullable<unknown>, due: NonNullable<unknown>, count: NonNullable<unknown> }} Issues_Project_SummaryInputs */
/** @typedef {{}} Issues_Projects_EmptyInputs */
/** @typedef {{}} Issues_Projects_None_DoneInputs */
/** @typedef {{}} Issues_Projects_None_MatchInputs */
/** @typedef {{}} Issues_Projects_StateInputs */
/** @typedef {{}} Issues_Prop_AssigneeInputs */
/** @typedef {{}} Issues_Prop_CycleInputs */
/** @typedef {{}} Issues_Prop_DueInputs */
/** @typedef {{}} Issues_Prop_LabelsInputs */
/** @typedef {{}} Issues_Prop_MilestoneInputs */
/** @typedef {{}} Issues_Prop_ProjectInputs */
/** @typedef {{}} Issues_Prop_StateInputs */
/** @typedef {{}} Issues_Prop_TeamInputs */
/** @typedef {{}} Issues_Range_SepInputs */
/** @typedef {{}} Issues_ReloadInputs */
/** @typedef {{}} Issues_Reload_NeededInputs */
/** @typedef {{}} Issues_RemoveInputs */
/** @typedef {{}} Issues_Remove_BodyInputs */
/** @typedef {{ names: NonNullable<unknown> }} Issues_Remove_Many_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Issues_Remove_Many_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Issues_Remove_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Issues_Row_MenuInputs */
/** @typedef {{}} Issues_SaveInputs */
/** @typedef {{}} Issues_Save_FailedInputs */
/** @typedef {{ state: NonNullable<unknown> }} Issues_Set_StateInputs */
/** @typedef {{}} Issues_SomeoneInputs */
/** @typedef {{}} Issues_Start_DateInputs */
/** @typedef {{ date: NonNullable<unknown> }} Issues_Starts_OnInputs */
/** @typedef {{}} Issues_State_DoingInputs */
/** @typedef {{}} Issues_State_DoneInputs */
/** @typedef {{}} Issues_State_OpenInputs */
/** @typedef {{}} Issues_State_ReviewInputs */
/** @typedef {{}} Issues_Tab_CyclesInputs */
/** @typedef {{}} Issues_Tab_IssuesInputs */
/** @typedef {{}} Issues_Tab_ProjectsInputs */
/** @typedef {{}} Issues_Tab_UpcomingInputs */
/** @typedef {{}} Issues_TabsInputs */
/** @typedef {{}} Issues_Target_DateInputs */
/** @typedef {{}} Issues_Team_CreateInputs */
/** @typedef {{}} Issues_Team_Create_FailedInputs */
/** @typedef {{}} Issues_Team_NameInputs */
/** @typedef {{}} Issues_Team_SettingsInputs */
/** @typedef {{}} Issues_Teams_EmptyInputs */
/** @typedef {{ n: NonNullable<unknown> }} Issues_Time_Days_AgoInputs */
/** @typedef {{ time: NonNullable<unknown> }} Issues_Time_YesterdayInputs */
/** @typedef {{}} Issues_Title_LabelInputs */
/** @typedef {{}} Issues_Title_PlaceholderInputs */
/** @typedef {{ max: NonNullable<unknown> }} Issues_Too_LongInputs */
/** @typedef {{}} Issues_UnassignedInputs */
/** @typedef {{}} Issues_Upcoming_EmptyInputs */
/** @typedef {{}} Mail_Approved_Line_BodyInputs */
/** @typedef {{}} Mail_Approved_SubjectInputs */
/** @typedef {{ otp: NonNullable<unknown> }} Mail_Sign_In_Code_Line_CodeInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Mail_Sign_In_Code_Line_ExpiresInputs */
/** @typedef {{}} Mail_Sign_In_Code_Line_IgnoreInputs */
/** @typedef {{}} Mail_Sign_In_Code_SubjectInputs */
/** @typedef {{ email: NonNullable<unknown> }} Mail_Waitlist_Joined_Line_BodyInputs */
/** @typedef {{}} Mail_Waitlist_Joined_SubjectInputs */
/** @typedef {{}} Publish_ArchivedInputs */
/** @typedef {{}} Publish_Kind_ChatInputs */
/** @typedef {{}} Publish_Kind_MemberInputs */
/** @typedef {{}} Publish_Kind_MessageInputs */
/** @typedef {{}} Publish_Kind_OtherInputs */
/** @typedef {{}} Publish_Kind_Private_PageInputs */
/** @typedef {{}} Publish_Made_WithInputs */
/** @typedef {{}} Publish_Slide_ControlsInputs */
/** @typedef {{}} Publish_Slide_Exit_FullscreenInputs */
/** @typedef {{}} Publish_Slide_FullscreenInputs */
/** @typedef {{}} Publish_Slide_NextInputs */
/** @typedef {{}} Publish_Slide_PrevInputs */
/** @typedef {{}} Publish_UnavailableInputs */
/** @typedef {{ date: NonNullable<unknown> }} Publish_Updated_AtInputs */
/** @typedef {{ device: NonNullable<unknown> }} Push_App_DeniedInputs */
/** @typedef {{ device: NonNullable<unknown> }} Push_App_LabelInputs */
/** @typedef {{}} Push_App_Open_SettingsInputs */
/** @typedef {{}} Push_BlockedInputs */
/** @typedef {{ when: NonNullable<unknown> }} Push_Delivered_AtInputs */
/** @typedef {{}} Push_Desktop_AppInputs */
/** @typedef {{}} Push_Desktop_BlockedInputs */
/** @typedef {{}} Push_Desktop_Open_SettingsInputs */
/** @typedef {{}} Push_Desktop_UnsignedInputs */
/** @typedef {{}} Push_DestinationsInputs */
/** @typedef {{}} Push_Hub_SealedInputs */
/** @typedef {{}} Push_Ios_Add_To_HomeInputs */
/** @typedef {{}} Push_Not_DeliveredInputs */
/** @typedef {{}} Push_Not_SentInputs */
/** @typedef {{}} Push_Other_DeviceInputs */
/** @typedef {{}} Push_ReceiveInputs */
/** @typedef {{}} Push_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Remove_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_RemovedInputs */
/** @typedef {{}} Push_Send_TestInputs */
/** @typedef {{}} Push_SentInputs */
/** @typedef {{}} Push_Subscribe_FailedInputs */
/** @typedef {{}} Push_Test_FailedInputs */
/** @typedef {{}} Push_This_DeviceInputs */
/** @typedef {{}} Push_UnavailableInputs */
/** @typedef {{}} Push_Unsubscribe_FailedInputs */
/** @typedef {{}} Push_UnsupportedInputs */
/** @typedef {{}} Sandboxes_Admin_AllowInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_By_EmailInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_By_Email_NoteInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_DevInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_FailedInputs */
/** @typedef {{}} Sandboxes_Admin_Col_AllowedInputs */
/** @typedef {{}} Sandboxes_Admin_Col_EmailInputs */
/** @typedef {{}} Sandboxes_Admin_Col_KindInputs */
/** @typedef {{}} Sandboxes_Admin_Col_StateInputs */
/** @typedef {{}} Sandboxes_Admin_DescriptionInputs */
/** @typedef {{}} Sandboxes_Admin_Email_LabelInputs */
/** @typedef {{}} Sandboxes_Admin_EmptyInputs */
/** @typedef {{}} Sandboxes_Admin_Kind_DevInputs */
/** @typedef {{}} Sandboxes_Admin_Kind_GeneralInputs */
/** @typedef {{ time: NonNullable<unknown> }} Sandboxes_Admin_Last_ActiveInputs */
/** @typedef {{}} Sandboxes_Admin_Memory_NoteInputs */
/** @typedef {{ used: NonNullable<unknown>, budget: NonNullable<unknown> }} Sandboxes_Admin_Memory_UsageInputs */
/** @typedef {{}} Sandboxes_Admin_Not_CreatedInputs */
/** @typedef {{}} Sandboxes_Admin_RevokeInputs */
/** @typedef {{ label: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Confirm_DevInputs */
/** @typedef {{ label: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Confirm_GeneralInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Failed_DevInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Failed_GeneralInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Label_DevInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Label_GeneralInputs */
/** @typedef {{ state: NonNullable<unknown> }} Sandboxes_Admin_Revoking_StateInputs */
/** @typedef {{}} Sandboxes_Admin_TitleInputs */
/** @typedef {{}} Sandboxes_Error_CollisionInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_Delete_TimeoutInputs */
/** @typedef {{}} Sandboxes_Error_K8sInputs */
/** @typedef {{}} Sandboxes_Error_No_Dev_ImageInputs */
/** @typedef {{ code: NonNullable<unknown> }} Sandboxes_Error_OtherInputs */
/** @typedef {{}} Sandboxes_Error_Profile_MismatchInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_Start_TimeoutInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_Stop_TimeoutInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_UnreachableInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_AsleepInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_DeletingInputs */
/** @typedef {{ name: NonNullable<unknown>, error: NonNullable<unknown> }} Sandboxes_Line_ErrorInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_PreparingInputs */
/** @typedef {{ name: NonNullable<unknown>, n: NonNullable<unknown> }} Sandboxes_Line_QueuedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_WakingInputs */
/** @typedef {{}} Sandboxes_Menu_PreviewsInputs */
/** @typedef {{}} Sandboxes_Name_DevInputs */
/** @typedef {{}} Sandboxes_Name_GeneralInputs */
/** @typedef {{}} Sandboxes_Preview_ForbiddenInputs */
/** @typedef {{}} Sandboxes_Preview_Open_FailedInputs */
/** @typedef {{}} Sandboxes_Preview_OpeningInputs */
/** @typedef {{}} Sandboxes_Previews_DescriptionInputs */
/** @typedef {{}} Sandboxes_Previews_EmptyInputs */
/** @typedef {{ time: NonNullable<unknown> }} Sandboxes_Previews_Last_SeenInputs */
/** @typedef {{}} Sandboxes_Previews_None_RunningInputs */
/** @typedef {{}} Sandboxes_Previews_Status_ConflictInputs */
/** @typedef {{}} Sandboxes_Previews_Status_FailedInputs */
/** @typedef {{}} Sandboxes_Previews_Status_MissingInputs */
/** @typedef {{}} Sandboxes_Previews_Status_RunningInputs */
/** @typedef {{}} Sandboxes_Previews_StopInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Previews_Stop_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Previews_Stop_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Previews_Stop_OfflineInputs */
/** @typedef {{}} Sandboxes_Previews_StoppingInputs */
/** @typedef {{}} Sandboxes_Previews_TitleInputs */
/** @typedef {{}} Sandboxes_Status_AsleepInputs */
/** @typedef {{}} Sandboxes_Status_DeletingInputs */
/** @typedef {{}} Sandboxes_Status_ErrorInputs */
/** @typedef {{}} Sandboxes_Status_PreparingInputs */
/** @typedef {{}} Sandboxes_Status_QueuedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Sandboxes_Status_Queued_AtInputs */
/** @typedef {{}} Sandboxes_Status_RunningInputs */
/** @typedef {{}} Sandboxes_Status_WakingInputs */
/** @typedef {{}} Vc_CallsInputs */
/** @typedef {{}} Vc_CancelInputs */
/** @typedef {{}} Vc_Close_DisabledInputs */
/** @typedef {{}} Vc_Close_EndedInputs */
/** @typedef {{}} Vc_Close_FullInputs */
/** @typedef {{}} Vc_Close_Not_FoundInputs */
/** @typedef {{}} Vc_Close_ReplacedInputs */
/** @typedef {{}} Vc_Closed_RejoinInputs */
/** @typedef {{}} Vc_Conn_ClosedInputs */
/** @typedef {{}} Vc_Conn_ConnectedInputs */
/** @typedef {{}} Vc_Conn_ConnectingInputs */
/** @typedef {{}} Vc_Conn_FailedInputs */
/** @typedef {{}} Vc_Conn_UnstableInputs */
/** @typedef {{}} Vc_Denoise_LoadingInputs */
/** @typedef {{}} Vc_Denoise_OffInputs */
/** @typedef {{}} Vc_Denoise_OnInputs */
/** @typedef {{}} Vc_Denoise_UnavailableInputs */
/** @typedef {{ elapsed: NonNullable<unknown> }} Vc_ElapsedInputs */
/** @typedef {{}} Vc_EmptyInputs */
/** @typedef {{}} Vc_EndInputs */
/** @typedef {{}} Vc_End_FailedInputs */
/** @typedef {{}} Vc_Ended_MarkInputs */
/** @typedef {{ when: NonNullable<unknown>, duration: NonNullable<unknown>, people: NonNullable<unknown> }} Vc_Ended_SubInputs */
/** @typedef {{}} Vc_FilterInputs */
/** @typedef {{}} Vc_Filter_AllInputs */
/** @typedef {{}} Vc_Filter_EndedInputs */
/** @typedef {{}} Vc_Filter_LiveInputs */
/** @typedef {{}} Vc_JoinInputs */
/** @typedef {{}} Vc_Join_Prepare_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Vc_Joined_AriaInputs */
/** @typedef {{}} Vc_LeaveInputs */
/** @typedef {{}} Vc_Live_MarkInputs */
/** @typedef {{}} Vc_Load_FailedInputs */
/** @typedef {{}} Vc_Mic_DeniedInputs */
/** @typedef {{ min: NonNullable<unknown> }} Vc_MinutesInputs */
/** @typedef {{}} Vc_MuteInputs */
/** @typedef {{}} Vc_MutedInputs */
/** @typedef {{}} Vc_NarrowInputs */
/** @typedef {{}} Vc_Narrow_TitleInputs */
/** @typedef {{}} Vc_New_CallInputs */
/** @typedef {{}} Vc_New_NoteInputs */
/** @typedef {{}} Vc_No_SpaceInputs */
/** @typedef {{}} Vc_NobodyInputs */
/** @typedef {{}} Vc_None_MatchInputs */
/** @typedef {{}} Vc_Not_FoundInputs */
/** @typedef {{}} Vc_Note_EndedInputs */
/** @typedef {{}} Vc_Note_LiveInputs */
/** @typedef {{}} Vc_Own_ScreenInputs */
/** @typedef {{ count: NonNullable<unknown> }} Vc_PeopleInputs */
/** @typedef {{}} Vc_Play_AudioInputs */
/** @typedef {{}} Vc_ReconnectingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Vc_Screen_OfInputs */
/** @typedef {{}} Vc_Self_SuffixInputs */
/** @typedef {{}} Vc_Share_ScreenInputs */
/** @typedef {{}} Vc_SharingInputs */
/** @typedef {{}} Vc_Space_LabelInputs */
/** @typedef {{}} Vc_StartInputs */
/** @typedef {{}} Vc_Start_FailedInputs */
/** @typedef {{}} Vc_Stop_SharingInputs */
/** @typedef {{}} Vc_Title_AriaInputs */
/** @typedef {{}} Vc_Title_LabelInputs */
/** @typedef {{}} Vc_Title_PlaceholderInputs */
/** @typedef {{}} Vc_To_ListInputs */
/** @typedef {{}} Vc_Unknown_MemberInputs */
/** @typedef {{}} Vc_UnmuteInputs */
/** @typedef {{}} Vc_Waiting_VideoInputs */
/** @typedef {{}} Wd_Col_SpaceInputs */
/** @typedef {{}} Wd_DatasetsInputs */
/** @typedef {{}} Wd_Datasets_BackInputs */
/** @typedef {{}} Wd_Datasets_CreateInputs */
/** @typedef {{}} Wd_Datasets_Create_FailedInputs */
/** @typedef {{}} Wd_Datasets_EmptyInputs */
/** @typedef {{}} Wd_Datasets_Load_FailedInputs */
/** @typedef {{}} Wd_Datasets_NewInputs */
/** @typedef {{}} Wd_Datasets_New_NoteInputs */
/** @typedef {{}} Wd_Datasets_None_MatchInputs */
/** @typedef {{ count: NonNullable<unknown> }} Wd_Datasets_RowsInputs */
/** @typedef {{}} Wd_Datasets_SpaceInputs */
/** @typedef {{}} Wd_Datasets_Space_EmptyInputs */
/** @typedef {{}} Wd_Datasets_TitleInputs */
/** @typedef {{}} Wd_EmptyInputs */
/** @typedef {{}} Wd_Load_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Move_FailedInputs */
/** @typedef {{}} Wd_Move_HintInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Move_TitleInputs */
/** @typedef {{}} Wd_NavInputs */
/** @typedef {{}} Wd_New_InInputs */
/** @typedef {{}} Wd_No_SpaceInputs */
/** @typedef {{}} Wd_None_MatchInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Pin_FailedInputs */
/** @typedef {{}} Wd_ReleaseInputs */
/** @typedef {{}} Wd_Release_ActionInputs */
/** @typedef {{}} Wd_Release_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Release_FailedInputs */
/** @typedef {{}} Wd_Release_No_SpaceInputs */
/** @typedef {{}} Wd_Release_NoneInputs */
/** @typedef {{}} Wd_Release_SpaceInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Release_TitleInputs */
/** @typedef {{}} Wd_Release_WorkspaceInputs */
/** @typedef {{ title: NonNullable<unknown>, workspace: NonNullable<unknown> }} Wd_ReleasedInputs */
/** @typedef {{}} Wd_Space_EmptyInputs */
/** @typedef {{}} Web_Admin_DescriptionInputs */
/** @typedef {{}} Web_Admin_TitleInputs */
/** @typedef {{}} Web_Admin_Waitlist_ApproveInputs */
/** @typedef {{}} Web_Admin_Waitlist_Approve_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Web_Admin_Waitlist_Approved_DoneInputs */
/** @typedef {{}} Web_Admin_Waitlist_ClearInputs */
/** @typedef {{}} Web_Admin_Waitlist_Col_EmailInputs */
/** @typedef {{}} Web_Admin_Waitlist_Col_JoinedInputs */
/** @typedef {{}} Web_Admin_Waitlist_Col_ViaInputs */
/** @typedef {{}} Web_Admin_Waitlist_Confirm_ApproveInputs */
/** @typedef {{ count: NonNullable<unknown> }} Web_Admin_Waitlist_Confirm_TextInputs */
/** @typedef {{}} Web_Admin_Waitlist_DescriptionInputs */
/** @typedef {{}} Web_Admin_Waitlist_EmptyInputs */
/** @typedef {{}} Web_Admin_Waitlist_Select_AllInputs */
/** @typedef {{ count: NonNullable<unknown> }} Web_Admin_Waitlist_SelectedInputs */
/** @typedef {{}} Web_Admin_Waitlist_TitleInputs */
/** @typedef {{}} Web_Admin_Waitlist_ToolbarInputs */
/** @typedef {{}} Web_Admin_Waitlist_Via_EmailInputs */
/** @typedef {{}} Web_App_Update_LoadInputs */
/** @typedef {{}} Web_BannedInputs */
/** @typedef {{}} Web_Captcha_FailedInputs */
/** @typedef {{}} Web_Home_IconInputs */
/** @typedef {{}} Web_Home_Icon_BlackInputs */
/** @typedef {{}} Web_Home_Icon_GreenInputs */
/** @typedef {{}} Web_Home_Icon_Ground_BlackInputs */
/** @typedef {{}} Web_Home_Icon_Ground_WhiteInputs */
/** @typedef {{}} Web_Home_Icon_InkInputs */
/** @typedef {{}} Web_Home_Icon_NoteInputs */
/** @typedef {{}} Web_Home_Icon_PurpleInputs */
/** @typedef {{}} Web_Home_Icon_StandardInputs */
/** @typedef {{}} Web_Home_Icon_VermilionInputs */
/** @typedef {{}} Web_Home_Icon_WhiteInputs */
/** @typedef {{}} Web_Hub_AllowInputs */
/** @typedef {{}} Web_Hub_Code_LabelInputs */
/** @typedef {{}} Web_Hub_Code_NextInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Hub_ConnectingInputs */
/** @typedef {{}} Web_Hub_DeniedInputs */
/** @typedef {{}} Web_Hub_DenyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Hub_Desktop_ConnectingInputs */
/** @typedef {{}} Web_Hub_Desktop_DeniedInputs */
/** @typedef {{}} Web_Hub_Desktop_DoneInputs */
/** @typedef {{}} Web_Hub_Desktop_WhatInputs */
/** @typedef {{}} Web_Hub_DoneInputs */
/** @typedef {{}} Web_Hub_FailedInputs */
/** @typedef {{}} Web_Hub_Not_FoundInputs */
/** @typedef {{}} Web_Hub_Pair_PcInputs */
/** @typedef {{}} Web_Hub_Pair_PhoneInputs */
/** @typedef {{}} Web_Hub_Pair_TitleInputs */
/** @typedef {{ time: NonNullable<unknown> }} Web_Hub_Started_AtInputs */
/** @typedef {{ place: NonNullable<unknown> }} Web_Hub_Started_FromInputs */
/** @typedef {{}} Web_Hub_TitleInputs */
/** @typedef {{}} Web_Hub_Type_CodeInputs */
/** @typedef {{}} Web_Hub_WarningInputs */
/** @typedef {{}} Web_Hub_WhatInputs */
/** @typedef {{}} Web_Load_FailedInputs */
/** @typedef {{}} Web_Mail_FailedInputs */
/** @typedef {{}} Web_Me_Moving_BodyInputs */
/** @typedef {{}} Web_Me_Moving_Open_HereInputs */
/** @typedef {{}} Web_Me_Moving_TitleInputs */
/** @typedef {{ hub: NonNullable<unknown> }} Web_Me_On_Hub_BodyInputs */
/** @typedef {{}} Web_Me_On_Hub_Body_UnnamedInputs */
/** @typedef {{}} Web_Me_On_Hub_TitleInputs */
/** @typedef {{}} Web_Me_Opening_HereInputs */
/** @typedef {{}} Web_Menu_AdminInputs */
/** @typedef {{}} Web_Menu_Sign_OutInputs */
/** @typedef {{}} Web_Oauth_AllowInputs */
/** @typedef {{}} Web_Oauth_Can_DoInputs */
/** @typedef {{ client: NonNullable<unknown> }} Web_Oauth_ConnectingInputs */
/** @typedef {{}} Web_Oauth_DenyInputs */
/** @typedef {{}} Web_Oauth_Desktop_WarningInputs */
/** @typedef {{ where: NonNullable<unknown> }} Web_Oauth_DestinationInputs */
/** @typedef {{}} Web_Oauth_FailedInputs */
/** @typedef {{}} Web_Oauth_Outside_FlowInputs */
/** @typedef {{}} Web_Oauth_Scope_DesktopInputs */
/** @typedef {{}} Web_Oauth_Scope_OfflineInputs */
/** @typedef {{}} Web_Oauth_Scope_ReadInputs */
/** @typedef {{}} Web_Oauth_Scope_WriteInputs */
/** @typedef {{ where: NonNullable<unknown> }} Web_Oauth_This_DeviceInputs */
/** @typedef {{}} Web_Oauth_TitleInputs */
/** @typedef {{}} Web_Oauth_UnverifiedInputs */
/** @typedef {{}} Web_Otp_ExpiredInputs */
/** @typedef {{}} Web_Otp_InvalidInputs */
/** @typedef {{}} Web_Otp_Too_ManyInputs */
/** @typedef {{}} Web_Passkey_FailedInputs */
/** @typedef {{}} Web_Passkey_LaterInputs */
/** @typedef {{}} Web_Passkey_Later_NoteInputs */
/** @typedef {{}} Web_Passkey_LeadInputs */
/** @typedef {{}} Web_Passkey_NoneInputs */
/** @typedef {{}} Web_Passkey_RegisterInputs */
/** @typedef {{}} Web_Passkey_Register_FailedInputs */
/** @typedef {{}} Web_Passkey_TitleInputs */
/** @typedef {{}} Web_Rate_LimitedInputs */
/** @typedef {{}} Web_Resend_Too_SoonInputs */
/** @typedef {{}} Web_RetryInputs */
/** @typedef {{}} Web_Settings_AppsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Allow_WorkspaceInputs */
/** @typedef {{ scopes: NonNullable<unknown>, granted: NonNullable<unknown> }} Web_Settings_Apps_App_DescriptionInputs */
/** @typedef {{}} Web_Settings_Apps_CopiedInputs */
/** @typedef {{}} Web_Settings_Apps_CopyInputs */
/** @typedef {{}} Web_Settings_Apps_DescriptionInputs */
/** @typedef {{}} Web_Settings_Apps_DisconnectInputs */
/** @typedef {{}} Web_Settings_Apps_Disconnect_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Disconnect_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Disconnect_TitleInputs */
/** @typedef {{}} Web_Settings_Apps_EmptyInputs */
/** @typedef {{}} Web_Settings_Apps_ListInputs */
/** @typedef {{}} Web_Settings_Apps_No_WorkspacesInputs */
/** @typedef {{}} Web_Settings_Apps_Not_AllowedInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_DesktopInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_OfflineInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_ReadInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_WriteInputs */
/** @typedef {{}} Web_Settings_Apps_UrlInputs */
/** @typedef {{}} Web_Settings_Apps_Url_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Workspace_FailedInputs */
/** @typedef {{}} Web_Settings_Apps_WorkspacesInputs */
/** @typedef {{}} Web_Settings_Apps_Workspaces_NoteInputs */
/** @typedef {{}} Web_Settings_DescriptionInputs */
/** @typedef {{}} Web_Settings_SecurityInputs */
/** @typedef {{}} Web_Settings_Security_AddInputs */
/** @typedef {{}} Web_Settings_Security_Add_FailedInputs */
/** @typedef {{}} Web_Settings_Security_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Security_Delete_FailedInputs */
/** @typedef {{}} Web_Settings_Security_Delete_Last_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Security_Delete_NamedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Security_Delete_TitleInputs */
/** @typedef {{}} Web_Settings_Security_DescriptionInputs */
/** @typedef {{}} Web_Settings_Security_EmailInputs */
/** @typedef {{}} Web_Settings_Security_Email_NoteInputs */
/** @typedef {{}} Web_Settings_Security_GoogleInputs */
/** @typedef {{}} Web_Settings_Security_Google_LinkInputs */
/** @typedef {{}} Web_Settings_Security_Google_Link_FailedInputs */
/** @typedef {{}} Web_Settings_Security_Google_LinkedInputs */
/** @typedef {{}} Web_Settings_Security_Google_Not_ConfiguredInputs */
/** @typedef {{}} Web_Settings_Security_Google_NoteInputs */
/** @typedef {{}} Web_Settings_Security_PasskeysInputs */
/** @typedef {{}} Web_Settings_Security_Passkeys_NoteInputs */
/** @typedef {{ date: NonNullable<unknown> }} Web_Settings_Security_Registered_OnInputs */
/** @typedef {{}} Web_Settings_Security_UnnamedInputs */
/** @typedef {{}} Web_Settings_TitleInputs */
/** @typedef {{}} Web_Signin_Code_LabelInputs */
/** @typedef {{ email: NonNullable<unknown>, minutes: NonNullable<unknown> }} Web_Signin_Code_ReusedInputs */
/** @typedef {{ email: NonNullable<unknown>, minutes: NonNullable<unknown> }} Web_Signin_Code_SentInputs */
/** @typedef {{}} Web_Signin_ContinueInputs */
/** @typedef {{}} Web_Signin_Email_HintInputs */
/** @typedef {{}} Web_Signin_Email_InvalidInputs */
/** @typedef {{}} Web_Signin_Email_LabelInputs */
/** @typedef {{}} Web_Signin_FailedInputs */
/** @typedef {{}} Web_Signin_GoogleInputs */
/** @typedef {{}} Web_Signin_Google_FailedInputs */
/** @typedef {{}} Web_Signin_In_App_BodyInputs */
/** @typedef {{}} Web_Signin_In_App_TitleInputs */
/** @typedef {{}} Web_Signin_Other_EmailInputs */
/** @typedef {{}} Web_Signin_PasskeyInputs */
/** @typedef {{}} Web_Signin_ResendInputs */
/** @typedef {{}} Web_Signin_ResentInputs */
/** @typedef {{}} Web_Signin_RetryInputs */
/** @typedef {{}} Web_Signin_TitleInputs */
/** @typedef {{}} Web_Trust_Approve_PcInputs */
/** @typedef {{}} Web_Trust_Approve_PhoneInputs */
/** @typedef {{}} Web_Trust_Approve_TitleInputs */
/** @typedef {{ email: NonNullable<unknown> }} Web_Waitlist_BodyInputs */
/** @typedef {{}} Web_Waitlist_SwitchInputs */
/** @typedef {{}} Web_Waitlist_TitleInputs */
/** @typedef {{}} Workspace_Default_Role_AdminInputs */
/** @typedef {{}} Workspace_Default_Space_NameInputs */
/** @typedef {{}} Workspace_Unnamed_MemberInputs */
/** @typedef {{}} Ws_CancelInputs */
/** @typedef {{}} Ws_Case_PanelInputs */
/** @typedef {{}} Ws_DeleteInputs */
/** @typedef {{}} Ws_Dock_SpacesInputs */
/** @typedef {{}} Ws_Feature_BroadcastInputs */
/** @typedef {{}} Ws_Feature_Broadcast_NoteInputs */
/** @typedef {{}} Ws_Feature_CycleInputs */
/** @typedef {{}} Ws_Feature_Cycle_NoteInputs */
/** @typedef {{}} Ws_Feature_DmInputs */
/** @typedef {{}} Ws_Feature_Dm_NoteInputs */
/** @typedef {{}} Ws_Feature_DocumentInputs */
/** @typedef {{}} Ws_Feature_Document_NoteInputs */
/** @typedef {{}} Ws_Feature_IssueInputs */
/** @typedef {{}} Ws_Feature_Issue_NoteInputs */
/** @typedef {{}} Ws_Feature_JournalInputs */
/** @typedef {{}} Ws_Feature_Journal_NoteInputs */
/** @typedef {{}} Ws_Feature_ProjectInputs */
/** @typedef {{}} Ws_Feature_Project_NoteInputs */
/** @typedef {{ feature: NonNullable<unknown> }} Ws_Feature_RequiresInputs */
/** @typedef {{}} Ws_Feature_TopicInputs */
/** @typedef {{}} Ws_Feature_Topic_NoteInputs */
/** @typedef {{}} Ws_Feature_VoiceInputs */
/** @typedef {{}} Ws_Feature_Voice_NoteInputs */
/** @typedef {{}} Ws_Features_EnabledInputs */
/** @typedef {{}} Ws_Features_McpInputs */
/** @typedef {{}} Ws_Features_Mcp_NoteInputs */
/** @typedef {{}} Ws_Features_OutsideInputs */
/** @typedef {{}} Ws_Features_PublishInputs */
/** @typedef {{}} Ws_Features_Publish_NoteInputs */
/** @typedef {{}} Ws_Features_Publish_OffInputs */
/** @typedef {{}} Ws_Features_Publish_Off_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Features_Publish_Off_TitleInputs */
/** @typedef {{}} Ws_General_IconInputs */
/** @typedef {{}} Ws_General_Icon_NoteInputs */
/** @typedef {{}} Ws_General_NameInputs */
/** @typedef {{}} Ws_General_UrlInputs */
/** @typedef {{}} Ws_General_Url_ChangeInputs */
/** @typedef {{}} Ws_General_Url_EditInputs */
/** @typedef {{}} Ws_General_Url_Edit_TitleInputs */
/** @typedef {{}} Ws_General_Url_NoteInputs */
/** @typedef {{}} Ws_Home_EmptyInputs */
/** @typedef {{}} Ws_Invite_FailedInputs */
/** @typedef {{ kind: NonNullable<unknown> }} Ws_Invite_Guest_NoteInputs */
/** @typedef {{}} Ws_Invite_JoinInputs */
/** @typedef {{}} Ws_Invite_LoadingInputs */
/** @typedef {{}} Ws_Invite_Not_FoundInputs */
/** @typedef {{}} Ws_Invite_Sign_InInputs */
/** @typedef {{}} Ws_Invite_TitleInputs */
/** @typedef {{ workspace: NonNullable<unknown> }} Ws_Invite_ToInputs */
/** @typedef {{ workspace: NonNullable<unknown> }} Ws_Invite_UnusableInputs */
/** @typedef {{}} Ws_Invites_ActiveInputs */
/** @typedef {{}} Ws_Invites_AllInputs */
/** @typedef {{}} Ws_Invites_CopiedInputs */
/** @typedef {{}} Ws_Invites_CopyInputs */
/** @typedef {{}} Ws_Invites_Copy_FailedInputs */
/** @typedef {{}} Ws_Invites_CreateInputs */
/** @typedef {{}} Ws_Invites_Create_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Invites_DaysInputs */
/** @typedef {{}} Ws_Invites_EmptyInputs */
/** @typedef {{}} Ws_Invites_ExpiredInputs */
/** @typedef {{}} Ws_Invites_ExpiresInputs */
/** @typedef {{}} Ws_Invites_FilterInputs */
/** @typedef {{}} Ws_Invites_Guest_NoteInputs */
/** @typedef {{}} Ws_Invites_Joins_AsInputs */
/** @typedef {{}} Ws_Invites_KindInputs */
/** @typedef {{}} Ws_Invites_LinkInputs */
/** @typedef {{}} Ws_Invites_ListInputs */
/** @typedef {{}} Ws_Invites_Max_UsesInputs */
/** @typedef {{}} Ws_Invites_Member_NoteInputs */
/** @typedef {{}} Ws_Invites_NeverInputs */
/** @typedef {{}} Ws_Invites_NewInputs */
/** @typedef {{}} Ws_Invites_No_ActiveInputs */
/** @typedef {{}} Ws_Invites_Not_FoundInputs */
/** @typedef {{}} Ws_Invites_RevokeInputs */
/** @typedef {{}} Ws_Invites_Revoke_FailedInputs */
/** @typedef {{}} Ws_Invites_Revoke_NoteInputs */
/** @typedef {{}} Ws_Invites_RevokedInputs */
/** @typedef {{}} Ws_Invites_RoleInputs */
/** @typedef {{}} Ws_Invites_Role_NoteInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Invites_TimesInputs */
/** @typedef {{}} Ws_Invites_UnlimitedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Ws_Invites_UntilInputs */
/** @typedef {{}} Ws_Invites_UrlInputs */
/** @typedef {{}} Ws_Invites_Url_HiddenInputs */
/** @typedef {{}} Ws_Invites_Url_NoteInputs */
/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Ws_Invites_UsageInputs */
/** @typedef {{ used: NonNullable<unknown> }} Ws_Invites_Usage_UnlimitedInputs */
/** @typedef {{}} Ws_Invites_Used_UpInputs */
/** @typedef {{}} Ws_Invites_UsesInputs */
/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Ws_Invites_Uses_OfInputs */
/** @typedef {{ used: NonNullable<unknown> }} Ws_Invites_Uses_UnlimitedInputs */
/** @typedef {{}} Ws_Invites_ValidInputs */
/** @typedef {{}} Ws_Kind_GuestInputs */
/** @typedef {{}} Ws_Kind_MemberInputs */
/** @typedef {{}} Ws_List_NarrowInputs */
/** @typedef {{}} Ws_List_Narrow_NameInputs */
/** @typedef {{}} Ws_List_No_MatchInputs */
/** @typedef {{}} Ws_Load_FailedInputs */
/** @typedef {{}} Ws_Members_AllInputs */
/** @typedef {{}} Ws_Members_BulkInputs */
/** @typedef {{}} Ws_Members_Bulk_ClearInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Members_Bulk_Remove_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Members_Bulk_Remove_TitleInputs */
/** @typedef {{}} Ws_Members_Col_JoinedInputs */
/** @typedef {{}} Ws_Members_Col_KindInputs */
/** @typedef {{}} Ws_Members_Col_Last_ActiveInputs */
/** @typedef {{}} Ws_Members_Col_NameInputs */
/** @typedef {{}} Ws_Members_Col_RegisteredInputs */
/** @typedef {{}} Ws_Members_Col_RolesInputs */
/** @typedef {{}} Ws_Members_EmptyInputs */
/** @typedef {{}} Ws_Members_FilterInputs */
/** @typedef {{}} Ws_Members_Guest_No_RolesInputs */
/** @typedef {{ date: NonNullable<unknown> }} Ws_Members_JoinedInputs */
/** @typedef {{}} Ws_Members_KindInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Kind_FailedInputs */
/** @typedef {{}} Ws_Members_ListInputs */
/** @typedef {{}} Ws_Members_Make_GuestInputs */
/** @typedef {{}} Ws_Members_Make_MemberInputs */
/** @typedef {{}} Ws_Members_No_MatchInputs */
/** @typedef {{}} Ws_Members_No_RolesInputs */
/** @typedef {{}} Ws_Members_Not_FoundInputs */
/** @typedef {{}} Ws_Members_OwnerInputs */
/** @typedef {{ date: NonNullable<unknown> }} Ws_Members_Owner_NoteInputs */
/** @typedef {{}} Ws_Members_RemoveInputs */
/** @typedef {{}} Ws_Members_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Remove_FailedInputs */
/** @typedef {{}} Ws_Members_Remove_LabelInputs */
/** @typedef {{}} Ws_Members_Remove_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Remove_TitleInputs */
/** @typedef {{}} Ws_Members_RolesInputs */
/** @typedef {{}} Ws_Members_Roles_AboveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Roles_FailedInputs */
/** @typedef {{}} Ws_Members_Roles_Not_AllowedInputs */
/** @typedef {{}} Ws_Members_SearchInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_SelectInputs */
/** @typedef {{}} Ws_Members_Select_AllInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Members_SelectedInputs */
/** @typedef {{}} Ws_Members_To_Guest_BodyInputs */
/** @typedef {{}} Ws_Members_To_Guest_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_To_Guest_TitleInputs */
/** @typedef {{}} Ws_Members_To_Member_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_MenuInputs */
/** @typedef {{}} Ws_Menu_InviteInputs */
/** @typedef {{}} Ws_Menu_NewInputs */
/** @typedef {{}} Ws_Menu_SettingsInputs */
/** @typedef {{}} Ws_Missing_BodyInputs */
/** @typedef {{}} Ws_Missing_TitleInputs */
/** @typedef {{}} Ws_My_CasesInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_My_Cases_ChipInputs */
/** @typedef {{}} Ws_New_CreateInputs */
/** @typedef {{}} Ws_New_DescriptionInputs */
/** @typedef {{}} Ws_New_FailedInputs */
/** @typedef {{}} Ws_New_TitleInputs */
/** @typedef {{}} Ws_Perm_Emoji_CreateInputs */
/** @typedef {{}} Ws_Perm_Emoji_ManageInputs */
/** @typedef {{}} Ws_Perm_Issue_ManageInputs */
/** @typedef {{}} Ws_Perm_Member_ManageInputs */
/** @typedef {{}} Ws_Perm_Message_WriteInputs */
/** @typedef {{}} Ws_Perm_Page_WriteInputs */
/** @typedef {{}} Ws_Perm_Role_ManageInputs */
/** @typedef {{}} Ws_Perm_Space_ManageInputs */
/** @typedef {{}} Ws_Perm_Workspace_InviteInputs */
/** @typedef {{}} Ws_Perm_Workspace_ManageInputs */
/** @typedef {{}} Ws_Profile_AvatarInputs */
/** @typedef {{}} Ws_Profile_Avatar_NoteInputs */
/** @typedef {{}} Ws_Profile_Avatar_ResetInputs */
/** @typedef {{}} Ws_Profile_NameInputs */
/** @typedef {{}} Ws_Profile_Name_NoteInputs */
/** @typedef {{}} Ws_RailInputs */
/** @typedef {{}} Ws_Rail_NewInputs */
/** @typedef {{}} Ws_Roles_Above_YouInputs */
/** @typedef {{}} Ws_Roles_CreateInputs */
/** @typedef {{}} Ws_Roles_Create_FailedInputs */
/** @typedef {{}} Ws_Roles_Default_NoteInputs */
/** @typedef {{}} Ws_Roles_Default_SubInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Roles_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Roles_Delete_FailedInputs */
/** @typedef {{}} Ws_Roles_Delete_LabelInputs */
/** @typedef {{}} Ws_Roles_Delete_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Roles_Delete_TitleInputs */
/** @typedef {{}} Ws_Roles_ListInputs */
/** @typedef {{}} Ws_Roles_NameInputs */
/** @typedef {{}} Ws_Roles_Name_ExampleInputs */
/** @typedef {{}} Ws_Roles_NewInputs */
/** @typedef {{}} Ws_Roles_Not_AllowedInputs */
/** @typedef {{}} Ws_Roles_Not_FoundInputs */
/** @typedef {{}} Ws_Roles_NoteInputs */
/** @typedef {{}} Ws_Roles_Only_YoursInputs */
/** @typedef {{}} Ws_Roles_PermissionsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Roles_Permissions_FailedInputs */
/** @typedef {{}} Ws_Roles_PositionInputs */
/** @typedef {{}} Ws_Roles_Position_NoteInputs */
/** @typedef {{ position: NonNullable<unknown> }} Ws_Roles_Position_SubInputs */
/** @typedef {{}} Ws_Save_FailedInputs */
/** @typedef {{}} Ws_Settings_AdminInputs */
/** @typedef {{}} Ws_Settings_BackInputs */
/** @typedef {{}} Ws_Settings_FeaturesInputs */
/** @typedef {{}} Ws_Settings_Features_DescriptionInputs */
/** @typedef {{}} Ws_Settings_GeneralInputs */
/** @typedef {{}} Ws_Settings_General_DescriptionInputs */
/** @typedef {{}} Ws_Settings_Index_DescriptionInputs */
/** @typedef {{}} Ws_Settings_InvitesInputs */
/** @typedef {{}} Ws_Settings_Invites_DescriptionInputs */
/** @typedef {{}} Ws_Settings_MembersInputs */
/** @typedef {{}} Ws_Settings_Members_DescriptionInputs */
/** @typedef {{}} Ws_Settings_Not_AllowedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Settings_OfInputs */
/** @typedef {{}} Ws_Settings_PersonalInputs */
/** @typedef {{}} Ws_Settings_ProfileInputs */
/** @typedef {{}} Ws_Settings_Profile_DescriptionInputs */
/** @typedef {{}} Ws_Settings_RolesInputs */
/** @typedef {{}} Ws_Settings_Roles_DescriptionInputs */
/** @typedef {{}} Ws_Settings_SpacesInputs */
/** @typedef {{}} Ws_Settings_Spaces_DescriptionInputs */
/** @typedef {{}} Ws_Settings_TitleInputs */
/** @typedef {{}} Ws_Slug_FormatInputs */
/** @typedef {{}} Ws_Slug_ReservedInputs */
/** @typedef {{}} Ws_Slug_TakenInputs */
/** @typedef {{}} Ws_Spaces_Add_ManagerInputs */
/** @typedef {{}} Ws_Spaces_Add_MemberInputs */
/** @typedef {{}} Ws_Spaces_Anyone_NoteInputs */
/** @typedef {{}} Ws_Spaces_ArchiveInputs */
/** @typedef {{}} Ws_Spaces_Archive_LabelInputs */
/** @typedef {{}} Ws_Spaces_Archive_NoteInputs */
/** @typedef {{}} Ws_Spaces_ArchivedInputs */
/** @typedef {{}} Ws_Spaces_Archived_NoteInputs */
/** @typedef {{}} Ws_Spaces_CreateInputs */
/** @typedef {{}} Ws_Spaces_Create_FailedInputs */
/** @typedef {{}} Ws_Spaces_Create_Not_AllowedInputs */
/** @typedef {{}} Ws_Spaces_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Delete_FailedInputs */
/** @typedef {{}} Ws_Spaces_Delete_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Delete_TitleInputs */
/** @typedef {{}} Ws_Spaces_DescriptionInputs */
/** @typedef {{}} Ws_Spaces_Description_PlaceholderInputs */
/** @typedef {{}} Ws_Spaces_FeaturesInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Features_FailedInputs */
/** @typedef {{}} Ws_Spaces_ListInputs */
/** @typedef {{}} Ws_Spaces_ManagersInputs */
/** @typedef {{}} Ws_Spaces_MembersInputs */
/** @typedef {{}} Ws_Spaces_Members_NoteInputs */
/** @typedef {{}} Ws_Spaces_NameInputs */
/** @typedef {{}} Ws_Spaces_NarrowInputs */
/** @typedef {{}} Ws_Spaces_Narrow_Members_BodyInputs */
/** @typedef {{}} Ws_Spaces_Narrow_Private_BodyInputs */
/** @typedef {{ name: NonNullable<unknown>, visibility: NonNullable<unknown> }} Ws_Spaces_Narrow_TitleInputs */
/** @typedef {{}} Ws_Spaces_NewInputs */
/** @typedef {{}} Ws_Spaces_No_ManagersInputs */
/** @typedef {{}} Ws_Spaces_No_MembersInputs */
/** @typedef {{}} Ws_Spaces_Not_AllowedInputs */
/** @typedef {{}} Ws_Spaces_Not_FoundInputs */
/** @typedef {{}} Ws_Spaces_Private_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Remove_PersonInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Remove_Person_FailedInputs */
/** @typedef {{}} Ws_Spaces_UnarchiveInputs */
/** @typedef {{}} Ws_Spaces_Unarchive_NoteInputs */
/** @typedef {{}} Ws_Spaces_VisibilityInputs */
/** @typedef {{}} Ws_Visibility_AnyoneInputs */
/** @typedef {{}} Ws_Visibility_MembersInputs */
/** @typedef {{}} Ws_Visibility_PrivateInputs */
import * as __ja from "./ja.js"
import * as __en from "./en.js"
/**
* | output |
* | --- |
* | "This account has been suspended. If you think this is a mistake, contact the operator." |
*
* @param {Auth_BannedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_banned = /** @type {((inputs?: Auth_BannedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_BannedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.auth_banned(inputs)
	return __ja.auth_banned(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't send the email" |
*
* @param {Auth_Mail_Send_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mail_send_failed = /** @type {((inputs?: Auth_Mail_Send_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mail_Send_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.auth_mail_send_failed(inputs)
	return __ja.auth_mail_send_failed(inputs)
});
/**
* | secondsPlural | output |
* | --- | --- |
* | "one" | "You can request a new code once every {seconds} second" |
* | "other" | "You can request a new code once every {seconds} seconds" |
*
* @param {Auth_Resend_Too_SoonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_resend_too_soon = /** @type {((inputs: Auth_Resend_Too_SoonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Resend_Too_SoonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.auth_resend_too_soon(inputs)
	return __ja.auth_resend_too_soon(inputs)
});
/**
* | output |
* | --- |
* | "As a broadcast" |
*
* @param {Cv_As_BroadcastInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_as_broadcast = /** @type {((inputs?: Cv_As_BroadcastInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_As_BroadcastInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_as_broadcast(inputs)
	return __ja.cv_as_broadcast(inputs)
});
/**
* | output |
* | --- |
* | "Broadcast" |
*
* @param {Cv_BroadcastInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_broadcast = /** @type {((inputs?: Cv_BroadcastInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_BroadcastInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_broadcast(inputs)
	return __ja.cv_broadcast(inputs)
});
/**
* | output |
* | --- |
* | "A broadcast reaches everyone who sees this space. It takes no replies." |
*
* @param {Cv_Broadcast_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_broadcast_hint = /** @type {((inputs?: Cv_Broadcast_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Broadcast_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_broadcast_hint(inputs)
	return __ja.cv_broadcast_hint(inputs)
});
/**
* | output |
* | --- |
* | "Broadcasts take no replies." |
*
* @param {Cv_Broadcast_No_ReplyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_broadcast_no_reply = /** @type {((inputs?: Cv_Broadcast_No_ReplyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Broadcast_No_ReplyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_broadcast_no_reply(inputs)
	return __ja.cv_broadcast_no_reply(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Cv_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_cancel = /** @type {((inputs?: Cv_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_cancel(inputs)
	return __ja.cv_cancel(inputs)
});
/**
* | output |
* | --- |
* | "You cannot write in this conversation." |
*
* @param {Cv_Cannot_PostInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_cannot_post = /** @type {((inputs?: Cv_Cannot_PostInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Cannot_PostInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_cannot_post(inputs)
	return __ja.cv_cannot_post(inputs)
});
/**
* | output |
* | --- |
* | "Last message" |
*
* @param {Cv_Col_Last_MessageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_col_last_message = /** @type {((inputs?: Cv_Col_Last_MessageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Col_Last_MessageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_col_last_message(inputs)
	return __ja.cv_col_last_message(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Cv_Col_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_col_name = /** @type {((inputs?: Cv_Col_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Col_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_col_name(inputs)
	return __ja.cv_col_name(inputs)
});
/**
* | output |
* | --- |
* | "Space" |
*
* @param {Cv_Col_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_col_space = /** @type {((inputs?: Cv_Col_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Col_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_col_space(inputs)
	return __ja.cv_col_space(inputs)
});
/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Cv_Col_UpdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_col_updated = /** @type {((inputs?: Cv_Col_UpdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Col_UpdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_col_updated(inputs)
	return __ja.cv_col_updated(inputs)
});
/**
* | output |
* | --- |
* | "No messages with {name} yet. The first one starts it." |
*
* @param {Cv_Dm_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dm_empty = /** @type {((inputs: Cv_Dm_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dm_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dm_empty(inputs)
	return __ja.cv_dm_empty(inputs)
});
/**
* | output |
* | --- |
* | "No messages with {names} yet. The first one starts it." |
*
* @param {Cv_Dm_Empty_GroupInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dm_empty_group = /** @type {((inputs: Cv_Dm_Empty_GroupInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dm_Empty_GroupInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dm_empty_group(inputs)
	return __ja.cv_dm_empty_group(inputs)
});
/**
* | output |
* | --- |
* | "This one is just for you. Keep notes and drafts here." |
*
* @param {Cv_Dm_Empty_SelfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dm_empty_self = /** @type {((inputs?: Cv_Dm_Empty_SelfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dm_Empty_SelfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dm_empty_self(inputs)
	return __ja.cv_dm_empty_self(inputs)
});
/**
* | output |
* | --- |
* | "No messages yet. The first one starts it." |
*
* @param {Cv_Dm_Empty_UnknownInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dm_empty_unknown = /** @type {((inputs?: Cv_Dm_Empty_UnknownInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dm_Empty_UnknownInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dm_empty_unknown(inputs)
	return __ja.cv_dm_empty_unknown(inputs)
});
/**
* | output |
* | --- |
* | "Last message {when}" |
*
* @param {Cv_Dm_LastInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dm_last = /** @type {((inputs: Cv_Dm_LastInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dm_LastInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dm_last(inputs)
	return __ja.cv_dm_last(inputs)
});
/**
* | output |
* | --- |
* | "{count} members" |
*
* @param {Cv_Dm_MembersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dm_members = /** @type {((inputs: Cv_Dm_MembersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dm_MembersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dm_members(inputs)
	return __ja.cv_dm_members(inputs)
});
/**
* | output |
* | --- |
* | "Direct message menu" |
*
* @param {Cv_Dm_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dm_menu = /** @type {((inputs?: Cv_Dm_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dm_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dm_menu(inputs)
	return __ja.cv_dm_menu(inputs)
});
/**
* | output |
* | --- |
* | "{name} (you)" |
*
* @param {Cv_Dm_Self_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dm_self_name = /** @type {((inputs: Cv_Dm_Self_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dm_Self_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dm_self_name(inputs)
	return __ja.cv_dm_self_name(inputs)
});
/**
* | output |
* | --- |
* | "DM" |
*
* @param {Cv_DmsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dms = /** @type {((inputs?: Cv_DmsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_DmsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dms(inputs)
	return __ja.cv_dms(inputs)
});
/**
* | output |
* | --- |
* | "No direct messages yet." |
*
* @param {Cv_Dms_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dms_empty = /** @type {((inputs?: Cv_Dms_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dms_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dms_empty(inputs)
	return __ja.cv_dms_empty(inputs)
});
/**
* | output |
* | --- |
* | "No direct message matches." |
*
* @param {Cv_Dms_None_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dms_none_match = /** @type {((inputs?: Cv_Dms_None_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dms_None_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dms_none_match(inputs)
	return __ja.cv_dms_none_match(inputs)
});
/**
* | output |
* | --- |
* | "No unread direct messages." |
*
* @param {Cv_Dms_None_UnreadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dms_none_unread = /** @type {((inputs?: Cv_Dms_None_UnreadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dms_None_UnreadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dms_none_unread(inputs)
	return __ja.cv_dms_none_unread(inputs)
});
/**
* | output |
* | --- |
* | "Start a DM" |
*
* @param {Cv_Dms_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_dms_start = /** @type {((inputs?: Cv_Dms_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Dms_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_dms_start(inputs)
	return __ja.cv_dms_start(inputs)
});
/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Cv_EditInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_edit = /** @type {((inputs?: Cv_EditInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_EditInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_edit(inputs)
	return __ja.cv_edit(inputs)
});
/**
* | output |
* | --- |
* | "Edit the message" |
*
* @param {Cv_Edit_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_edit_label = /** @type {((inputs?: Cv_Edit_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Edit_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_edit_label(inputs)
	return __ja.cv_edit_label(inputs)
});
/**
* | output |
* | --- |
* | "Add" |
*
* @param {Cv_Emoji_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_add = /** @type {((inputs?: Cv_Emoji_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_add(inputs)
	return __ja.cv_emoji_add(inputs)
});
/**
* | output |
* | --- |
* | "Add" |
*
* @param {Cv_Emoji_Add_SectionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_add_section = /** @type {((inputs?: Cv_Emoji_Add_SectionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Add_SectionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_add_section(inputs)
	return __ja.cv_emoji_add_section(inputs)
});
/**
* | output |
* | --- |
* | "You may not add emoji." |
*
* @param {Cv_Emoji_Cannot_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_cannot_add = /** @type {((inputs?: Cv_Emoji_Cannot_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Cannot_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_cannot_add(inputs)
	return __ja.cv_emoji_cannot_add(inputs)
});
/**
* | output |
* | --- |
* | "Choose" |
*
* @param {Cv_Emoji_ChooseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_choose = /** @type {((inputs?: Cv_Emoji_ChooseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_ChooseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_choose(inputs)
	return __ja.cv_emoji_choose(inputs)
});
/**
* | output |
* | --- |
* | "Choose an image" |
*
* @param {Cv_Emoji_Choose_ImageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_choose_image = /** @type {((inputs?: Cv_Emoji_Choose_ImageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Choose_ImageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_choose_image(inputs)
	return __ja.cv_emoji_choose_image(inputs)
});
/**
* | output |
* | --- |
* | "No emoji yet." |
*
* @param {Cv_Emoji_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_empty = /** @type {((inputs?: Cv_Emoji_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_empty(inputs)
	return __ja.cv_emoji_empty(inputs)
});
/**
* | output |
* | --- |
* | "Up to {max} emoji" |
*
* @param {Cv_Emoji_FullInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_full = /** @type {((inputs: Cv_Emoji_FullInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_FullInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_full(inputs)
	return __ja.cv_emoji_full(inputs)
});
/**
* | output |
* | --- |
* | "Image" |
*
* @param {Cv_Emoji_ImageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_image = /** @type {((inputs?: Cv_Emoji_ImageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_ImageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_image(inputs)
	return __ja.cv_emoji_image(inputs)
});
/**
* | output |
* | --- |
* | "A near square image (up to {kb}KB)" |
*
* @param {Cv_Emoji_Image_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_image_note = /** @type {((inputs: Cv_Emoji_Image_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Image_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_image_note(inputs)
	return __ja.cv_emoji_image_note(inputs)
});
/**
* | output |
* | --- |
* | "List" |
*
* @param {Cv_Emoji_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_list = /** @type {((inputs?: Cv_Emoji_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_list(inputs)
	return __ja.cv_emoji_list(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Cv_Emoji_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_name = /** @type {((inputs?: Cv_Emoji_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_name(inputs)
	return __ja.cv_emoji_name(inputs)
});
/**
* | output |
* | --- |
* | "Lowercase letters, digits, _ and -" |
*
* @param {Cv_Emoji_Name_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_name_note = /** @type {((inputs?: Cv_Emoji_Name_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Name_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_name_note(inputs)
	return __ja.cv_emoji_name_note(inputs)
});
/**
* | output |
* | --- |
* | "A name is up to 32 lowercase letters, digits, _ and -" |
*
* @param {Cv_Emoji_Name_RuleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_name_rule = /** @type {((inputs?: Cv_Emoji_Name_RuleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Name_RuleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_name_rule(inputs)
	return __ja.cv_emoji_name_rule(inputs)
});
/**
* | output |
* | --- |
* | "None chosen" |
*
* @param {Cv_Emoji_No_ImageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_no_image = /** @type {((inputs?: Cv_Emoji_No_ImageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_No_ImageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_no_image(inputs)
	return __ja.cv_emoji_no_image(inputs)
});
/**
* | output |
* | --- |
* | "Choose an image" |
*
* @param {Cv_Emoji_Pick_ImageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_pick_image = /** @type {((inputs?: Cv_Emoji_Pick_ImageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Pick_ImageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_pick_image(inputs)
	return __ja.cv_emoji_pick_image(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Cv_Emoji_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_remove = /** @type {((inputs?: Cv_Emoji_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_remove(inputs)
	return __ja.cv_emoji_remove(inputs)
});
/**
* | output |
* | --- |
* | ":{name}: in messages and reactions will show as text, not the image." |
*
* @param {Cv_Emoji_Remove_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_remove_body = /** @type {((inputs: Cv_Emoji_Remove_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Remove_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_remove_body(inputs)
	return __ja.cv_emoji_remove_body(inputs)
});
/**
* | output |
* | --- |
* | "Remove :{name}:" |
*
* @param {Cv_Emoji_Remove_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_remove_label = /** @type {((inputs: Cv_Emoji_Remove_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Remove_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_remove_label(inputs)
	return __ja.cv_emoji_remove_label(inputs)
});
/**
* | output |
* | --- |
* | "Remove :{name}:?" |
*
* @param {Cv_Emoji_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_remove_title = /** @type {((inputs: Cv_Emoji_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_remove_title(inputs)
	return __ja.cv_emoji_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Images are up to {kb}KB" |
*
* @param {Cv_Emoji_Too_LargeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_emoji_too_large = /** @type {((inputs: Cv_Emoji_Too_LargeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Emoji_Too_LargeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_emoji_too_large(inputs)
	return __ja.cv_emoji_too_large(inputs)
});
/**
* | output |
* | --- |
* | "Filter" |
*
* @param {Cv_FilterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_filter = /** @type {((inputs?: Cv_FilterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_FilterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_filter(inputs)
	return __ja.cv_filter(inputs)
});
/**
* | output |
* | --- |
* | "All" |
*
* @param {Cv_Filter_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_filter_all = /** @type {((inputs?: Cv_Filter_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Filter_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_filter_all(inputs)
	return __ja.cv_filter_all(inputs)
});
/**
* | output |
* | --- |
* | "Broadcasts" |
*
* @param {Cv_Filter_BroadcastsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_filter_broadcasts = /** @type {((inputs?: Cv_Filter_BroadcastsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Filter_BroadcastsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_filter_broadcasts(inputs)
	return __ja.cv_filter_broadcasts(inputs)
});
/**
* | output |
* | --- |
* | "Narrow to a space" |
*
* @param {Cv_Filter_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_filter_space = /** @type {((inputs?: Cv_Filter_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Filter_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_filter_space(inputs)
	return __ja.cv_filter_space(inputs)
});
/**
* | output |
* | --- |
* | "All spaces" |
*
* @param {Cv_Filter_Space_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_filter_space_all = /** @type {((inputs?: Cv_Filter_Space_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Filter_Space_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_filter_space_all(inputs)
	return __ja.cv_filter_space_all(inputs)
});
/**
* | output |
* | --- |
* | "Unread" |
*
* @param {Cv_Filter_UnreadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_filter_unread = /** @type {((inputs?: Cv_Filter_UnreadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Filter_UnreadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_filter_unread(inputs)
	return __ja.cv_filter_unread(inputs)
});
/**
* | output |
* | --- |
* | "Inbox" |
*
* @param {Cv_InboxInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_inbox = /** @type {((inputs?: Cv_InboxInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_InboxInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_inbox(inputs)
	return __ja.cv_inbox(inputs)
});
/**
* | output |
* | --- |
* | "You wrote here" |
*
* @param {Cv_Inbox_Reason_PostedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_inbox_reason_posted = /** @type {((inputs?: Cv_Inbox_Reason_PostedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Inbox_Reason_PostedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_inbox_reason_posted(inputs)
	return __ja.cv_inbox_reason_posted(inputs)
});
/**
* | output |
* | --- |
* | "Could not load" |
*
* @param {Cv_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_load_failed = /** @type {((inputs?: Cv_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_load_failed(inputs)
	return __ja.cv_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Cv_Loading_OlderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_loading_older = /** @type {((inputs?: Cv_Loading_OlderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Loading_OlderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_loading_older(inputs)
	return __ja.cv_loading_older(inputs)
});
/**
* | output |
* | --- |
* | "Mark as read" |
*
* @param {Cv_Mark_ReadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_mark_read = /** @type {((inputs?: Cv_Mark_ReadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Mark_ReadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_mark_read(inputs)
	return __ja.cv_mark_read(inputs)
});
/**
* | output |
* | --- |
* | "DM" |
*
* @param {Cv_Me_DmsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_me_dms = /** @type {((inputs?: Cv_Me_DmsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Me_DmsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_me_dms(inputs)
	return __ja.cv_me_dms(inputs)
});
/**
* | output |
* | --- |
* | "{count} members" |
*
* @param {Cv_Members_CountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_members_count = /** @type {((inputs: Cv_Members_CountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Members_CountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_members_count(inputs)
	return __ja.cv_members_count(inputs)
});
/**
* | output |
* | --- |
* | "and {count} more" |
*
* @param {Cv_Members_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_members_more = /** @type {((inputs: Cv_Members_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Members_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_members_more(inputs)
	return __ja.cv_members_more(inputs)
});
/**
* | output |
* | --- |
* | "Cannot see this space" |
*
* @param {Cv_Mention_Cannot_SeeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_mention_cannot_see = /** @type {((inputs?: Cv_Mention_Cannot_SeeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Mention_Cannot_SeeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_mention_cannot_see(inputs)
	return __ja.cv_mention_cannot_see(inputs)
});
/**
* | output |
* | --- |
* | "Message menu" |
*
* @param {Cv_Message_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_message_menu = /** @type {((inputs?: Cv_Message_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Message_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_message_menu(inputs)
	return __ja.cv_message_menu(inputs)
});
/**
* | output |
* | --- |
* | "Move to another space" |
*
* @param {Cv_MoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_move = /** @type {((inputs?: Cv_MoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_MoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_move(inputs)
	return __ja.cv_move(inputs)
});
/**
* | output |
* | --- |
* | "Move" |
*
* @param {Cv_Move_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_move_action = /** @type {((inputs?: Cv_Move_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Move_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_move_action(inputs)
	return __ja.cv_move_action(inputs)
});
/**
* | output |
* | --- |
* | "Narrow the list" |
*
* @param {Cv_NarrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_narrow = /** @type {((inputs?: Cv_NarrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_NarrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_narrow(inputs)
	return __ja.cv_narrow(inputs)
});
/**
* | output |
* | --- |
* | "Narrow by name" |
*
* @param {Cv_Narrow_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_narrow_name = /** @type {((inputs?: Cv_Narrow_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Narrow_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_narrow_name(inputs)
	return __ja.cv_narrow_name(inputs)
});
/**
* | output |
* | --- |
* | "Narrow by title" |
*
* @param {Cv_Narrow_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_narrow_title = /** @type {((inputs?: Cv_Narrow_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Narrow_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_narrow_title(inputs)
	return __ja.cv_narrow_title(inputs)
});
/**
* | output |
* | --- |
* | "New DM" |
*
* @param {Cv_New_DmInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_dm = /** @type {((inputs?: Cv_New_DmInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_DmInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_dm(inputs)
	return __ja.cv_new_dm(inputs)
});
/**
* | output |
* | --- |
* | "Chosen" |
*
* @param {Cv_New_Dm_ChosenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_dm_chosen = /** @type {((inputs?: Cv_New_Dm_ChosenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_Dm_ChosenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_dm_chosen(inputs)
	return __ja.cv_new_dm_chosen(inputs)
});
/**
* | output |
* | --- |
* | "Up to {max} people" |
*
* @param {Cv_New_Dm_LimitInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_dm_limit = /** @type {((inputs: Cv_New_Dm_LimitInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_Dm_LimitInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_dm_limit(inputs)
	return __ja.cv_new_dm_limit(inputs)
});
/**
* | output |
* | --- |
* | "Nobody found" |
*
* @param {Cv_New_Dm_NobodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_dm_nobody = /** @type {((inputs?: Cv_New_Dm_NobodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_Dm_NobodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_dm_nobody(inputs)
	return __ja.cv_new_dm_nobody(inputs)
});
/**
* | output |
* | --- |
* | "People" |
*
* @param {Cv_New_Dm_PeopleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_dm_people = /** @type {((inputs?: Cv_New_Dm_PeopleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_Dm_PeopleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_dm_people(inputs)
	return __ja.cv_new_dm_people(inputs)
});
/**
* | output |
* | --- |
* | "Find by name" |
*
* @param {Cv_New_Dm_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_dm_search = /** @type {((inputs?: Cv_New_Dm_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_Dm_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_dm_search(inputs)
	return __ja.cv_new_dm_search(inputs)
});
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Cv_New_Dm_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_dm_start = /** @type {((inputs?: Cv_New_Dm_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_Dm_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_dm_start(inputs)
	return __ja.cv_new_dm_start(inputs)
});
/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Cv_New_Dm_UnpickInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_dm_unpick = /** @type {((inputs: Cv_New_Dm_UnpickInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_Dm_UnpickInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_dm_unpick(inputs)
	return __ja.cv_new_dm_unpick(inputs)
});
/**
* | output |
* | --- |
* | "New topic" |
*
* @param {Cv_New_TopicInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_topic = /** @type {((inputs?: Cv_New_TopicInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_TopicInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_topic(inputs)
	return __ja.cv_new_topic(inputs)
});
/**
* | output |
* | --- |
* | "A name is optional. Without one, the list shows the first message." |
*
* @param {Cv_New_Topic_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_topic_hint = /** @type {((inputs?: Cv_New_Topic_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_Topic_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_topic_hint(inputs)
	return __ja.cv_new_topic_hint(inputs)
});
/**
* | output |
* | --- |
* | "Space" |
*
* @param {Cv_New_Topic_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_new_topic_in = /** @type {((inputs?: Cv_New_Topic_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_New_Topic_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_new_topic_in(inputs)
	return __ja.cv_new_topic_in(inputs)
});
/**
* | output |
* | --- |
* | "No description." |
*
* @param {Cv_No_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_no_description = /** @type {((inputs?: Cv_No_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_No_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_no_description(inputs)
	return __ja.cv_no_description(inputs)
});
/**
* | output |
* | --- |
* | "No space takes topics." |
*
* @param {Cv_No_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_no_space = /** @type {((inputs?: Cv_No_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_No_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_no_space(inputs)
	return __ja.cv_no_space(inputs)
});
/**
* | output |
* | --- |
* | "This conversation is not there or cannot be seen." |
*
* @param {Cv_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_not_found = /** @type {((inputs?: Cv_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_not_found(inputs)
	return __ja.cv_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Pin to this space" |
*
* @param {Cv_PinInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_pin = /** @type {((inputs?: Cv_PinInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_PinInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_pin(inputs)
	return __ja.cv_pin(inputs)
});
/**
* | output |
* | --- |
* | "Down" |
*
* @param {Cv_Pin_DownInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_pin_down = /** @type {((inputs?: Cv_Pin_DownInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Pin_DownInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_pin_down(inputs)
	return __ja.cv_pin_down(inputs)
});
/**
* | output |
* | --- |
* | "Move {name} down" |
*
* @param {Cv_Pin_Down_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_pin_down_label = /** @type {((inputs: Cv_Pin_Down_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Pin_Down_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_pin_down_label(inputs)
	return __ja.cv_pin_down_label(inputs)
});
/**
* | output |
* | --- |
* | "Not visible" |
*
* @param {Cv_Pin_GoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_pin_gone = /** @type {((inputs?: Cv_Pin_GoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Pin_GoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_pin_gone(inputs)
	return __ja.cv_pin_gone(inputs)
});
/**
* | output |
* | --- |
* | "Up" |
*
* @param {Cv_Pin_UpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_pin_up = /** @type {((inputs?: Cv_Pin_UpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Pin_UpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_pin_up(inputs)
	return __ja.cv_pin_up(inputs)
});
/**
* | output |
* | --- |
* | "Move {name} up" |
*
* @param {Cv_Pin_Up_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_pin_up_label = /** @type {((inputs: Cv_Pin_Up_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Pin_Up_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_pin_up_label(inputs)
	return __ja.cv_pin_up_label(inputs)
});
/**
* | output |
* | --- |
* | "Pinned" |
*
* @param {Cv_PinsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_pins = /** @type {((inputs?: Cv_PinsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_PinsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_pins(inputs)
	return __ja.cv_pins(inputs)
});
/**
* | output |
* | --- |
* | "Nothing pinned." |
*
* @param {Cv_Pins_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_pins_empty = /** @type {((inputs?: Cv_Pins_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Pins_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_pins_empty(inputs)
	return __ja.cv_pins_empty(inputs)
});
/**
* | output |
* | --- |
* | "Nothing pinned. Pin a topic or a document from its menu." |
*
* @param {Cv_Pins_Empty_CanInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_pins_empty_can = /** @type {((inputs?: Cv_Pins_Empty_CanInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Pins_Empty_CanInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_pins_empty_can(inputs)
	return __ja.cv_pins_empty_can(inputs)
});
/**
* | output |
* | --- |
* | "Message" |
*
* @param {Cv_Post_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_post_label = /** @type {((inputs?: Cv_Post_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Post_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_post_label(inputs)
	return __ja.cv_post_label(inputs)
});
/**
* | output |
* | --- |
* | "Write and send" |
*
* @param {Cv_Post_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_post_placeholder = /** @type {((inputs?: Cv_Post_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Post_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_post_placeholder(inputs)
	return __ja.cv_post_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Message {name}" |
*
* @param {Cv_Post_Placeholder_DmInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_post_placeholder_dm = /** @type {((inputs: Cv_Post_Placeholder_DmInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Post_Placeholder_DmInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_post_placeholder_dm(inputs)
	return __ja.cv_post_placeholder_dm(inputs)
});
/**
* | output |
* | --- |
* | "Message {names}" |
*
* @param {Cv_Post_Placeholder_Dm_GroupInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_post_placeholder_dm_group = /** @type {((inputs: Cv_Post_Placeholder_Dm_GroupInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Post_Placeholder_Dm_GroupInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_post_placeholder_dm_group(inputs)
	return __ja.cv_post_placeholder_dm_group(inputs)
});
/**
* | output |
* | --- |
* | "Jot something down" |
*
* @param {Cv_Post_Placeholder_Dm_SelfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_post_placeholder_dm_self = /** @type {((inputs?: Cv_Post_Placeholder_Dm_SelfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Post_Placeholder_Dm_SelfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_post_placeholder_dm_self(inputs)
	return __ja.cv_post_placeholder_dm_self(inputs)
});
/**
* | output |
* | --- |
* | "Add a reaction" |
*
* @param {Cv_ReactInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_react = /** @type {((inputs?: Cv_ReactInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_ReactInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_react(inputs)
	return __ja.cv_react(inputs)
});
/**
* | output |
* | --- |
* | "Nothing found" |
*
* @param {Cv_React_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_react_none = /** @type {((inputs?: Cv_React_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_React_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_react_none(inputs)
	return __ja.cv_react_none(inputs)
});
/**
* | output |
* | --- |
* | "Find an emoji" |
*
* @param {Cv_React_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_react_search = /** @type {((inputs?: Cv_React_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_React_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_react_search(inputs)
	return __ja.cv_react_search(inputs)
});
/**
* | output |
* | --- |
* | "Checked" |
*
* @param {Cv_Reaction_CheckInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_reaction_check = /** @type {((inputs?: Cv_Reaction_CheckInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Reaction_CheckInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_reaction_check(inputs)
	return __ja.cv_reaction_check(inputs)
});
/**
* | output |
* | --- |
* | "Seen" |
*
* @param {Cv_Reaction_EyeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_reaction_eye = /** @type {((inputs?: Cv_Reaction_EyeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Reaction_EyeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_reaction_eye(inputs)
	return __ja.cv_reaction_eye(inputs)
});
/**
* | output |
* | --- |
* | "{name} {count}" |
*
* @param {Cv_Reaction_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_reaction_label = /** @type {((inputs: Cv_Reaction_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Reaction_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_reaction_label(inputs)
	return __ja.cv_reaction_label(inputs)
});
/**
* | output |
* | --- |
* | "Reactions" |
*
* @param {Cv_ReactionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_reactions = /** @type {((inputs?: Cv_ReactionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_ReactionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_reactions(inputs)
	return __ja.cv_reactions(inputs)
});
/**
* | output |
* | --- |
* | "Recent topics" |
*
* @param {Cv_Recent_TopicsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_recent_topics = /** @type {((inputs?: Cv_Recent_TopicsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Recent_TopicsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_recent_topics(inputs)
	return __ja.cv_recent_topics(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Cv_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_remove = /** @type {((inputs?: Cv_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_remove(inputs)
	return __ja.cv_remove(inputs)
});
/**
* | output |
* | --- |
* | "This message becomes a line saying it was removed, and its files and reactions go too. This cannot be undone." |
*
* @param {Cv_Remove_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_remove_body = /** @type {((inputs?: Cv_Remove_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Remove_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_remove_body(inputs)
	return __ja.cv_remove_body(inputs)
});
/**
* | output |
* | --- |
* | "Remove this message?" |
*
* @param {Cv_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_remove_title = /** @type {((inputs?: Cv_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_remove_title(inputs)
	return __ja.cv_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Cv_RenameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_rename = /** @type {((inputs?: Cv_RenameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_RenameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_rename(inputs)
	return __ja.cv_rename(inputs)
});
/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Cv_Rename_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_rename_action = /** @type {((inputs?: Cv_Rename_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Rename_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_rename_action(inputs)
	return __ja.cv_rename_action(inputs)
});
/**
* | output |
* | --- |
* | "Save" |
*
* @param {Cv_SaveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_save = /** @type {((inputs?: Cv_SaveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_SaveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_save(inputs)
	return __ja.cv_save(inputs)
});
/**
* | output |
* | --- |
* | "Could not save" |
*
* @param {Cv_Save_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_save_failed = /** @type {((inputs?: Cv_Save_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Save_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_save_failed(inputs)
	return __ja.cv_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "Could not send" |
*
* @param {Cv_Send_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_send_failed = /** @type {((inputs?: Cv_Send_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Send_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_send_failed(inputs)
	return __ja.cv_send_failed(inputs)
});
/**
* | output |
* | --- |
* | "Emoji" |
*
* @param {Cv_Settings_EmojiInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_settings_emoji = /** @type {((inputs?: Cv_Settings_EmojiInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Settings_EmojiInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_settings_emoji(inputs)
	return __ja.cv_settings_emoji(inputs)
});
/**
* | output |
* | --- |
* | "Emoji only this workspace uses, written as :name: in messages and reactions." |
*
* @param {Cv_Settings_Emoji_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_settings_emoji_description = /** @type {((inputs?: Cv_Settings_Emoji_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Settings_Emoji_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_settings_emoji_description(inputs)
	return __ja.cv_settings_emoji_description(inputs)
});
/**
* | output |
* | --- |
* | "Emoji only this workspace uses" |
*
* @param {Cv_Settings_Emoji_ShortInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_settings_emoji_short = /** @type {((inputs?: Cv_Settings_Emoji_ShortInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Settings_Emoji_ShortInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_settings_emoji_short(inputs)
	return __ja.cv_settings_emoji_short(inputs)
});
/**
* | output |
* | --- |
* | "Space" |
*
* @param {Cv_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_space = /** @type {((inputs?: Cv_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_space(inputs)
	return __ja.cv_space(inputs)
});
/**
* | output |
* | --- |
* | "This space is not there or cannot be seen." |
*
* @param {Cv_Space_MissingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_space_missing = /** @type {((inputs?: Cv_Space_MissingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Space_MissingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_space_missing(inputs)
	return __ja.cv_space_missing(inputs)
});
/**
* | output |
* | --- |
* | "Space overview" |
*
* @param {Cv_Space_OverviewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_space_overview = /** @type {((inputs?: Cv_Space_OverviewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Space_OverviewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_space_overview(inputs)
	return __ja.cv_space_overview(inputs)
});
/**
* | output |
* | --- |
* | "Start a topic here" |
*
* @param {Cv_Start_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_start_here = /** @type {((inputs?: Cv_Start_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Start_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_start_here(inputs)
	return __ja.cv_start_here(inputs)
});
/**
* | output |
* | --- |
* | "Emoji" |
*
* @param {Cv_Suggest_EmojiInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_suggest_emoji = /** @type {((inputs?: Cv_Suggest_EmojiInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Suggest_EmojiInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_suggest_emoji(inputs)
	return __ja.cv_suggest_emoji(inputs)
});
/**
* | output |
* | --- |
* | "Topics to link" |
*
* @param {Cv_Suggest_LinksInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_suggest_links = /** @type {((inputs?: Cv_Suggest_LinksInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Suggest_LinksInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_suggest_links(inputs)
	return __ja.cv_suggest_links(inputs)
});
/**
* | output |
* | --- |
* | "Members" |
*
* @param {Cv_Suggest_PeopleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_suggest_people = /** @type {((inputs?: Cv_Suggest_PeopleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Suggest_PeopleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_suggest_people(inputs)
	return __ja.cv_suggest_people(inputs)
});
/**
* | output |
* | --- |
* | "Up to {max} characters" |
*
* @param {Cv_Too_LongInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_too_long = /** @type {((inputs: Cv_Too_LongInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Too_LongInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_too_long(inputs)
	return __ja.cv_too_long(inputs)
});
/**
* | output |
* | --- |
* | "Topic" |
*
* @param {Cv_TopicInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_topic = /** @type {((inputs?: Cv_TopicInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_TopicInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_topic(inputs)
	return __ja.cv_topic(inputs)
});
/**
* | output |
* | --- |
* | "Topic menu" |
*
* @param {Cv_Topic_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_topic_menu = /** @type {((inputs?: Cv_Topic_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Topic_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_topic_menu(inputs)
	return __ja.cv_topic_menu(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Cv_Topic_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_topic_name = /** @type {((inputs?: Cv_Topic_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Topic_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_topic_name(inputs)
	return __ja.cv_topic_name(inputs)
});
/**
* | output |
* | --- |
* | "Name (optional)" |
*
* @param {Cv_Topic_Name_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_topic_name_placeholder = /** @type {((inputs?: Cv_Topic_Name_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Topic_Name_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_topic_name_placeholder(inputs)
	return __ja.cv_topic_name_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Topics" |
*
* @param {Cv_TopicsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_topics = /** @type {((inputs?: Cv_TopicsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_TopicsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_topics(inputs)
	return __ja.cv_topics(inputs)
});
/**
* | output |
* | --- |
* | "No topics yet." |
*
* @param {Cv_Topics_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_topics_empty = /** @type {((inputs?: Cv_Topics_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Topics_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_topics_empty(inputs)
	return __ja.cv_topics_empty(inputs)
});
/**
* | output |
* | --- |
* | "No topics match." |
*
* @param {Cv_Topics_None_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_topics_none_match = /** @type {((inputs?: Cv_Topics_None_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Topics_None_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_topics_none_match(inputs)
	return __ja.cv_topics_none_match(inputs)
});
/**
* | output |
* | --- |
* | "Start a Topic" |
*
* @param {Cv_Topics_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_topics_start = /** @type {((inputs?: Cv_Topics_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Topics_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_topics_start(inputs)
	return __ja.cv_topics_start(inputs)
});
/**
* | output |
* | --- |
* | "Unpin" |
*
* @param {Cv_UnpinInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_unpin = /** @type {((inputs?: Cv_UnpinInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_UnpinInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_unpin(inputs)
	return __ja.cv_unpin(inputs)
});
/**
* | output |
* | --- |
* | "Unpin {name}" |
*
* @param {Cv_Unpin_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_unpin_label = /** @type {((inputs: Cv_Unpin_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Unpin_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_unpin_label(inputs)
	return __ja.cv_unpin_label(inputs)
});
/**
* | output |
* | --- |
* | "Unread" |
*
* @param {Cv_Unread_DotInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cv_unread_dot = /** @type {((inputs?: Cv_Unread_DotInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Unread_DotInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cv_unread_dot(inputs)
	return __ja.cv_unread_dot(inputs)
});
/**
* | output |
* | --- |
* | "This app can't be used as trameria desktop" |
*
* @param {Desktop_Client_Not_AllowedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_client_not_allowed = /** @type {((inputs?: Desktop_Client_Not_AllowedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Client_Not_AllowedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_client_not_allowed(inputs)
	return __ja.desktop_client_not_allowed(inputs)
});
/**
* | output |
* | --- |
* | "This sign-in isn't for trameria desktop" |
*
* @param {Desktop_Scope_MissingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_scope_missing = /** @type {((inputs?: Desktop_Scope_MissingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Scope_MissingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_scope_missing(inputs)
	return __ja.desktop_scope_missing(inputs)
});
/**
* | output |
* | --- |
* | "Your sign-in has expired. Please sign in again" |
*
* @param {Desktop_Token_ExpiredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_token_expired = /** @type {((inputs?: Desktop_Token_ExpiredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Token_ExpiredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_token_expired(inputs)
	return __ja.desktop_token_expired(inputs)
});
/**
* | output |
* | --- |
* | "Invalid token" |
*
* @param {Desktop_Token_InvalidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_token_invalid = /** @type {((inputs?: Desktop_Token_InvalidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Token_InvalidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_token_invalid(inputs)
	return __ja.desktop_token_invalid(inputs)
});
/**
* | output |
* | --- |
* | "Sign in to trameria desktop to continue" |
*
* @param {Desktop_Token_MissingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_token_missing = /** @type {((inputs?: Desktop_Token_MissingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Token_MissingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_token_missing(inputs)
	return __ja.desktop_token_missing(inputs)
});
/**
* | output |
* | --- |
* | "This app has been disconnected. Please sign in again" |
*
* @param {Desktop_Token_RevokedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_token_revoked = /** @type {((inputs?: Desktop_Token_RevokedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Token_RevokedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_token_revoked(inputs)
	return __ja.desktop_token_revoked(inputs)
});
/**
* | output |
* | --- |
* | "Your account is awaiting approval" |
*
* @param {Desktop_WaitlistedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_waitlisted = /** @type {((inputs?: Desktop_WaitlistedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_WaitlistedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_waitlisted(inputs)
	return __ja.desktop_waitlisted(inputs)
});
/**
* | output |
* | --- |
* | "ACTIVITY" |
*
* @param {Issues_ActivityInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity = /** @type {((inputs?: Issues_ActivityInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_ActivityInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity(inputs)
	return __ja.issues_activity(inputs)
});
/**
* | output |
* | --- |
* | "removed the assignee" |
*
* @param {Issues_Activity_Assignee_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_assignee_clear = /** @type {((inputs?: Issues_Activity_Assignee_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Assignee_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_assignee_clear(inputs)
	return __ja.issues_activity_assignee_clear(inputs)
});
/**
* | output |
* | --- |
* | "set the assignee to {to}" |
*
* @param {Issues_Activity_Assignee_SetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_assignee_set = /** @type {((inputs: Issues_Activity_Assignee_SetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Assignee_SetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_assignee_set(inputs)
	return __ja.issues_activity_assignee_set(inputs)
});
/**
* | output |
* | --- |
* | "created the Issue" |
*
* @param {Issues_Activity_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_created = /** @type {((inputs?: Issues_Activity_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_created(inputs)
	return __ja.issues_activity_created(inputs)
});
/**
* | output |
* | --- |
* | "removed the Cycle" |
*
* @param {Issues_Activity_Cycle_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_cycle_clear = /** @type {((inputs?: Issues_Activity_Cycle_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Cycle_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_cycle_clear(inputs)
	return __ja.issues_activity_cycle_clear(inputs)
});
/**
* | output |
* | --- |
* | "set the Cycle to {to}" |
*
* @param {Issues_Activity_Cycle_SetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_cycle_set = /** @type {((inputs: Issues_Activity_Cycle_SetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Cycle_SetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_cycle_set(inputs)
	return __ja.issues_activity_cycle_set(inputs)
});
/**
* | output |
* | --- |
* | "removed the due date" |
*
* @param {Issues_Activity_Due_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_due_clear = /** @type {((inputs?: Issues_Activity_Due_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Due_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_due_clear(inputs)
	return __ja.issues_activity_due_clear(inputs)
});
/**
* | output |
* | --- |
* | "set the due date to {to}" |
*
* @param {Issues_Activity_Due_SetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_due_set = /** @type {((inputs: Issues_Activity_Due_SetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Due_SetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_due_set(inputs)
	return __ja.issues_activity_due_set(inputs)
});
/**
* | output |
* | --- |
* | "added the label {label}" |
*
* @param {Issues_Activity_Label_AddedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_label_added = /** @type {((inputs: Issues_Activity_Label_AddedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Label_AddedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_label_added(inputs)
	return __ja.issues_activity_label_added(inputs)
});
/**
* | output |
* | --- |
* | "removed the label {label}" |
*
* @param {Issues_Activity_Label_RemovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_label_removed = /** @type {((inputs: Issues_Activity_Label_RemovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Label_RemovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_label_removed(inputs)
	return __ja.issues_activity_label_removed(inputs)
});
/**
* | output |
* | --- |
* | "{text}" |
*
* @param {Issues_Activity_LineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_line = /** @type {((inputs: Issues_Activity_LineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_LineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_line(inputs)
	return __ja.issues_activity_line(inputs)
});
/**
* | output |
* | --- |
* | "removed the milestone" |
*
* @param {Issues_Activity_Milestone_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_milestone_clear = /** @type {((inputs?: Issues_Activity_Milestone_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Milestone_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_milestone_clear(inputs)
	return __ja.issues_activity_milestone_clear(inputs)
});
/**
* | output |
* | --- |
* | "set the milestone to {to}" |
*
* @param {Issues_Activity_Milestone_SetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_milestone_set = /** @type {((inputs: Issues_Activity_Milestone_SetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Milestone_SetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_milestone_set(inputs)
	return __ja.issues_activity_milestone_set(inputs)
});
/**
* | output |
* | --- |
* | "removed the Project" |
*
* @param {Issues_Activity_Project_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_project_clear = /** @type {((inputs?: Issues_Activity_Project_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Project_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_project_clear(inputs)
	return __ja.issues_activity_project_clear(inputs)
});
/**
* | output |
* | --- |
* | "set the Project to {to}" |
*
* @param {Issues_Activity_Project_SetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_project_set = /** @type {((inputs: Issues_Activity_Project_SetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Project_SetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_project_set(inputs)
	return __ja.issues_activity_project_set(inputs)
});
/**
* | output |
* | --- |
* | "changed the status to {to}" |
*
* @param {Issues_Activity_StateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_state = /** @type {((inputs: Issues_Activity_StateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_StateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_state(inputs)
	return __ja.issues_activity_state(inputs)
});
/**
* | output |
* | --- |
* | "removed the Team" |
*
* @param {Issues_Activity_Team_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_team_clear = /** @type {((inputs?: Issues_Activity_Team_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Team_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_team_clear(inputs)
	return __ja.issues_activity_team_clear(inputs)
});
/**
* | output |
* | --- |
* | "set the Team to {to}" |
*
* @param {Issues_Activity_Team_SetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_team_set = /** @type {((inputs: Issues_Activity_Team_SetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_Team_SetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_team_set(inputs)
	return __ja.issues_activity_team_set(inputs)
});
/**
* | output |
* | --- |
* | "changed the title to \"{to}\"" |
*
* @param {Issues_Activity_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_activity_title = /** @type {((inputs: Issues_Activity_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Activity_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_activity_title(inputs)
	return __ja.issues_activity_title(inputs)
});
/**
* | output |
* | --- |
* | "Add label" |
*
* @param {Issues_Add_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_add_label = /** @type {((inputs?: Issues_Add_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Add_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_add_label(inputs)
	return __ja.issues_add_label(inputs)
});
/**
* | output |
* | --- |
* | "AI memo" |
*
* @param {Issues_Ai_MemoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_ai_memo = /** @type {((inputs?: Issues_Ai_MemoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Ai_MemoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_ai_memo(inputs)
	return __ja.issues_ai_memo(inputs)
});
/**
* | output |
* | --- |
* | "All" |
*
* @param {Issues_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_all = /** @type {((inputs?: Issues_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_all(inputs)
	return __ja.issues_all(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Issues_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cancel = /** @type {((inputs?: Issues_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cancel(inputs)
	return __ja.issues_cancel(inputs)
});
/**
* | output |
* | --- |
* | "This can't be undone." |
*
* @param {Issues_Cannot_UndoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cannot_undo = /** @type {((inputs?: Issues_Cannot_UndoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cannot_UndoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cannot_undo(inputs)
	return __ja.issues_cannot_undo(inputs)
});
/**
* | output |
* | --- |
* | "Change assignee" |
*
* @param {Issues_Change_AssigneeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_change_assignee = /** @type {((inputs?: Issues_Change_AssigneeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Change_AssigneeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_change_assignee(inputs)
	return __ja.issues_change_assignee(inputs)
});
/**
* | output |
* | --- |
* | "Change Cycle" |
*
* @param {Issues_Change_CycleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_change_cycle = /** @type {((inputs?: Issues_Change_CycleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Change_CycleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_change_cycle(inputs)
	return __ja.issues_change_cycle(inputs)
});
/**
* | output |
* | --- |
* | "Change due date" |
*
* @param {Issues_Change_DueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_change_due = /** @type {((inputs?: Issues_Change_DueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Change_DueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_change_due(inputs)
	return __ja.issues_change_due(inputs)
});
/**
* | output |
* | --- |
* | "Change milestone" |
*
* @param {Issues_Change_MilestoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_change_milestone = /** @type {((inputs?: Issues_Change_MilestoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Change_MilestoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_change_milestone(inputs)
	return __ja.issues_change_milestone(inputs)
});
/**
* | output |
* | --- |
* | "Change Project" |
*
* @param {Issues_Change_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_change_project = /** @type {((inputs?: Issues_Change_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Change_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_change_project(inputs)
	return __ja.issues_change_project(inputs)
});
/**
* | output |
* | --- |
* | "Change Space" |
*
* @param {Issues_Change_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_change_space = /** @type {((inputs?: Issues_Change_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Change_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_change_space(inputs)
	return __ja.issues_change_space(inputs)
});
/**
* | output |
* | --- |
* | "Change status" |
*
* @param {Issues_Change_StateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_change_state = /** @type {((inputs?: Issues_Change_StateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Change_StateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_change_state(inputs)
	return __ja.issues_change_state(inputs)
});
/**
* | output |
* | --- |
* | "Change the due date" |
*
* @param {Issues_Change_Target_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_change_target_date = /** @type {((inputs?: Issues_Change_Target_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Change_Target_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_change_target_date(inputs)
	return __ja.issues_change_target_date(inputs)
});
/**
* | output |
* | --- |
* | "Change Team" |
*
* @param {Issues_Change_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_change_team = /** @type {((inputs?: Issues_Change_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Change_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_change_team(inputs)
	return __ja.issues_change_team(inputs)
});
/**
* | output |
* | --- |
* | "Choose a milestone" |
*
* @param {Issues_Choose_MilestoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_choose_milestone = /** @type {((inputs?: Issues_Choose_MilestoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Choose_MilestoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_choose_milestone(inputs)
	return __ja.issues_choose_milestone(inputs)
});
/**
* | output |
* | --- |
* | "Choose a Team first" |
*
* @param {Issues_Choose_Team_FirstInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_choose_team_first = /** @type {((inputs?: Issues_Choose_Team_FirstInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Choose_Team_FirstInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_choose_team_first(inputs)
	return __ja.issues_choose_team_first(inputs)
});
/**
* | output |
* | --- |
* | "Clear due date" |
*
* @param {Issues_Clear_DueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_clear_due = /** @type {((inputs?: Issues_Clear_DueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Clear_DueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_clear_due(inputs)
	return __ja.issues_clear_due(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Issues_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_close = /** @type {((inputs?: Issues_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_close(inputs)
	return __ja.issues_close(inputs)
});
/**
* | output |
* | --- |
* | "Assignee" |
*
* @param {Issues_Col_AssigneeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_col_assignee = /** @type {((inputs?: Issues_Col_AssigneeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Col_AssigneeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_col_assignee(inputs)
	return __ja.issues_col_assignee(inputs)
});
/**
* | output |
* | --- |
* | "Due date" |
*
* @param {Issues_Col_DueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_col_due = /** @type {((inputs?: Issues_Col_DueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Col_DueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_col_due(inputs)
	return __ja.issues_col_due(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Issues_Col_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_col_name = /** @type {((inputs?: Issues_Col_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Col_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_col_name(inputs)
	return __ja.issues_col_name(inputs)
});
/**
* | output |
* | --- |
* | "Project" |
*
* @param {Issues_Col_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_col_project = /** @type {((inputs?: Issues_Col_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Col_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_col_project(inputs)
	return __ja.issues_col_project(inputs)
});
/**
* | output |
* | --- |
* | "Space" |
*
* @param {Issues_Col_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_col_space = /** @type {((inputs?: Issues_Col_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Col_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_col_space(inputs)
	return __ja.issues_col_space(inputs)
});
/**
* | output |
* | --- |
* | "Status" |
*
* @param {Issues_Col_StateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_col_state = /** @type {((inputs?: Issues_Col_StateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Col_StateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_col_state(inputs)
	return __ja.issues_col_state(inputs)
});
/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Issues_Col_UpdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_col_updated = /** @type {((inputs?: Issues_Col_UpdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Col_UpdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_col_updated(inputs)
	return __ja.issues_col_updated(inputs)
});
/**
* | output |
* | --- |
* | "Edit comment" |
*
* @param {Issues_Comment_Edit_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_comment_edit_label = /** @type {((inputs?: Issues_Comment_Edit_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Comment_Edit_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_comment_edit_label(inputs)
	return __ja.issues_comment_edit_label(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't send the comment" |
*
* @param {Issues_Comment_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_comment_failed = /** @type {((inputs?: Issues_Comment_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Comment_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_comment_failed(inputs)
	return __ja.issues_comment_failed(inputs)
});
/**
* | output |
* | --- |
* | "Comment" |
*
* @param {Issues_Comment_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_comment_label = /** @type {((inputs?: Issues_Comment_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Comment_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_comment_label(inputs)
	return __ja.issues_comment_label(inputs)
});
/**
* | output |
* | --- |
* | "Comment actions" |
*
* @param {Issues_Comment_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_comment_menu = /** @type {((inputs?: Issues_Comment_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Comment_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_comment_menu(inputs)
	return __ja.issues_comment_menu(inputs)
});
/**
* | output |
* | --- |
* | "Write a comment…" |
*
* @param {Issues_Comment_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_comment_placeholder = /** @type {((inputs?: Issues_Comment_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Comment_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_comment_placeholder(inputs)
	return __ja.issues_comment_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Delete comment \"{excerpt}\"?" |
*
* @param {Issues_Comment_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_comment_remove_title = /** @type {((inputs: Issues_Comment_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Comment_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_comment_remove_title(inputs)
	return __ja.issues_comment_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Comments" |
*
* @param {Issues_CommentsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_comments = /** @type {((inputs?: Issues_CommentsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_CommentsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_comments(inputs)
	return __ja.issues_comments(inputs)
});
/**
* | output |
* | --- |
* | "Create Issue" |
*
* @param {Issues_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_create = /** @type {((inputs?: Issues_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_create(inputs)
	return __ja.issues_create(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't create the Issue" |
*
* @param {Issues_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_create_failed = /** @type {((inputs?: Issues_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_create_failed(inputs)
	return __ja.issues_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "Also ⌘↵ to create" |
*
* @param {Issues_Create_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_create_hint = /** @type {((inputs?: Issues_Create_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Create_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_create_hint(inputs)
	return __ja.issues_create_hint(inputs)
});
/**
* | output |
* | --- |
* | "Active" |
*
* @param {Issues_Cycle_Active_TagInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_active_tag = /** @type {((inputs?: Issues_Cycle_Active_TagInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Active_TagInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_active_tag(inputs)
	return __ja.issues_cycle_active_tag(inputs)
});
/**
* | output |
* | --- |
* | "Add the next cycle" |
*
* @param {Issues_Cycle_Add_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_add_next = /** @type {((inputs?: Issues_Cycle_Add_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Add_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_add_next(inputs)
	return __ja.issues_cycle_add_next(inputs)
});
/**
* | output |
* | --- |
* | "{n} days left" |
*
* @param {Issues_Cycle_Days_LeftInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_days_left = /** @type {((inputs: Issues_Cycle_Days_LeftInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Days_LeftInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_days_left(inputs)
	return __ja.issues_cycle_days_left(inputs)
});
/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Issues_Cycle_Done_TagInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_done_tag = /** @type {((inputs?: Issues_Cycle_Done_TagInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Done_TagInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_done_tag(inputs)
	return __ja.issues_cycle_done_tag(inputs)
});
/**
* | output |
* | --- |
* | "No issues in this cycle yet. Add them from an issue's Cycle." |
*
* @param {Issues_Cycle_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_empty = /** @type {((inputs?: Issues_Cycle_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_empty(inputs)
	return __ja.issues_cycle_empty(inputs)
});
/**
* | output |
* | --- |
* | "Cycle length" |
*
* @param {Issues_Cycle_LengthInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_length = /** @type {((inputs?: Issues_Cycle_LengthInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_LengthInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_length(inputs)
	return __ja.issues_cycle_length(inputs)
});
/**
* | output |
* | --- |
* | "Cycle actions" |
*
* @param {Issues_Cycle_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_menu = /** @type {((inputs?: Issues_Cycle_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_menu(inputs)
	return __ja.issues_cycle_menu(inputs)
});
/**
* | output |
* | --- |
* | "In progress · {left}" |
*
* @param {Issues_Cycle_Meta_ActiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_meta_active = /** @type {((inputs: Issues_Cycle_Meta_ActiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Meta_ActiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_meta_active(inputs)
	return __ja.issues_cycle_meta_active(inputs)
});
/**
* | output |
* | --- |
* | "Done · {from}–{to}" |
*
* @param {Issues_Cycle_Meta_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_meta_done = /** @type {((inputs: Issues_Cycle_Meta_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Meta_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_meta_done(inputs)
	return __ja.issues_cycle_meta_done(inputs)
});
/**
* | output |
* | --- |
* | "{starts} · Not started yet" |
*
* @param {Issues_Cycle_Meta_Not_StartedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_meta_not_started = /** @type {((inputs: Issues_Cycle_Meta_Not_StartedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Meta_Not_StartedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_meta_not_started(inputs)
	return __ja.issues_cycle_meta_not_started(inputs)
});
/**
* | output |
* | --- |
* | "Cycle not found. The URL is wrong, or it was deleted." |
*
* @param {Issues_Cycle_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_not_found = /** @type {((inputs?: Issues_Cycle_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_not_found(inputs)
	return __ja.issues_cycle_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Planned" |
*
* @param {Issues_Cycle_Planned_TagInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_planned_tag = /** @type {((inputs?: Issues_Cycle_Planned_TagInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Planned_TagInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_planned_tag(inputs)
	return __ja.issues_cycle_planned_tag(inputs)
});
/**
* | output |
* | --- |
* | "Delete this cycle" |
*
* @param {Issues_Cycle_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_remove = /** @type {((inputs?: Issues_Cycle_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_remove(inputs)
	return __ja.issues_cycle_remove(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Issues_Cycle_Remove_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_remove_action = /** @type {((inputs?: Issues_Cycle_Remove_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Remove_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_remove_action(inputs)
	return __ja.issues_cycle_remove_action(inputs)
});
/**
* | output |
* | --- |
* | "Its issues stay and leave the cycle. This can't be undone." |
*
* @param {Issues_Cycle_Remove_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_remove_body = /** @type {((inputs?: Issues_Cycle_Remove_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Remove_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_remove_body(inputs)
	return __ja.issues_cycle_remove_body(inputs)
});
/**
* | output |
* | --- |
* | "Delete {name} ({team})?" |
*
* @param {Issues_Cycle_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_remove_title = /** @type {((inputs: Issues_Cycle_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_remove_title(inputs)
	return __ja.issues_cycle_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "{starts} · {pct}% · {count} issues" |
*
* @param {Issues_Cycle_SubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_sub = /** @type {((inputs: Issues_Cycle_SubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_SubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_sub(inputs)
	return __ja.issues_cycle_sub(inputs)
});
/**
* | output |
* | --- |
* | "{starts} · {count} issues planned" |
*
* @param {Issues_Cycle_Sub_PlannedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycle_sub_planned = /** @type {((inputs: Issues_Cycle_Sub_PlannedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycle_Sub_PlannedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycle_sub_planned(inputs)
	return __ja.issues_cycle_sub_planned(inputs)
});
/**
* | output |
* | --- |
* | "No cycles yet" |
*
* @param {Issues_Cycles_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycles_empty = /** @type {((inputs?: Issues_Cycles_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycles_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycles_empty(inputs)
	return __ja.issues_cycles_empty(inputs)
});
/**
* | output |
* | --- |
* | "No matching cycles" |
*
* @param {Issues_Cycles_None_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_cycles_none_match = /** @type {((inputs?: Issues_Cycles_None_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Cycles_None_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_cycles_none_match(inputs)
	return __ja.issues_cycles_none_match(inputs)
});
/**
* | output |
* | --- |
* | "days" |
*
* @param {Issues_Days_UnitInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_days_unit = /** @type {((inputs?: Issues_Days_UnitInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Days_UnitInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_days_unit(inputs)
	return __ja.issues_days_unit(inputs)
});
/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Issues_EditInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_edit = /** @type {((inputs?: Issues_EditInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_EditInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_edit(inputs)
	return __ja.issues_edit(inputs)
});
/**
* | output |
* | --- |
* | "No Issues yet" |
*
* @param {Issues_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_empty = /** @type {((inputs?: Issues_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_empty(inputs)
	return __ja.issues_empty(inputs)
});
/**
* | output |
* | --- |
* | "End date" |
*
* @param {Issues_End_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_end_date = /** @type {((inputs?: Issues_End_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_End_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_end_date(inputs)
	return __ja.issues_end_date(inputs)
});
/**
* | output |
* | --- |
* | "Narrow to a space" |
*
* @param {Issues_Filter_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_filter_space = /** @type {((inputs?: Issues_Filter_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Filter_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_filter_space(inputs)
	return __ja.issues_filter_space(inputs)
});
/**
* | output |
* | --- |
* | "All spaces" |
*
* @param {Issues_Filter_Space_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_filter_space_all = /** @type {((inputs?: Issues_Filter_Space_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Filter_Space_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_filter_space_all(inputs)
	return __ja.issues_filter_space_all(inputs)
});
/**
* | output |
* | --- |
* | "Filter by team" |
*
* @param {Issues_Filter_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_filter_team = /** @type {((inputs?: Issues_Filter_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Filter_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_filter_team(inputs)
	return __ja.issues_filter_team(inputs)
});
/**
* | output |
* | --- |
* | "Former member" |
*
* @param {Issues_Former_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_former_member = /** @type {((inputs?: Issues_Former_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Former_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_former_member(inputs)
	return __ja.issues_former_member(inputs)
});
/**
* | output |
* | --- |
* | "Group by" |
*
* @param {Issues_Group_ByInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_group_by = /** @type {((inputs?: Issues_Group_ByInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Group_ByInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_group_by(inputs)
	return __ja.issues_group_by(inputs)
});
/**
* | output |
* | --- |
* | "By assignee" |
*
* @param {Issues_Group_By_AssigneeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_group_by_assignee = /** @type {((inputs?: Issues_Group_By_AssigneeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Group_By_AssigneeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_group_by_assignee(inputs)
	return __ja.issues_group_by_assignee(inputs)
});
/**
* | output |
* | --- |
* | "By Project" |
*
* @param {Issues_Group_By_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_group_by_project = /** @type {((inputs?: Issues_Group_By_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Group_By_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_group_by_project(inputs)
	return __ja.issues_group_by_project(inputs)
});
/**
* | output |
* | --- |
* | "By status" |
*
* @param {Issues_Group_By_StateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_group_by_state = /** @type {((inputs?: Issues_Group_By_StateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Group_By_StateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_group_by_state(inputs)
	return __ja.issues_group_by_state(inputs)
});
/**
* | output |
* | --- |
* | "By Team" |
*
* @param {Issues_Group_By_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_group_by_team = /** @type {((inputs?: Issues_Group_By_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Group_By_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_group_by_team(inputs)
	return __ja.issues_group_by_team(inputs)
});
/**
* | output |
* | --- |
* | "No Project" |
*
* @param {Issues_Group_No_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_group_no_project = /** @type {((inputs?: Issues_Group_No_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Group_No_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_group_no_project(inputs)
	return __ja.issues_group_no_project(inputs)
});
/**
* | output |
* | --- |
* | "No Team" |
*
* @param {Issues_Group_No_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_group_no_team = /** @type {((inputs?: Issues_Group_No_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Group_No_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_group_no_team(inputs)
	return __ja.issues_group_no_team(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load" |
*
* @param {Issues_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_load_failed = /** @type {((inputs?: Issues_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_load_failed(inputs)
	return __ja.issues_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Create an Issue" |
*
* @param {Issues_Make_FirstInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_make_first = /** @type {((inputs?: Issues_Make_FirstInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Make_FirstInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_make_first(inputs)
	return __ja.issues_make_first(inputs)
});
/**
* | output |
* | --- |
* | "Create a project" |
*
* @param {Issues_Make_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_make_project = /** @type {((inputs?: Issues_Make_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Make_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_make_project(inputs)
	return __ja.issues_make_project(inputs)
});
/**
* | output |
* | --- |
* | "Create a team" |
*
* @param {Issues_Make_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_make_team = /** @type {((inputs?: Issues_Make_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Make_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_make_team(inputs)
	return __ja.issues_make_team(inputs)
});
/**
* | output |
* | --- |
* | "Issue actions" |
*
* @param {Issues_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_menu = /** @type {((inputs?: Issues_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_menu(inputs)
	return __ja.issues_menu(inputs)
});
/**
* | output |
* | --- |
* | "+ Milestone" |
*
* @param {Issues_Milestone_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_add = /** @type {((inputs?: Issues_Milestone_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_add(inputs)
	return __ja.issues_milestone_add(inputs)
});
/**
* | output |
* | --- |
* | "Add a milestone" |
*
* @param {Issues_Milestone_Add_RowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_add_row = /** @type {((inputs?: Issues_Milestone_Add_RowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_Add_RowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_add_row(inputs)
	return __ja.issues_milestone_add_row(inputs)
});
/**
* | output |
* | --- |
* | "Milestone name" |
*
* @param {Issues_Milestone_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_name = /** @type {((inputs?: Issues_Milestone_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_name(inputs)
	return __ja.issues_milestone_name(inputs)
});
/**
* | output |
* | --- |
* | "M4 retrospective" |
*
* @param {Issues_Milestone_Name_ExampleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_name_example = /** @type {((inputs?: Issues_Milestone_Name_ExampleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_Name_ExampleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_name_example(inputs)
	return __ja.issues_milestone_name_example(inputs)
});
/**
* | output |
* | --- |
* | "New milestone name" |
*
* @param {Issues_Milestone_New_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_new_name = /** @type {((inputs?: Issues_Milestone_New_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_New_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_new_name(inputs)
	return __ja.issues_milestone_new_name(inputs)
});
/**
* | output |
* | --- |
* | "Delete the milestone “{name}”" |
*
* @param {Issues_Milestone_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_remove = /** @type {((inputs: Issues_Milestone_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_remove(inputs)
	return __ja.issues_milestone_remove(inputs)
});
/**
* | output |
* | --- |
* | "Its issues stay and leave the milestone. This can't be undone." |
*
* @param {Issues_Milestone_Remove_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_remove_body = /** @type {((inputs?: Issues_Milestone_Remove_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_Remove_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_remove_body(inputs)
	return __ja.issues_milestone_remove_body(inputs)
});
/**
* | output |
* | --- |
* | "Remove the milestone" |
*
* @param {Issues_Milestone_Remove_RowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_remove_row = /** @type {((inputs?: Issues_Milestone_Remove_RowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_Remove_RowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_remove_row(inputs)
	return __ja.issues_milestone_remove_row(inputs)
});
/**
* | output |
* | --- |
* | "Delete the milestone “{name}”?" |
*
* @param {Issues_Milestone_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_remove_title = /** @type {((inputs: Issues_Milestone_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_remove_title(inputs)
	return __ja.issues_milestone_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Rename the milestone “{name}”" |
*
* @param {Issues_Milestone_RenameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_rename = /** @type {((inputs: Issues_Milestone_RenameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_RenameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_rename(inputs)
	return __ja.issues_milestone_rename(inputs)
});
/**
* | output |
* | --- |
* | "e.g. M1 spec settled" |
*
* @param {Issues_Milestone_Row_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_milestone_row_placeholder = /** @type {((inputs?: Issues_Milestone_Row_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Milestone_Row_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_milestone_row_placeholder(inputs)
	return __ja.issues_milestone_row_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Narrow the issues" |
*
* @param {Issues_NarrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_narrow = /** @type {((inputs?: Issues_NarrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_NarrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_narrow(inputs)
	return __ja.issues_narrow(inputs)
});
/**
* | output |
* | --- |
* | "Filter cycles" |
*
* @param {Issues_Narrow_CyclesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_narrow_cycles = /** @type {((inputs?: Issues_Narrow_CyclesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Narrow_CyclesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_narrow_cycles(inputs)
	return __ja.issues_narrow_cycles(inputs)
});
/**
* | output |
* | --- |
* | "Filter by cycle or team" |
*
* @param {Issues_Narrow_Cycles_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_narrow_cycles_placeholder = /** @type {((inputs?: Issues_Narrow_Cycles_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Narrow_Cycles_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_narrow_cycles_placeholder(inputs)
	return __ja.issues_narrow_cycles_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Filter by title" |
*
* @param {Issues_Narrow_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_narrow_placeholder = /** @type {((inputs?: Issues_Narrow_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Narrow_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_narrow_placeholder(inputs)
	return __ja.issues_narrow_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Filter projects" |
*
* @param {Issues_Narrow_ProjectsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_narrow_projects = /** @type {((inputs?: Issues_Narrow_ProjectsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Narrow_ProjectsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_narrow_projects(inputs)
	return __ja.issues_narrow_projects(inputs)
});
/**
* | output |
* | --- |
* | "Filter by name" |
*
* @param {Issues_Narrow_Projects_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_narrow_projects_placeholder = /** @type {((inputs?: Issues_Narrow_Projects_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Narrow_Projects_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_narrow_projects_placeholder(inputs)
	return __ja.issues_narrow_projects_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Issues" |
*
* @param {Issues_NavInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_nav = /** @type {((inputs?: Issues_NavInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_NavInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_nav(inputs)
	return __ja.issues_nav(inputs)
});
/**
* | output |
* | --- |
* | "New issue" |
*
* @param {Issues_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_new = /** @type {((inputs?: Issues_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_new(inputs)
	return __ja.issues_new(inputs)
});
/**
* | output |
* | --- |
* | "New project" |
*
* @param {Issues_New_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_new_project = /** @type {((inputs?: Issues_New_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_New_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_new_project(inputs)
	return __ja.issues_new_project(inputs)
});
/**
* | output |
* | --- |
* | "New team" |
*
* @param {Issues_New_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_new_team = /** @type {((inputs?: Issues_New_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_New_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_new_team(inputs)
	return __ja.issues_new_team(inputs)
});
/**
* | output |
* | --- |
* | "Cycle length (days)" |
*
* @param {Issues_New_Team_Cycle_DaysInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_new_team_cycle_days = /** @type {((inputs?: Issues_New_Team_Cycle_DaysInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_New_Team_Cycle_DaysInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_new_team_cycle_days(inputs)
	return __ja.issues_new_team_cycle_days(inputs)
});
/**
* | output |
* | --- |
* | "e.g. Web platform" |
*
* @param {Issues_New_Team_Name_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_new_team_name_placeholder = /** @type {((inputs?: Issues_New_Team_Name_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_New_Team_Name_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_new_team_name_placeholder(inputs)
	return __ja.issues_new_team_name_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "A team runs cycles. Creating one makes a cycle starting today and the next two." |
*
* @param {Issues_New_Team_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_new_team_note = /** @type {((inputs?: Issues_New_Team_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_New_Team_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_new_team_note(inputs)
	return __ja.issues_new_team_note(inputs)
});
/**
* | output |
* | --- |
* | "No activity yet" |
*
* @param {Issues_No_ActivityInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_activity = /** @type {((inputs?: Issues_No_ActivityInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_ActivityInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_activity(inputs)
	return __ja.issues_no_activity(inputs)
});
/**
* | output |
* | --- |
* | "No Cycle" |
*
* @param {Issues_No_CycleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_cycle = /** @type {((inputs?: Issues_No_CycleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_CycleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_cycle(inputs)
	return __ja.issues_no_cycle(inputs)
});
/**
* | output |
* | --- |
* | "No due date" |
*
* @param {Issues_No_DueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_due = /** @type {((inputs?: Issues_No_DueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_DueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_due(inputs)
	return __ja.issues_no_due(inputs)
});
/**
* | output |
* | --- |
* | "No milestone" |
*
* @param {Issues_No_MilestoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_milestone = /** @type {((inputs?: Issues_No_MilestoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_MilestoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_milestone(inputs)
	return __ja.issues_no_milestone(inputs)
});
/**
* | output |
* | --- |
* | "You don't have permission to create an Issue. issue.manage is required. Ask someone with the role." |
*
* @param {Issues_No_PermissionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_permission = /** @type {((inputs?: Issues_No_PermissionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_PermissionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_permission(inputs)
	return __ja.issues_no_permission(inputs)
});
/**
* | output |
* | --- |
* | "You don't have permission to create a project. issue.manage is required. Ask someone with the role." |
*
* @param {Issues_No_Permission_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_permission_project = /** @type {((inputs?: Issues_No_Permission_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_Permission_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_permission_project(inputs)
	return __ja.issues_no_permission_project(inputs)
});
/**
* | output |
* | --- |
* | "You don't have permission to create a team. issue.manage is required. Ask someone with the role." |
*
* @param {Issues_No_Permission_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_permission_team = /** @type {((inputs?: Issues_No_Permission_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_Permission_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_permission_team(inputs)
	return __ja.issues_no_permission_team(inputs)
});
/**
* | output |
* | --- |
* | "No Project" |
*
* @param {Issues_No_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_project = /** @type {((inputs?: Issues_No_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_project(inputs)
	return __ja.issues_no_project(inputs)
});
/**
* | output |
* | --- |
* | "No space can hold Issues." |
*
* @param {Issues_No_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_space = /** @type {((inputs?: Issues_No_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_space(inputs)
	return __ja.issues_no_space(inputs)
});
/**
* | output |
* | --- |
* | "No space can hold projects." |
*
* @param {Issues_No_Space_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_space_project = /** @type {((inputs?: Issues_No_Space_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_Space_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_space_project(inputs)
	return __ja.issues_no_space_project(inputs)
});
/**
* | output |
* | --- |
* | "No space has cycles on." |
*
* @param {Issues_No_Space_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_space_team = /** @type {((inputs?: Issues_No_Space_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_Space_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_space_team(inputs)
	return __ja.issues_no_space_team(inputs)
});
/**
* | output |
* | --- |
* | "No Team" |
*
* @param {Issues_No_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_no_team = /** @type {((inputs?: Issues_No_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_No_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_no_team(inputs)
	return __ja.issues_no_team(inputs)
});
/**
* | output |
* | --- |
* | "None" |
*
* @param {Issues_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_none = /** @type {((inputs?: Issues_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_none(inputs)
	return __ja.issues_none(inputs)
});
/**
* | output |
* | --- |
* | "No Issues match" |
*
* @param {Issues_None_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_none_match = /** @type {((inputs?: Issues_None_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_None_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_none_match(inputs)
	return __ja.issues_none_match(inputs)
});
/**
* | output |
* | --- |
* | "Issue not found. The URL is wrong, or it was deleted." |
*
* @param {Issues_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_not_found = /** @type {((inputs?: Issues_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_not_found(inputs)
	return __ja.issues_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Not set" |
*
* @param {Issues_Not_SetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_not_set = /** @type {((inputs?: Issues_Not_SetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Not_SetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_not_set(inputs)
	return __ja.issues_not_set(inputs)
});
/**
* | output |
* | --- |
* | "Description" |
*
* @param {Issues_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_note = /** @type {((inputs?: Issues_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_note(inputs)
	return __ja.issues_note(inputs)
});
/**
* | output |
* | --- |
* | "Add a description…" |
*
* @param {Issues_Note_New_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_note_new_placeholder = /** @type {((inputs?: Issues_Note_New_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Note_New_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_note_new_placeholder(inputs)
	return __ja.issues_note_new_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Write a description…" |
*
* @param {Issues_Note_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_note_placeholder = /** @type {((inputs?: Issues_Note_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Note_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_note_placeholder(inputs)
	return __ja.issues_note_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "{done}/{total} done" |
*
* @param {Issues_Progress_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_progress_done = /** @type {((inputs: Issues_Progress_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Progress_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_progress_done(inputs)
	return __ja.issues_progress_done(inputs)
});
/**
* | output |
* | --- |
* | "Create project" |
*
* @param {Issues_Project_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_create = /** @type {((inputs?: Issues_Project_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_create(inputs)
	return __ja.issues_project_create(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't create the project" |
*
* @param {Issues_Project_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_create_failed = /** @type {((inputs?: Issues_Project_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_create_failed(inputs)
	return __ja.issues_project_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "Mark done" |
*
* @param {Issues_Project_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_done = /** @type {((inputs?: Issues_Project_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_done(inputs)
	return __ja.issues_project_done(inputs)
});
/**
* | output |
* | --- |
* | "· {count} issues" |
*
* @param {Issues_Project_Issue_CountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_issue_count = /** @type {((inputs: Issues_Project_Issue_CountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_Issue_CountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_issue_count(inputs)
	return __ja.issues_project_issue_count(inputs)
});
/**
* | output |
* | --- |
* | "Project actions" |
*
* @param {Issues_Project_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_menu = /** @type {((inputs?: Issues_Project_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_menu(inputs)
	return __ja.issues_project_menu(inputs)
});
/**
* | output |
* | --- |
* | "Project name" |
*
* @param {Issues_Project_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_name = /** @type {((inputs?: Issues_Project_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_name(inputs)
	return __ja.issues_project_name(inputs)
});
/**
* | output |
* | --- |
* | "Project name" |
*
* @param {Issues_Project_Name_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_name_placeholder = /** @type {((inputs?: Issues_Project_Name_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_Name_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_name_placeholder(inputs)
	return __ja.issues_project_name_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Project not found. The URL is wrong, or it was deleted." |
*
* @param {Issues_Project_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_not_found = /** @type {((inputs?: Issues_Project_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_not_found(inputs)
	return __ja.issues_project_not_found(inputs)
});
/**
* | output |
* | --- |
* | "What is this project for? Write the background and aims…" |
*
* @param {Issues_Project_Note_New_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_note_new_placeholder = /** @type {((inputs?: Issues_Project_Note_New_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_Note_New_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_note_new_placeholder(inputs)
	return __ja.issues_project_note_new_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "What is this project for…" |
*
* @param {Issues_Project_Note_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_note_placeholder = /** @type {((inputs?: Issues_Project_Note_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_Note_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_note_placeholder(inputs)
	return __ja.issues_project_note_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "{pct}% · Due" |
*
* @param {Issues_Project_Pct_TargetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_pct_target = /** @type {((inputs: Issues_Project_Pct_TargetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_Pct_TargetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_pct_target(inputs)
	return __ja.issues_project_pct_target(inputs)
});
/**
* | output |
* | --- |
* | "Its issues stay and leave the project. Its milestones are deleted too. This can't be undone." |
*
* @param {Issues_Project_Remove_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_remove_body = /** @type {((inputs?: Issues_Project_Remove_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_Remove_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_remove_body(inputs)
	return __ja.issues_project_remove_body(inputs)
});
/**
* | output |
* | --- |
* | "Delete the project “{name}”?" |
*
* @param {Issues_Project_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_remove_title = /** @type {((inputs: Issues_Project_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_remove_title(inputs)
	return __ja.issues_project_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Reopen" |
*
* @param {Issues_Project_ReopenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_reopen = /** @type {((inputs?: Issues_Project_ReopenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_ReopenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_reopen(inputs)
	return __ja.issues_project_reopen(inputs)
});
/**
* | output |
* | --- |
* | "{pct}% · {due} · Team {teams}" |
*
* @param {Issues_Project_SubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_sub = /** @type {((inputs: Issues_Project_SubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_SubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_sub(inputs)
	return __ja.issues_project_sub(inputs)
});
/**
* | output |
* | --- |
* | "{pct}% · Due {due} · {count} issues" |
*
* @param {Issues_Project_SummaryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_project_summary = /** @type {((inputs: Issues_Project_SummaryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Project_SummaryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_project_summary(inputs)
	return __ja.issues_project_summary(inputs)
});
/**
* | output |
* | --- |
* | "No projects yet" |
*
* @param {Issues_Projects_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_projects_empty = /** @type {((inputs?: Issues_Projects_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Projects_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_projects_empty(inputs)
	return __ja.issues_projects_empty(inputs)
});
/**
* | output |
* | --- |
* | "No finished projects" |
*
* @param {Issues_Projects_None_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_projects_none_done = /** @type {((inputs?: Issues_Projects_None_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Projects_None_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_projects_none_done(inputs)
	return __ja.issues_projects_none_done(inputs)
});
/**
* | output |
* | --- |
* | "No matching projects" |
*
* @param {Issues_Projects_None_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_projects_none_match = /** @type {((inputs?: Issues_Projects_None_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Projects_None_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_projects_none_match(inputs)
	return __ja.issues_projects_none_match(inputs)
});
/**
* | output |
* | --- |
* | "Filter by state" |
*
* @param {Issues_Projects_StateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_projects_state = /** @type {((inputs?: Issues_Projects_StateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Projects_StateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_projects_state(inputs)
	return __ja.issues_projects_state(inputs)
});
/**
* | output |
* | --- |
* | "Assignee" |
*
* @param {Issues_Prop_AssigneeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_prop_assignee = /** @type {((inputs?: Issues_Prop_AssigneeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Prop_AssigneeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_prop_assignee(inputs)
	return __ja.issues_prop_assignee(inputs)
});
/**
* | output |
* | --- |
* | "Cycle" |
*
* @param {Issues_Prop_CycleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_prop_cycle = /** @type {((inputs?: Issues_Prop_CycleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Prop_CycleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_prop_cycle(inputs)
	return __ja.issues_prop_cycle(inputs)
});
/**
* | output |
* | --- |
* | "Due date" |
*
* @param {Issues_Prop_DueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_prop_due = /** @type {((inputs?: Issues_Prop_DueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Prop_DueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_prop_due(inputs)
	return __ja.issues_prop_due(inputs)
});
/**
* | output |
* | --- |
* | "Labels" |
*
* @param {Issues_Prop_LabelsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_prop_labels = /** @type {((inputs?: Issues_Prop_LabelsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Prop_LabelsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_prop_labels(inputs)
	return __ja.issues_prop_labels(inputs)
});
/**
* | output |
* | --- |
* | "Milestone" |
*
* @param {Issues_Prop_MilestoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_prop_milestone = /** @type {((inputs?: Issues_Prop_MilestoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Prop_MilestoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_prop_milestone(inputs)
	return __ja.issues_prop_milestone(inputs)
});
/**
* | output |
* | --- |
* | "Project" |
*
* @param {Issues_Prop_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_prop_project = /** @type {((inputs?: Issues_Prop_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Prop_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_prop_project(inputs)
	return __ja.issues_prop_project(inputs)
});
/**
* | output |
* | --- |
* | "Status" |
*
* @param {Issues_Prop_StateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_prop_state = /** @type {((inputs?: Issues_Prop_StateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Prop_StateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_prop_state(inputs)
	return __ja.issues_prop_state(inputs)
});
/**
* | output |
* | --- |
* | "Team" |
*
* @param {Issues_Prop_TeamInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_prop_team = /** @type {((inputs?: Issues_Prop_TeamInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Prop_TeamInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_prop_team(inputs)
	return __ja.issues_prop_team(inputs)
});
/**
* | output |
* | --- |
* | "–" |
*
* @param {Issues_Range_SepInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_range_sep = /** @type {((inputs?: Issues_Range_SepInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Range_SepInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_range_sep(inputs)
	return __ja.issues_range_sep(inputs)
});
/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Issues_ReloadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_reload = /** @type {((inputs?: Issues_ReloadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_ReloadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_reload(inputs)
	return __ja.issues_reload(inputs)
});
/**
* | output |
* | --- |
* | "This app is out of date. Reload to write here." |
*
* @param {Issues_Reload_NeededInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_reload_needed = /** @type {((inputs?: Issues_Reload_NeededInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Reload_NeededInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_reload_needed(inputs)
	return __ja.issues_reload_needed(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Issues_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_remove = /** @type {((inputs?: Issues_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_remove(inputs)
	return __ja.issues_remove(inputs)
});
/**
* | output |
* | --- |
* | "Its comments and activity will be deleted too. This can't be undone." |
*
* @param {Issues_Remove_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_remove_body = /** @type {((inputs?: Issues_Remove_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Remove_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_remove_body(inputs)
	return __ja.issues_remove_body(inputs)
});
/**
* | output |
* | --- |
* | "{names}. Their comments and activity will be deleted too. This can't be undone." |
*
* @param {Issues_Remove_Many_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_remove_many_body = /** @type {((inputs: Issues_Remove_Many_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Remove_Many_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_remove_many_body(inputs)
	return __ja.issues_remove_many_body(inputs)
});
/**
* | output |
* | --- |
* | "Delete {count} Issues?" |
*
* @param {Issues_Remove_Many_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_remove_many_title = /** @type {((inputs: Issues_Remove_Many_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Remove_Many_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_remove_many_title(inputs)
	return __ja.issues_remove_many_title(inputs)
});
/**
* | output |
* | --- |
* | "Delete \"{title}\"?" |
*
* @param {Issues_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_remove_title = /** @type {((inputs: Issues_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_remove_title(inputs)
	return __ja.issues_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Actions for \"{title}\"" |
*
* @param {Issues_Row_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_row_menu = /** @type {((inputs: Issues_Row_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Row_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_row_menu(inputs)
	return __ja.issues_row_menu(inputs)
});
/**
* | output |
* | --- |
* | "Save" |
*
* @param {Issues_SaveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_save = /** @type {((inputs?: Issues_SaveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_SaveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_save(inputs)
	return __ja.issues_save(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't save" |
*
* @param {Issues_Save_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_save_failed = /** @type {((inputs?: Issues_Save_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Save_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_save_failed(inputs)
	return __ja.issues_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "Set to {state}" |
*
* @param {Issues_Set_StateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_set_state = /** @type {((inputs: Issues_Set_StateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Set_StateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_set_state(inputs)
	return __ja.issues_set_state(inputs)
});
/**
* | output |
* | --- |
* | "Someone" |
*
* @param {Issues_SomeoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_someone = /** @type {((inputs?: Issues_SomeoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_SomeoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_someone(inputs)
	return __ja.issues_someone(inputs)
});
/**
* | output |
* | --- |
* | "Start date" |
*
* @param {Issues_Start_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_start_date = /** @type {((inputs?: Issues_Start_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Start_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_start_date(inputs)
	return __ja.issues_start_date(inputs)
});
/**
* | output |
* | --- |
* | "Starts {date}" |
*
* @param {Issues_Starts_OnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_starts_on = /** @type {((inputs: Issues_Starts_OnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Starts_OnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_starts_on(inputs)
	return __ja.issues_starts_on(inputs)
});
/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Issues_State_DoingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_state_doing = /** @type {((inputs?: Issues_State_DoingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_State_DoingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_state_doing(inputs)
	return __ja.issues_state_doing(inputs)
});
/**
* | output |
* | --- |
* | "Done" |
*
* @param {Issues_State_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_state_done = /** @type {((inputs?: Issues_State_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_State_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_state_done(inputs)
	return __ja.issues_state_done(inputs)
});
/**
* | output |
* | --- |
* | "To do" |
*
* @param {Issues_State_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_state_open = /** @type {((inputs?: Issues_State_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_State_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_state_open(inputs)
	return __ja.issues_state_open(inputs)
});
/**
* | output |
* | --- |
* | "In review" |
*
* @param {Issues_State_ReviewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_state_review = /** @type {((inputs?: Issues_State_ReviewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_State_ReviewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_state_review(inputs)
	return __ja.issues_state_review(inputs)
});
/**
* | output |
* | --- |
* | "Cycles" |
*
* @param {Issues_Tab_CyclesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_tab_cycles = /** @type {((inputs?: Issues_Tab_CyclesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Tab_CyclesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_tab_cycles(inputs)
	return __ja.issues_tab_cycles(inputs)
});
/**
* | output |
* | --- |
* | "Issues" |
*
* @param {Issues_Tab_IssuesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_tab_issues = /** @type {((inputs?: Issues_Tab_IssuesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Tab_IssuesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_tab_issues(inputs)
	return __ja.issues_tab_issues(inputs)
});
/**
* | output |
* | --- |
* | "Projects" |
*
* @param {Issues_Tab_ProjectsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_tab_projects = /** @type {((inputs?: Issues_Tab_ProjectsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Tab_ProjectsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_tab_projects(inputs)
	return __ja.issues_tab_projects(inputs)
});
/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Issues_Tab_UpcomingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_tab_upcoming = /** @type {((inputs?: Issues_Tab_UpcomingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Tab_UpcomingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_tab_upcoming(inputs)
	return __ja.issues_tab_upcoming(inputs)
});
/**
* | output |
* | --- |
* | "Issue lists" |
*
* @param {Issues_TabsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_tabs = /** @type {((inputs?: Issues_TabsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_TabsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_tabs(inputs)
	return __ja.issues_tabs(inputs)
});
/**
* | output |
* | --- |
* | "Due date" |
*
* @param {Issues_Target_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_target_date = /** @type {((inputs?: Issues_Target_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Target_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_target_date(inputs)
	return __ja.issues_target_date(inputs)
});
/**
* | output |
* | --- |
* | "Create" |
*
* @param {Issues_Team_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_team_create = /** @type {((inputs?: Issues_Team_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Team_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_team_create(inputs)
	return __ja.issues_team_create(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't create the team" |
*
* @param {Issues_Team_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_team_create_failed = /** @type {((inputs?: Issues_Team_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Team_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_team_create_failed(inputs)
	return __ja.issues_team_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Issues_Team_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_team_name = /** @type {((inputs?: Issues_Team_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Team_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_team_name(inputs)
	return __ja.issues_team_name(inputs)
});
/**
* | output |
* | --- |
* | "Team settings" |
*
* @param {Issues_Team_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_team_settings = /** @type {((inputs?: Issues_Team_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Team_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_team_settings(inputs)
	return __ja.issues_team_settings(inputs)
});
/**
* | output |
* | --- |
* | "No teams yet" |
*
* @param {Issues_Teams_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_teams_empty = /** @type {((inputs?: Issues_Teams_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Teams_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_teams_empty(inputs)
	return __ja.issues_teams_empty(inputs)
});
/**
* | output |
* | --- |
* | "{n} days ago" |
*
* @param {Issues_Time_Days_AgoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_time_days_ago = /** @type {((inputs: Issues_Time_Days_AgoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Time_Days_AgoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_time_days_ago(inputs)
	return __ja.issues_time_days_ago(inputs)
});
/**
* | output |
* | --- |
* | "Yesterday {time}" |
*
* @param {Issues_Time_YesterdayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_time_yesterday = /** @type {((inputs: Issues_Time_YesterdayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Time_YesterdayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_time_yesterday(inputs)
	return __ja.issues_time_yesterday(inputs)
});
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Issues_Title_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_title_label = /** @type {((inputs?: Issues_Title_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Title_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_title_label(inputs)
	return __ja.issues_title_label(inputs)
});
/**
* | output |
* | --- |
* | "Issue title" |
*
* @param {Issues_Title_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_title_placeholder = /** @type {((inputs?: Issues_Title_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Title_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_title_placeholder(inputs)
	return __ja.issues_title_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Up to {max} characters" |
*
* @param {Issues_Too_LongInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_too_long = /** @type {((inputs: Issues_Too_LongInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Too_LongInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_too_long(inputs)
	return __ja.issues_too_long(inputs)
});
/**
* | output |
* | --- |
* | "Unassigned" |
*
* @param {Issues_UnassignedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_unassigned = /** @type {((inputs?: Issues_UnassignedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_UnassignedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_unassigned(inputs)
	return __ja.issues_unassigned(inputs)
});
/**
* | output |
* | --- |
* | "No issues waiting for a cycle" |
*
* @param {Issues_Upcoming_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const issues_upcoming_empty = /** @type {((inputs?: Issues_Upcoming_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_Upcoming_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.issues_upcoming_empty(inputs)
	return __ja.issues_upcoming_empty(inputs)
});
/**
* | output |
* | --- |
* | "Your waitlist request was approved. You can sign in at the URL below." |
*
* @param {Mail_Approved_Line_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_approved_line_body = /** @type {((inputs?: Mail_Approved_Line_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Approved_Line_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mail_approved_line_body(inputs)
	return __ja.mail_approved_line_body(inputs)
});
/**
* | output |
* | --- |
* | "You can now sign in to trameria" |
*
* @param {Mail_Approved_SubjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_approved_subject = /** @type {((inputs?: Mail_Approved_SubjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Approved_SubjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mail_approved_subject(inputs)
	return __ja.mail_approved_subject(inputs)
});
/**
* | output |
* | --- |
* | "Your trameria sign-in code is {otp}." |
*
* @param {Mail_Sign_In_Code_Line_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_sign_in_code_line_code = /** @type {((inputs: Mail_Sign_In_Code_Line_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Sign_In_Code_Line_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mail_sign_in_code_line_code(inputs)
	return __ja.mail_sign_in_code_line_code(inputs)
});
/**
* | minutesPlural | output |
* | --- | --- |
* | "one" | "It expires in {minutes} minute." |
* | "other" | "It expires in {minutes} minutes." |
*
* @param {Mail_Sign_In_Code_Line_ExpiresInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_sign_in_code_line_expires = /** @type {((inputs: Mail_Sign_In_Code_Line_ExpiresInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Sign_In_Code_Line_ExpiresInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mail_sign_in_code_line_expires(inputs)
	return __ja.mail_sign_in_code_line_expires(inputs)
});
/**
* | output |
* | --- |
* | "If you didn't request this, you can ignore this email." |
*
* @param {Mail_Sign_In_Code_Line_IgnoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_sign_in_code_line_ignore = /** @type {((inputs?: Mail_Sign_In_Code_Line_IgnoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Sign_In_Code_Line_IgnoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mail_sign_in_code_line_ignore(inputs)
	return __ja.mail_sign_in_code_line_ignore(inputs)
});
/**
* | output |
* | --- |
* | "Your trameria sign-in code" |
*
* @param {Mail_Sign_In_Code_SubjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_sign_in_code_subject = /** @type {((inputs?: Mail_Sign_In_Code_SubjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Sign_In_Code_SubjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mail_sign_in_code_subject(inputs)
	return __ja.mail_sign_in_code_subject(inputs)
});
/**
* | output |
* | --- |
* | "{email} joined the waitlist." |
*
* @param {Mail_Waitlist_Joined_Line_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_waitlist_joined_line_body = /** @type {((inputs: Mail_Waitlist_Joined_Line_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Waitlist_Joined_Line_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mail_waitlist_joined_line_body(inputs)
	return __ja.mail_waitlist_joined_line_body(inputs)
});
/**
* | output |
* | --- |
* | "Someone joined the waitlist" |
*
* @param {Mail_Waitlist_Joined_SubjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_waitlist_joined_subject = /** @type {((inputs?: Mail_Waitlist_Joined_SubjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Waitlist_Joined_SubjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mail_waitlist_joined_subject(inputs)
	return __ja.mail_waitlist_joined_subject(inputs)
});
/**
* | output |
* | --- |
* | "An archived document cannot be published" |
*
* @param {Publish_ArchivedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_archived = /** @type {((inputs?: Publish_ArchivedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_ArchivedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_archived(inputs)
	return __ja.publish_archived(inputs)
});
/**
* | output |
* | --- |
* | "Chat" |
*
* @param {Publish_Kind_ChatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_kind_chat = /** @type {((inputs?: Publish_Kind_ChatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Kind_ChatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_kind_chat(inputs)
	return __ja.publish_kind_chat(inputs)
});
/**
* | output |
* | --- |
* | "Member" |
*
* @param {Publish_Kind_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_kind_member = /** @type {((inputs?: Publish_Kind_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Kind_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_kind_member(inputs)
	return __ja.publish_kind_member(inputs)
});
/**
* | output |
* | --- |
* | "Message" |
*
* @param {Publish_Kind_MessageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_kind_message = /** @type {((inputs?: Publish_Kind_MessageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Kind_MessageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_kind_message(inputs)
	return __ja.publish_kind_message(inputs)
});
/**
* | output |
* | --- |
* | "Reference" |
*
* @param {Publish_Kind_OtherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_kind_other = /** @type {((inputs?: Publish_Kind_OtherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Kind_OtherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_kind_other(inputs)
	return __ja.publish_kind_other(inputs)
});
/**
* | output |
* | --- |
* | "Private document" |
*
* @param {Publish_Kind_Private_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_kind_private_page = /** @type {((inputs?: Publish_Kind_Private_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Kind_Private_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_kind_private_page(inputs)
	return __ja.publish_kind_private_page(inputs)
});
/**
* | output |
* | --- |
* | "Made with trameria" |
*
* @param {Publish_Made_WithInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_made_with = /** @type {((inputs?: Publish_Made_WithInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Made_WithInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_made_with(inputs)
	return __ja.publish_made_with(inputs)
});
/**
* | output |
* | --- |
* | "Slide controls" |
*
* @param {Publish_Slide_ControlsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_slide_controls = /** @type {((inputs?: Publish_Slide_ControlsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Slide_ControlsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_slide_controls(inputs)
	return __ja.publish_slide_controls(inputs)
});
/**
* | output |
* | --- |
* | "Exit full screen" |
*
* @param {Publish_Slide_Exit_FullscreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_slide_exit_fullscreen = /** @type {((inputs?: Publish_Slide_Exit_FullscreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Slide_Exit_FullscreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_slide_exit_fullscreen(inputs)
	return __ja.publish_slide_exit_fullscreen(inputs)
});
/**
* | output |
* | --- |
* | "Full screen" |
*
* @param {Publish_Slide_FullscreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_slide_fullscreen = /** @type {((inputs?: Publish_Slide_FullscreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Slide_FullscreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_slide_fullscreen(inputs)
	return __ja.publish_slide_fullscreen(inputs)
});
/**
* | output |
* | --- |
* | "Next slide" |
*
* @param {Publish_Slide_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_slide_next = /** @type {((inputs?: Publish_Slide_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Slide_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_slide_next(inputs)
	return __ja.publish_slide_next(inputs)
});
/**
* | output |
* | --- |
* | "Previous slide" |
*
* @param {Publish_Slide_PrevInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_slide_prev = /** @type {((inputs?: Publish_Slide_PrevInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Slide_PrevInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_slide_prev(inputs)
	return __ja.publish_slide_prev(inputs)
});
/**
* | output |
* | --- |
* | "Publishing by link is not available here (no public store)" |
*
* @param {Publish_UnavailableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_unavailable = /** @type {((inputs?: Publish_UnavailableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_UnavailableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_unavailable(inputs)
	return __ja.publish_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Updated {date}" |
*
* @param {Publish_Updated_AtInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publish_updated_at = /** @type {((inputs: Publish_Updated_AtInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Updated_AtInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publish_updated_at(inputs)
	return __ja.publish_updated_at(inputs)
});
/**
* | output |
* | --- |
* | "Notifications are not allowed in the {device}'s Settings" |
*
* @param {Push_App_DeniedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_app_denied = /** @type {((inputs: Push_App_DeniedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_App_DeniedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_app_denied(inputs)
	return __ja.push_app_denied(inputs)
});
/**
* | output |
* | --- |
* | "{device} (app)" |
*
* @param {Push_App_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_app_label = /** @type {((inputs: Push_App_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_App_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_app_label(inputs)
	return __ja.push_app_label(inputs)
});
/**
* | output |
* | --- |
* | "Open Settings" |
*
* @param {Push_App_Open_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_app_open_settings = /** @type {((inputs?: Push_App_Open_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_App_Open_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_app_open_settings(inputs)
	return __ja.push_app_open_settings(inputs)
});
/**
* | output |
* | --- |
* | "Notifications are blocked in this browser. Allow them in the site settings in the address bar, then you can start receiving them here" |
*
* @param {Push_BlockedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_blocked = /** @type {((inputs?: Push_BlockedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_BlockedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_blocked(inputs)
	return __ja.push_blocked(inputs)
});
/**
* | output |
* | --- |
* | "Last delivered {when}" |
*
* @param {Push_Delivered_AtInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_delivered_at = /** @type {((inputs: Push_Delivered_AtInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Delivered_AtInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_delivered_at(inputs)
	return __ja.push_delivered_at(inputs)
});
/**
* | output |
* | --- |
* | "Desktop app" |
*
* @param {Push_Desktop_AppInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_desktop_app = /** @type {((inputs?: Push_Desktop_AppInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Desktop_AppInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_desktop_app(inputs)
	return __ja.push_desktop_app(inputs)
});
/**
* | output |
* | --- |
* | "macOS notifications are not allowed" |
*
* @param {Push_Desktop_BlockedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_desktop_blocked = /** @type {((inputs?: Push_Desktop_BlockedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Desktop_BlockedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_desktop_blocked(inputs)
	return __ja.push_desktop_blocked(inputs)
});
/**
* | output |
* | --- |
* | "Open System Settings" |
*
* @param {Push_Desktop_Open_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_desktop_open_settings = /** @type {((inputs?: Push_Desktop_Open_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Desktop_Open_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_desktop_open_settings(inputs)
	return __ja.push_desktop_open_settings(inputs)
});
/**
* | output |
* | --- |
* | "This build cannot show macOS notifications" |
*
* @param {Push_Desktop_UnsignedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_desktop_unsigned = /** @type {((inputs?: Push_Desktop_UnsignedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Desktop_UnsignedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_desktop_unsigned(inputs)
	return __ja.push_desktop_unsigned(inputs)
});
/**
* | output |
* | --- |
* | "Destinations" |
*
* @param {Push_DestinationsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_destinations = /** @type {((inputs?: Push_DestinationsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_DestinationsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_destinations(inputs)
	return __ja.push_destinations(inputs)
});
/**
* | output |
* | --- |
* | "You have a new notification" |
*
* @param {Push_Hub_SealedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_hub_sealed = /** @type {((inputs?: Push_Hub_SealedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Hub_SealedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_hub_sealed(inputs)
	return __ja.push_hub_sealed(inputs)
});
/**
* | output |
* | --- |
* | "Add this app to your Home Screen to get notifications. Use the Share button and choose \"Add to Home Screen\"" |
*
* @param {Push_Ios_Add_To_HomeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_ios_add_to_home = /** @type {((inputs?: Push_Ios_Add_To_HomeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Ios_Add_To_HomeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_ios_add_to_home(inputs)
	return __ja.push_ios_add_to_home(inputs)
});
/**
* | output |
* | --- |
* | "Nothing delivered yet" |
*
* @param {Push_Not_DeliveredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_not_delivered = /** @type {((inputs?: Push_Not_DeliveredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Not_DeliveredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_not_delivered(inputs)
	return __ja.push_not_delivered(inputs)
});
/**
* | output |
* | --- |
* | "It could not be delivered" |
*
* @param {Push_Not_SentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_not_sent = /** @type {((inputs?: Push_Not_SentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Not_SentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_not_sent(inputs)
	return __ja.push_not_sent(inputs)
});
/**
* | output |
* | --- |
* | "Other" |
*
* @param {Push_Other_DeviceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_other_device = /** @type {((inputs?: Push_Other_DeviceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Other_DeviceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_other_device(inputs)
	return __ja.push_other_device(inputs)
});
/**
* | output |
* | --- |
* | "Receive on this device" |
*
* @param {Push_ReceiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_receive = /** @type {((inputs?: Push_ReceiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_ReceiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_receive(inputs)
	return __ja.push_receive(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Push_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_remove = /** @type {((inputs?: Push_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_remove(inputs)
	return __ja.push_remove(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't remove \"{name}\"" |
*
* @param {Push_Remove_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_remove_failed = /** @type {((inputs: Push_Remove_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Remove_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_remove_failed(inputs)
	return __ja.push_remove_failed(inputs)
});
/**
* | output |
* | --- |
* | "Removed \"{name}\"" |
*
* @param {Push_RemovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_removed = /** @type {((inputs: Push_RemovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_RemovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_removed(inputs)
	return __ja.push_removed(inputs)
});
/**
* | output |
* | --- |
* | "Send test" |
*
* @param {Push_Send_TestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_send_test = /** @type {((inputs?: Push_Send_TestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Send_TestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_send_test(inputs)
	return __ja.push_send_test(inputs)
});
/**
* | output |
* | --- |
* | "Sent a test notification" |
*
* @param {Push_SentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_sent = /** @type {((inputs?: Push_SentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_SentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_sent(inputs)
	return __ja.push_sent(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't start receiving notifications" |
*
* @param {Push_Subscribe_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_subscribe_failed = /** @type {((inputs?: Push_Subscribe_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Subscribe_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_subscribe_failed(inputs)
	return __ja.push_subscribe_failed(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't send the test" |
*
* @param {Push_Test_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_test_failed = /** @type {((inputs?: Push_Test_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Test_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_test_failed(inputs)
	return __ja.push_test_failed(inputs)
});
/**
* | output |
* | --- |
* | "This device" |
*
* @param {Push_This_DeviceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_this_device = /** @type {((inputs?: Push_This_DeviceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_This_DeviceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_this_device(inputs)
	return __ja.push_this_device(inputs)
});
/**
* | output |
* | --- |
* | "Notifications aren't available in this environment" |
*
* @param {Push_UnavailableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_unavailable = /** @type {((inputs?: Push_UnavailableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_UnavailableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_unavailable(inputs)
	return __ja.push_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't stop receiving notifications" |
*
* @param {Push_Unsubscribe_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_unsubscribe_failed = /** @type {((inputs?: Push_Unsubscribe_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Unsubscribe_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_unsubscribe_failed(inputs)
	return __ja.push_unsubscribe_failed(inputs)
});
/**
* | output |
* | --- |
* | "This browser doesn't support notifications" |
*
* @param {Push_UnsupportedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const push_unsupported = /** @type {((inputs?: Push_UnsupportedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_UnsupportedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.push_unsupported(inputs)
	return __ja.push_unsupported(inputs)
});
/**
* | output |
* | --- |
* | "Allow" |
*
* @param {Sandboxes_Admin_AllowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_allow = /** @type {((inputs?: Sandboxes_Admin_AllowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_AllowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_allow(inputs)
	return __ja.sandboxes_admin_allow(inputs)
});
/**
* | output |
* | --- |
* | "Allow by email" |
*
* @param {Sandboxes_Admin_Allow_By_EmailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_allow_by_email = /** @type {((inputs?: Sandboxes_Admin_Allow_By_EmailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Allow_By_EmailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_allow_by_email(inputs)
	return __ja.sandboxes_admin_allow_by_email(inputs)
});
/**
* | output |
* | --- |
* | "An email address registered on trameria" |
*
* @param {Sandboxes_Admin_Allow_By_Email_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_allow_by_email_note = /** @type {((inputs?: Sandboxes_Admin_Allow_By_Email_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Allow_By_Email_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_allow_by_email_note(inputs)
	return __ja.sandboxes_admin_allow_by_email_note(inputs)
});
/**
* | output |
* | --- |
* | "Allow development" |
*
* @param {Sandboxes_Admin_Allow_DevInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_allow_dev = /** @type {((inputs?: Sandboxes_Admin_Allow_DevInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Allow_DevInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_allow_dev(inputs)
	return __ja.sandboxes_admin_allow_dev(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't allow" |
*
* @param {Sandboxes_Admin_Allow_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_allow_failed = /** @type {((inputs?: Sandboxes_Admin_Allow_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Allow_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_allow_failed(inputs)
	return __ja.sandboxes_admin_allow_failed(inputs)
});
/**
* | output |
* | --- |
* | "Allowed" |
*
* @param {Sandboxes_Admin_Col_AllowedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_col_allowed = /** @type {((inputs?: Sandboxes_Admin_Col_AllowedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Col_AllowedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_col_allowed(inputs)
	return __ja.sandboxes_admin_col_allowed(inputs)
});
/**
* | output |
* | --- |
* | "Email" |
*
* @param {Sandboxes_Admin_Col_EmailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_col_email = /** @type {((inputs?: Sandboxes_Admin_Col_EmailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Col_EmailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_col_email(inputs)
	return __ja.sandboxes_admin_col_email(inputs)
});
/**
* | output |
* | --- |
* | "Kind" |
*
* @param {Sandboxes_Admin_Col_KindInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_col_kind = /** @type {((inputs?: Sandboxes_Admin_Col_KindInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Col_KindInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_col_kind(inputs)
	return __ja.sandboxes_admin_col_kind(inputs)
});
/**
* | output |
* | --- |
* | "State" |
*
* @param {Sandboxes_Admin_Col_StateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_col_state = /** @type {((inputs?: Sandboxes_Admin_Col_StateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Col_StateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_col_state(inputs)
	return __ja.sandboxes_admin_col_state(inputs)
});
/**
* | output |
* | --- |
* | "People allowed here can make their own trameria cloud. The development one is a sandbox for people who develop, kept apart from the general one. Revoking del..." |
*
* @param {Sandboxes_Admin_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_description = /** @type {((inputs?: Sandboxes_Admin_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_description(inputs)
	return __ja.sandboxes_admin_description(inputs)
});
/**
* | output |
* | --- |
* | "Email address to allow" |
*
* @param {Sandboxes_Admin_Email_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_email_label = /** @type {((inputs?: Sandboxes_Admin_Email_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Email_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_email_label(inputs)
	return __ja.sandboxes_admin_email_label(inputs)
});
/**
* | output |
* | --- |
* | "Nobody is allowed" |
*
* @param {Sandboxes_Admin_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_empty = /** @type {((inputs?: Sandboxes_Admin_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_empty(inputs)
	return __ja.sandboxes_admin_empty(inputs)
});
/**
* | output |
* | --- |
* | "Development" |
*
* @param {Sandboxes_Admin_Kind_DevInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_kind_dev = /** @type {((inputs?: Sandboxes_Admin_Kind_DevInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Kind_DevInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_kind_dev(inputs)
	return __ja.sandboxes_admin_kind_dev(inputs)
});
/**
* | output |
* | --- |
* | "General" |
*
* @param {Sandboxes_Admin_Kind_GeneralInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_kind_general = /** @type {((inputs?: Sandboxes_Admin_Kind_GeneralInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Kind_GeneralInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_kind_general(inputs)
	return __ja.sandboxes_admin_kind_general(inputs)
});
/**
* | output |
* | --- |
* | "Last used {time}" |
*
* @param {Sandboxes_Admin_Last_ActiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_last_active = /** @type {((inputs: Sandboxes_Admin_Last_ActiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Last_ActiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_last_active(inputs)
	return __ja.sandboxes_admin_last_active(inputs)
});
/**
* | output |
* | --- |
* | "(the sum of the limits of awake sandboxes; beyond the budget they wait)" |
*
* @param {Sandboxes_Admin_Memory_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_memory_note = /** @type {((inputs?: Sandboxes_Admin_Memory_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Memory_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_memory_note(inputs)
	return __ja.sandboxes_admin_memory_note(inputs)
});
/**
* | output |
* | --- |
* | "In use {used} GB / budget {budget} GB" |
*
* @param {Sandboxes_Admin_Memory_UsageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_memory_usage = /** @type {((inputs: Sandboxes_Admin_Memory_UsageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Memory_UsageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_memory_usage(inputs)
	return __ja.sandboxes_admin_memory_usage(inputs)
});
/**
* | output |
* | --- |
* | "Not made yet" |
*
* @param {Sandboxes_Admin_Not_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_not_created = /** @type {((inputs?: Sandboxes_Admin_Not_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Not_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_not_created(inputs)
	return __ja.sandboxes_admin_not_created(inputs)
});
/**
* | output |
* | --- |
* | "Revoke" |
*
* @param {Sandboxes_Admin_RevokeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_revoke = /** @type {((inputs?: Sandboxes_Admin_RevokeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_RevokeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_revoke(inputs)
	return __ja.sandboxes_admin_revoke(inputs)
});
/**
* | output |
* | --- |
* | "Revoke the development allowance of “{label}”. Their trameria cloud, if any, is deleted with its disk (the files in the working directory) and logins. Runnin..." |
*
* @param {Sandboxes_Admin_Revoke_Confirm_DevInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_revoke_confirm_dev = /** @type {((inputs: Sandboxes_Admin_Revoke_Confirm_DevInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Revoke_Confirm_DevInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_revoke_confirm_dev(inputs)
	return __ja.sandboxes_admin_revoke_confirm_dev(inputs)
});
/**
* | output |
* | --- |
* | "Revoke the general allowance of “{label}”. Their trameria cloud, if any, is deleted with its disk (the files in the working directory) and logins." |
*
* @param {Sandboxes_Admin_Revoke_Confirm_GeneralInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_revoke_confirm_general = /** @type {((inputs: Sandboxes_Admin_Revoke_Confirm_GeneralInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Revoke_Confirm_GeneralInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_revoke_confirm_general(inputs)
	return __ja.sandboxes_admin_revoke_confirm_general(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't revoke the development allowance of {email}" |
*
* @param {Sandboxes_Admin_Revoke_Failed_DevInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_revoke_failed_dev = /** @type {((inputs: Sandboxes_Admin_Revoke_Failed_DevInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Revoke_Failed_DevInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_revoke_failed_dev(inputs)
	return __ja.sandboxes_admin_revoke_failed_dev(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't revoke the general allowance of {email}" |
*
* @param {Sandboxes_Admin_Revoke_Failed_GeneralInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_revoke_failed_general = /** @type {((inputs: Sandboxes_Admin_Revoke_Failed_GeneralInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Revoke_Failed_GeneralInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_revoke_failed_general(inputs)
	return __ja.sandboxes_admin_revoke_failed_general(inputs)
});
/**
* | output |
* | --- |
* | "Revoke the development allowance of {email}" |
*
* @param {Sandboxes_Admin_Revoke_Label_DevInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_revoke_label_dev = /** @type {((inputs: Sandboxes_Admin_Revoke_Label_DevInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Revoke_Label_DevInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_revoke_label_dev(inputs)
	return __ja.sandboxes_admin_revoke_label_dev(inputs)
});
/**
* | output |
* | --- |
* | "Revoke the general allowance of {email}" |
*
* @param {Sandboxes_Admin_Revoke_Label_GeneralInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_revoke_label_general = /** @type {((inputs: Sandboxes_Admin_Revoke_Label_GeneralInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Revoke_Label_GeneralInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_revoke_label_general(inputs)
	return __ja.sandboxes_admin_revoke_label_general(inputs)
});
/**
* | output |
* | --- |
* | "Revoking · {state}" |
*
* @param {Sandboxes_Admin_Revoking_StateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_revoking_state = /** @type {((inputs: Sandboxes_Admin_Revoking_StateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_Revoking_StateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_revoking_state(inputs)
	return __ja.sandboxes_admin_revoking_state(inputs)
});
/**
* | output |
* | --- |
* | "trameria cloud" |
*
* @param {Sandboxes_Admin_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_admin_title = /** @type {((inputs?: Sandboxes_Admin_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Admin_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_admin_title(inputs)
	return __ja.sandboxes_admin_title(inputs)
});
/**
* | output |
* | --- |
* | "Another sandbox has the same name, so this one can't be made. Tell the operators" |
*
* @param {Sandboxes_Error_CollisionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_error_collision = /** @type {((inputs?: Sandboxes_Error_CollisionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Error_CollisionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_error_collision(inputs)
	return __ja.sandboxes_error_collision(inputs)
});
/**
* | output |
* | --- |
* | "Deleting hasn't finished in {minutes} minutes. It goes on" |
*
* @param {Sandboxes_Error_Delete_TimeoutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_error_delete_timeout = /** @type {((inputs: Sandboxes_Error_Delete_TimeoutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Error_Delete_TimeoutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_error_delete_timeout(inputs)
	return __ja.sandboxes_error_delete_timeout(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't reach the server's environment. It tries again by itself shortly" |
*
* @param {Sandboxes_Error_K8sInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_error_k8s = /** @type {((inputs?: Sandboxes_Error_K8sInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Error_K8sInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_error_k8s(inputs)
	return __ja.sandboxes_error_k8s(inputs)
});
/**
* | output |
* | --- |
* | "No development image is set up. Tell the operators" |
*
* @param {Sandboxes_Error_No_Dev_ImageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_error_no_dev_image = /** @type {((inputs?: Sandboxes_Error_No_Dev_ImageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Error_No_Dev_ImageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_error_no_dev_image(inputs)
	return __ja.sandboxes_error_no_dev_image(inputs)
});
/**
* | output |
* | --- |
* | "Unknown cause ({code})" |
*
* @param {Sandboxes_Error_OtherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_error_other = /** @type {((inputs: Sandboxes_Error_OtherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Error_OtherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_error_other(inputs)
	return __ja.sandboxes_error_other(inputs)
});
/**
* | output |
* | --- |
* | "A sandbox of the other kind is left over, so this one can't start. Tell the operators" |
*
* @param {Sandboxes_Error_Profile_MismatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_error_profile_mismatch = /** @type {((inputs?: Sandboxes_Error_Profile_MismatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Error_Profile_MismatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_error_profile_mismatch(inputs)
	return __ja.sandboxes_error_profile_mismatch(inputs)
});
/**
* | output |
* | --- |
* | "It didn't start within {minutes} minutes. It tries again by itself shortly" |
*
* @param {Sandboxes_Error_Start_TimeoutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_error_start_timeout = /** @type {((inputs: Sandboxes_Error_Start_TimeoutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Error_Start_TimeoutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_error_start_timeout(inputs)
	return __ja.sandboxes_error_start_timeout(inputs)
});
/**
* | output |
* | --- |
* | "It didn't stop within {minutes} minutes" |
*
* @param {Sandboxes_Error_Stop_TimeoutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_error_stop_timeout = /** @type {((inputs: Sandboxes_Error_Stop_TimeoutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Error_Stop_TimeoutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_error_stop_timeout(inputs)
	return __ja.sandboxes_error_stop_timeout(inputs)
});
/**
* | output |
* | --- |
* | "It started, but its agent didn't connect within {minutes} minutes. It tries again by itself shortly" |
*
* @param {Sandboxes_Error_UnreachableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_error_unreachable = /** @type {((inputs: Sandboxes_Error_UnreachableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Error_UnreachableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_error_unreachable(inputs)
	return __ja.sandboxes_error_unreachable(inputs)
});
/**
* | output |
* | --- |
* | "{name} is asleep. Talking to it wakes it" |
*
* @param {Sandboxes_Line_AsleepInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_line_asleep = /** @type {((inputs: Sandboxes_Line_AsleepInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Line_AsleepInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_line_asleep(inputs)
	return __ja.sandboxes_line_asleep(inputs)
});
/**
* | output |
* | --- |
* | "Deleting {name}" |
*
* @param {Sandboxes_Line_DeletingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_line_deleting = /** @type {((inputs: Sandboxes_Line_DeletingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Line_DeletingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_line_deleting(inputs)
	return __ja.sandboxes_line_deleting(inputs)
});
/**
* | output |
* | --- |
* | "{name} isn't working. {error}" |
*
* @param {Sandboxes_Line_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_line_error = /** @type {((inputs: Sandboxes_Line_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Line_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_line_error(inputs)
	return __ja.sandboxes_line_error(inputs)
});
/**
* | output |
* | --- |
* | "Getting {name} ready. What you send arrives once it's ready" |
*
* @param {Sandboxes_Line_PreparingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_line_preparing = /** @type {((inputs: Sandboxes_Line_PreparingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Line_PreparingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_line_preparing(inputs)
	return __ja.sandboxes_line_preparing(inputs)
});
/**
* | output |
* | --- |
* | "{name} is waiting (#{n}) for room on the server and wakes by itself when there is. What you send arrives once it's awake" |
*
* @param {Sandboxes_Line_QueuedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_line_queued = /** @type {((inputs: Sandboxes_Line_QueuedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Line_QueuedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_line_queued(inputs)
	return __ja.sandboxes_line_queued(inputs)
});
/**
* | output |
* | --- |
* | "Waking {name}. What you send arrives once it's awake" |
*
* @param {Sandboxes_Line_WakingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_line_waking = /** @type {((inputs: Sandboxes_Line_WakingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Line_WakingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_line_waking(inputs)
	return __ja.sandboxes_line_waking(inputs)
});
/**
* | output |
* | --- |
* | "Previews" |
*
* @param {Sandboxes_Menu_PreviewsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_menu_previews = /** @type {((inputs?: Sandboxes_Menu_PreviewsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Menu_PreviewsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_menu_previews(inputs)
	return __ja.sandboxes_menu_previews(inputs)
});
/**
* | output |
* | --- |
* | "the development trameria cloud" |
*
* @param {Sandboxes_Name_DevInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_name_dev = /** @type {((inputs?: Sandboxes_Name_DevInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Name_DevInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_name_dev(inputs)
	return __ja.sandboxes_name_dev(inputs)
});
/**
* | output |
* | --- |
* | "trameria cloud" |
*
* @param {Sandboxes_Name_GeneralInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_name_general = /** @type {((inputs?: Sandboxes_Name_GeneralInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Name_GeneralInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_name_general(inputs)
	return __ja.sandboxes_name_general(inputs)
});
/**
* | output |
* | --- |
* | "You may not view this preview." |
*
* @param {Sandboxes_Preview_ForbiddenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_preview_forbidden = /** @type {((inputs?: Sandboxes_Preview_ForbiddenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Preview_ForbiddenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_preview_forbidden(inputs)
	return __ja.sandboxes_preview_forbidden(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't open the preview. Wait a moment and open it again." |
*
* @param {Sandboxes_Preview_Open_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_preview_open_failed = /** @type {((inputs?: Sandboxes_Preview_Open_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Preview_Open_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_preview_open_failed(inputs)
	return __ja.sandboxes_preview_open_failed(inputs)
});
/**
* | output |
* | --- |
* | "Opening the preview…" |
*
* @param {Sandboxes_Preview_OpeningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_preview_opening = /** @type {((inputs?: Sandboxes_Preview_OpeningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Preview_OpeningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_preview_opening(inputs)
	return __ja.sandboxes_preview_opening(inputs)
});
/**
* | output |
* | --- |
* | "Previews running on development trameria clouds. A sleeping sandbox wakes when its owner talks to it or when a preview URL opened before is opened again." |
*
* @param {Sandboxes_Previews_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_description = /** @type {((inputs?: Sandboxes_Previews_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_description(inputs)
	return __ja.sandboxes_previews_description(inputs)
});
/**
* | output |
* | --- |
* | "No development trameria cloud yet" |
*
* @param {Sandboxes_Previews_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_empty = /** @type {((inputs?: Sandboxes_Previews_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_empty(inputs)
	return __ja.sandboxes_previews_empty(inputs)
});
/**
* | output |
* | --- |
* | "Last viewed {time}" |
*
* @param {Sandboxes_Previews_Last_SeenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_last_seen = /** @type {((inputs: Sandboxes_Previews_Last_SeenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_Last_SeenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_last_seen(inputs)
	return __ja.sandboxes_previews_last_seen(inputs)
});
/**
* | output |
* | --- |
* | "No previews running" |
*
* @param {Sandboxes_Previews_None_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_none_running = /** @type {((inputs?: Sandboxes_Previews_None_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_None_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_none_running(inputs)
	return __ja.sandboxes_previews_none_running(inputs)
});
/**
* | output |
* | --- |
* | "Two worktrees make this name" |
*
* @param {Sandboxes_Previews_Status_ConflictInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_status_conflict = /** @type {((inputs?: Sandboxes_Previews_Status_ConflictInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_Status_ConflictInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_status_conflict(inputs)
	return __ja.sandboxes_previews_status_conflict(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't start" |
*
* @param {Sandboxes_Previews_Status_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_status_failed = /** @type {((inputs?: Sandboxes_Previews_Status_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_Status_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_status_failed(inputs)
	return __ja.sandboxes_previews_status_failed(inputs)
});
/**
* | output |
* | --- |
* | "No worktree" |
*
* @param {Sandboxes_Previews_Status_MissingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_status_missing = /** @type {((inputs?: Sandboxes_Previews_Status_MissingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_Status_MissingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_status_missing(inputs)
	return __ja.sandboxes_previews_status_missing(inputs)
});
/**
* | output |
* | --- |
* | "Running" |
*
* @param {Sandboxes_Previews_Status_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_status_running = /** @type {((inputs?: Sandboxes_Previews_Status_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_Status_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_status_running(inputs)
	return __ja.sandboxes_previews_status_running(inputs)
});
/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Sandboxes_Previews_StopInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_stop = /** @type {((inputs?: Sandboxes_Previews_StopInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_StopInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_stop(inputs)
	return __ja.sandboxes_previews_stop(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't stop “{name}”" |
*
* @param {Sandboxes_Previews_Stop_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_stop_failed = /** @type {((inputs: Sandboxes_Previews_Stop_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_Stop_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_stop_failed(inputs)
	return __ja.sandboxes_previews_stop_failed(inputs)
});
/**
* | output |
* | --- |
* | "Stop {name}" |
*
* @param {Sandboxes_Previews_Stop_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_stop_label = /** @type {((inputs: Sandboxes_Previews_Stop_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_Stop_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_stop_label(inputs)
	return __ja.sandboxes_previews_stop_label(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't stop “{name}”. The sandbox isn't running, so there is nothing to stop" |
*
* @param {Sandboxes_Previews_Stop_OfflineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_stop_offline = /** @type {((inputs: Sandboxes_Previews_Stop_OfflineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_Stop_OfflineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_stop_offline(inputs)
	return __ja.sandboxes_previews_stop_offline(inputs)
});
/**
* | output |
* | --- |
* | "Stopping…" |
*
* @param {Sandboxes_Previews_StoppingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_stopping = /** @type {((inputs?: Sandboxes_Previews_StoppingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_StoppingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_stopping(inputs)
	return __ja.sandboxes_previews_stopping(inputs)
});
/**
* | output |
* | --- |
* | "Previews" |
*
* @param {Sandboxes_Previews_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_previews_title = /** @type {((inputs?: Sandboxes_Previews_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Previews_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_previews_title(inputs)
	return __ja.sandboxes_previews_title(inputs)
});
/**
* | output |
* | --- |
* | "Asleep" |
*
* @param {Sandboxes_Status_AsleepInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_status_asleep = /** @type {((inputs?: Sandboxes_Status_AsleepInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Status_AsleepInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_status_asleep(inputs)
	return __ja.sandboxes_status_asleep(inputs)
});
/**
* | output |
* | --- |
* | "Deleting" |
*
* @param {Sandboxes_Status_DeletingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_status_deleting = /** @type {((inputs?: Sandboxes_Status_DeletingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Status_DeletingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_status_deleting(inputs)
	return __ja.sandboxes_status_deleting(inputs)
});
/**
* | output |
* | --- |
* | "Not working" |
*
* @param {Sandboxes_Status_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_status_error = /** @type {((inputs?: Sandboxes_Status_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Status_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_status_error(inputs)
	return __ja.sandboxes_status_error(inputs)
});
/**
* | output |
* | --- |
* | "Getting ready" |
*
* @param {Sandboxes_Status_PreparingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_status_preparing = /** @type {((inputs?: Sandboxes_Status_PreparingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Status_PreparingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_status_preparing(inputs)
	return __ja.sandboxes_status_preparing(inputs)
});
/**
* | output |
* | --- |
* | "Waiting" |
*
* @param {Sandboxes_Status_QueuedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_status_queued = /** @type {((inputs?: Sandboxes_Status_QueuedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Status_QueuedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_status_queued(inputs)
	return __ja.sandboxes_status_queued(inputs)
});
/**
* | output |
* | --- |
* | "Waiting · #{n}" |
*
* @param {Sandboxes_Status_Queued_AtInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_status_queued_at = /** @type {((inputs: Sandboxes_Status_Queued_AtInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Status_Queued_AtInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_status_queued_at(inputs)
	return __ja.sandboxes_status_queued_at(inputs)
});
/**
* | output |
* | --- |
* | "Running" |
*
* @param {Sandboxes_Status_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_status_running = /** @type {((inputs?: Sandboxes_Status_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Status_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_status_running(inputs)
	return __ja.sandboxes_status_running(inputs)
});
/**
* | output |
* | --- |
* | "Waking up" |
*
* @param {Sandboxes_Status_WakingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const sandboxes_status_waking = /** @type {((inputs?: Sandboxes_Status_WakingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Status_WakingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sandboxes_status_waking(inputs)
	return __ja.sandboxes_status_waking(inputs)
});
/**
* | output |
* | --- |
* | "Calls" |
*
* @param {Vc_CallsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_calls = /** @type {((inputs?: Vc_CallsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_CallsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_calls(inputs)
	return __ja.vc_calls(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Vc_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_cancel = /** @type {((inputs?: Vc_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_cancel(inputs)
	return __ja.vc_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Calls are turned off in this space" |
*
* @param {Vc_Close_DisabledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_close_disabled = /** @type {((inputs?: Vc_Close_DisabledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Close_DisabledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_close_disabled(inputs)
	return __ja.vc_close_disabled(inputs)
});
/**
* | output |
* | --- |
* | "Call ended" |
*
* @param {Vc_Close_EndedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_close_ended = /** @type {((inputs?: Vc_Close_EndedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Close_EndedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_close_ended(inputs)
	return __ja.vc_close_ended(inputs)
});
/**
* | output |
* | --- |
* | "Call is full (4 people max)" |
*
* @param {Vc_Close_FullInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_close_full = /** @type {((inputs?: Vc_Close_FullInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Close_FullInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_close_full(inputs)
	return __ja.vc_close_full(inputs)
});
/**
* | output |
* | --- |
* | "Call not found" |
*
* @param {Vc_Close_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_close_not_found = /** @type {((inputs?: Vc_Close_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Close_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_close_not_found(inputs)
	return __ja.vc_close_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Joined in another tab" |
*
* @param {Vc_Close_ReplacedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_close_replaced = /** @type {((inputs?: Vc_Close_ReplacedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Close_ReplacedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_close_replaced(inputs)
	return __ja.vc_close_replaced(inputs)
});
/**
* | output |
* | --- |
* | "Disconnected. Join again." |
*
* @param {Vc_Closed_RejoinInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_closed_rejoin = /** @type {((inputs?: Vc_Closed_RejoinInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Closed_RejoinInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_closed_rejoin(inputs)
	return __ja.vc_closed_rejoin(inputs)
});
/**
* | output |
* | --- |
* | "Disconnected" |
*
* @param {Vc_Conn_ClosedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_conn_closed = /** @type {((inputs?: Vc_Conn_ClosedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Conn_ClosedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_conn_closed(inputs)
	return __ja.vc_conn_closed(inputs)
});
/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Vc_Conn_ConnectedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_conn_connected = /** @type {((inputs?: Vc_Conn_ConnectedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Conn_ConnectedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_conn_connected(inputs)
	return __ja.vc_conn_connected(inputs)
});
/**
* | output |
* | --- |
* | "Connecting" |
*
* @param {Vc_Conn_ConnectingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_conn_connecting = /** @type {((inputs?: Vc_Conn_ConnectingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Conn_ConnectingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_conn_connecting(inputs)
	return __ja.vc_conn_connecting(inputs)
});
/**
* | output |
* | --- |
* | "Can't connect" |
*
* @param {Vc_Conn_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_conn_failed = /** @type {((inputs?: Vc_Conn_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Conn_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_conn_failed(inputs)
	return __ja.vc_conn_failed(inputs)
});
/**
* | output |
* | --- |
* | "Connection unstable" |
*
* @param {Vc_Conn_UnstableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_conn_unstable = /** @type {((inputs?: Vc_Conn_UnstableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Conn_UnstableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_conn_unstable(inputs)
	return __ja.vc_conn_unstable(inputs)
});
/**
* | output |
* | --- |
* | "Noise suppression: Preparing…" |
*
* @param {Vc_Denoise_LoadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_denoise_loading = /** @type {((inputs?: Vc_Denoise_LoadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Denoise_LoadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_denoise_loading(inputs)
	return __ja.vc_denoise_loading(inputs)
});
/**
* | output |
* | --- |
* | "Noise suppression: Off" |
*
* @param {Vc_Denoise_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_denoise_off = /** @type {((inputs?: Vc_Denoise_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Denoise_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_denoise_off(inputs)
	return __ja.vc_denoise_off(inputs)
});
/**
* | output |
* | --- |
* | "Noise suppression: On" |
*
* @param {Vc_Denoise_OnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_denoise_on = /** @type {((inputs?: Vc_Denoise_OnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Denoise_OnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_denoise_on(inputs)
	return __ja.vc_denoise_on(inputs)
});
/**
* | output |
* | --- |
* | "Noise suppression isn't available, so your raw microphone audio is being sent." |
*
* @param {Vc_Denoise_UnavailableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_denoise_unavailable = /** @type {((inputs?: Vc_Denoise_UnavailableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Denoise_UnavailableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_denoise_unavailable(inputs)
	return __ja.vc_denoise_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "{elapsed} elapsed" |
*
* @param {Vc_ElapsedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_elapsed = /** @type {((inputs: Vc_ElapsedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_ElapsedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_elapsed(inputs)
	return __ja.vc_elapsed(inputs)
});
/**
* | output |
* | --- |
* | "No calls yet" |
*
* @param {Vc_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_empty = /** @type {((inputs?: Vc_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_empty(inputs)
	return __ja.vc_empty(inputs)
});
/**
* | output |
* | --- |
* | "End call" |
*
* @param {Vc_EndInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_end = /** @type {((inputs?: Vc_EndInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_EndInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_end(inputs)
	return __ja.vc_end(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't end the call. Try again." |
*
* @param {Vc_End_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_end_failed = /** @type {((inputs?: Vc_End_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_End_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_end_failed(inputs)
	return __ja.vc_end_failed(inputs)
});
/**
* | output |
* | --- |
* | "Ended" |
*
* @param {Vc_Ended_MarkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_ended_mark = /** @type {((inputs?: Vc_Ended_MarkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ended_MarkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_ended_mark(inputs)
	return __ja.vc_ended_mark(inputs)
});
/**
* | output |
* | --- |
* | "{when} · {duration} · {people}" |
*
* @param {Vc_Ended_SubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_ended_sub = /** @type {((inputs: Vc_Ended_SubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ended_SubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_ended_sub(inputs)
	return __ja.vc_ended_sub(inputs)
});
/**
* | output |
* | --- |
* | "Narrow calls" |
*
* @param {Vc_FilterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_filter = /** @type {((inputs?: Vc_FilterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_FilterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_filter(inputs)
	return __ja.vc_filter(inputs)
});
/**
* | output |
* | --- |
* | "All" |
*
* @param {Vc_Filter_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_filter_all = /** @type {((inputs?: Vc_Filter_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Filter_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_filter_all(inputs)
	return __ja.vc_filter_all(inputs)
});
/**
* | output |
* | --- |
* | "History" |
*
* @param {Vc_Filter_EndedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_filter_ended = /** @type {((inputs?: Vc_Filter_EndedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Filter_EndedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_filter_ended(inputs)
	return __ja.vc_filter_ended(inputs)
});
/**
* | output |
* | --- |
* | "In call" |
*
* @param {Vc_Filter_LiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_filter_live = /** @type {((inputs?: Vc_Filter_LiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Filter_LiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_filter_live(inputs)
	return __ja.vc_filter_live(inputs)
});
/**
* | output |
* | --- |
* | "Join" |
*
* @param {Vc_JoinInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_join = /** @type {((inputs?: Vc_JoinInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_JoinInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_join(inputs)
	return __ja.vc_join(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't prepare the connection. Try again." |
*
* @param {Vc_Join_Prepare_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_join_prepare_failed = /** @type {((inputs?: Vc_Join_Prepare_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Join_Prepare_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_join_prepare_failed(inputs)
	return __ja.vc_join_prepare_failed(inputs)
});
/**
* | output |
* | --- |
* | "Call you're in: {title}" |
*
* @param {Vc_Joined_AriaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_joined_aria = /** @type {((inputs: Vc_Joined_AriaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Joined_AriaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_joined_aria(inputs)
	return __ja.vc_joined_aria(inputs)
});
/**
* | output |
* | --- |
* | "Leave" |
*
* @param {Vc_LeaveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_leave = /** @type {((inputs?: Vc_LeaveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_LeaveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_leave(inputs)
	return __ja.vc_leave(inputs)
});
/**
* | output |
* | --- |
* | "In call" |
*
* @param {Vc_Live_MarkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_live_mark = /** @type {((inputs?: Vc_Live_MarkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Live_MarkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_live_mark(inputs)
	return __ja.vc_live_mark(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load the calls" |
*
* @param {Vc_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_load_failed = /** @type {((inputs?: Vc_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_load_failed(inputs)
	return __ja.vc_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Microphone access is needed. Allow it in your browser settings, then try again." |
*
* @param {Vc_Mic_DeniedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_mic_denied = /** @type {((inputs?: Vc_Mic_DeniedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Mic_DeniedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_mic_denied(inputs)
	return __ja.vc_mic_denied(inputs)
});
/**
* | output |
* | --- |
* | "{min} min" |
*
* @param {Vc_MinutesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_minutes = /** @type {((inputs: Vc_MinutesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_MinutesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_minutes(inputs)
	return __ja.vc_minutes(inputs)
});
/**
* | output |
* | --- |
* | "Mute" |
*
* @param {Vc_MuteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_mute = /** @type {((inputs?: Vc_MuteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_MuteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_mute(inputs)
	return __ja.vc_mute(inputs)
});
/**
* | output |
* | --- |
* | "Muted" |
*
* @param {Vc_MutedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_muted = /** @type {((inputs?: Vc_MutedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_MutedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_muted(inputs)
	return __ja.vc_muted(inputs)
});
/**
* | output |
* | --- |
* | "Narrow calls" |
*
* @param {Vc_NarrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_narrow = /** @type {((inputs?: Vc_NarrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_NarrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_narrow(inputs)
	return __ja.vc_narrow(inputs)
});
/**
* | output |
* | --- |
* | "Narrow by title" |
*
* @param {Vc_Narrow_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_narrow_title = /** @type {((inputs?: Vc_Narrow_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Narrow_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_narrow_title(inputs)
	return __ja.vc_narrow_title(inputs)
});
/**
* | output |
* | --- |
* | "New call" |
*
* @param {Vc_New_CallInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_new_call = /** @type {((inputs?: Vc_New_CallInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_New_CallInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_new_call(inputs)
	return __ja.vc_new_call(inputs)
});
/**
* | output |
* | --- |
* | "A throwaway call. Up to 4 people. Audio isn't saved." |
*
* @param {Vc_New_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_new_note = /** @type {((inputs?: Vc_New_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_New_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_new_note(inputs)
	return __ja.vc_new_note(inputs)
});
/**
* | output |
* | --- |
* | "No space can have calls" |
*
* @param {Vc_No_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_no_space = /** @type {((inputs?: Vc_No_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_No_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_no_space(inputs)
	return __ja.vc_no_space(inputs)
});
/**
* | output |
* | --- |
* | "No one yet" |
*
* @param {Vc_NobodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_nobody = /** @type {((inputs?: Vc_NobodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_NobodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_nobody(inputs)
	return __ja.vc_nobody(inputs)
});
/**
* | output |
* | --- |
* | "No calls match" |
*
* @param {Vc_None_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_none_match = /** @type {((inputs?: Vc_None_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_None_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_none_match(inputs)
	return __ja.vc_none_match(inputs)
});
/**
* | output |
* | --- |
* | "This call can't be found" |
*
* @param {Vc_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_not_found = /** @type {((inputs?: Vc_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_not_found(inputs)
	return __ja.vc_not_found(inputs)
});
/**
* | output |
* | --- |
* | "This call has ended. The audio wasn't saved." |
*
* @param {Vc_Note_EndedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_note_ended = /** @type {((inputs?: Vc_Note_EndedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Note_EndedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_note_ended(inputs)
	return __ja.vc_note_ended(inputs)
});
/**
* | output |
* | --- |
* | "A throwaway call. It disappears when closed. Write down anything you want to keep in a Topic." |
*
* @param {Vc_Note_LiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_note_live = /** @type {((inputs?: Vc_Note_LiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Note_LiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_note_live(inputs)
	return __ja.vc_note_live(inputs)
});
/**
* | output |
* | --- |
* | "Your screen (this is what others see)" |
*
* @param {Vc_Own_ScreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_own_screen = /** @type {((inputs?: Vc_Own_ScreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Own_ScreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_own_screen(inputs)
	return __ja.vc_own_screen(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} person" |
* | "other" | "{count} people" |
*
* @param {Vc_PeopleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_people = /** @type {((inputs: Vc_PeopleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_PeopleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_people(inputs)
	return __ja.vc_people(inputs)
});
/**
* | output |
* | --- |
* | "Play audio" |
*
* @param {Vc_Play_AudioInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_play_audio = /** @type {((inputs?: Vc_Play_AudioInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Play_AudioInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_play_audio(inputs)
	return __ja.vc_play_audio(inputs)
});
/**
* | output |
* | --- |
* | "Reconnecting" |
*
* @param {Vc_ReconnectingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_reconnecting = /** @type {((inputs?: Vc_ReconnectingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_ReconnectingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_reconnecting(inputs)
	return __ja.vc_reconnecting(inputs)
});
/**
* | output |
* | --- |
* | "{name}'s screen" |
*
* @param {Vc_Screen_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_screen_of = /** @type {((inputs: Vc_Screen_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Screen_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_screen_of(inputs)
	return __ja.vc_screen_of(inputs)
});
/**
* | output |
* | --- |
* | "(you)" |
*
* @param {Vc_Self_SuffixInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_self_suffix = /** @type {((inputs?: Vc_Self_SuffixInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Self_SuffixInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_self_suffix(inputs)
	return __ja.vc_self_suffix(inputs)
});
/**
* | output |
* | --- |
* | "Share screen" |
*
* @param {Vc_Share_ScreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_share_screen = /** @type {((inputs?: Vc_Share_ScreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Share_ScreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_share_screen(inputs)
	return __ja.vc_share_screen(inputs)
});
/**
* | output |
* | --- |
* | "Sharing screen" |
*
* @param {Vc_SharingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_sharing = /** @type {((inputs?: Vc_SharingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_SharingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_sharing(inputs)
	return __ja.vc_sharing(inputs)
});
/**
* | output |
* | --- |
* | "Space" |
*
* @param {Vc_Space_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_space_label = /** @type {((inputs?: Vc_Space_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Space_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_space_label(inputs)
	return __ja.vc_space_label(inputs)
});
/**
* | output |
* | --- |
* | "Start call" |
*
* @param {Vc_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_start = /** @type {((inputs?: Vc_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_start(inputs)
	return __ja.vc_start(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't start the call. Try again." |
*
* @param {Vc_Start_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_start_failed = /** @type {((inputs?: Vc_Start_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Start_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_start_failed(inputs)
	return __ja.vc_start_failed(inputs)
});
/**
* | output |
* | --- |
* | "Stop sharing" |
*
* @param {Vc_Stop_SharingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_stop_sharing = /** @type {((inputs?: Vc_Stop_SharingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Stop_SharingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_stop_sharing(inputs)
	return __ja.vc_stop_sharing(inputs)
});
/**
* | output |
* | --- |
* | "Call title" |
*
* @param {Vc_Title_AriaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_title_aria = /** @type {((inputs?: Vc_Title_AriaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Title_AriaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_title_aria(inputs)
	return __ja.vc_title_aria(inputs)
});
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Vc_Title_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_title_label = /** @type {((inputs?: Vc_Title_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Title_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_title_label(inputs)
	return __ja.vc_title_label(inputs)
});
/**
* | output |
* | --- |
* | "What's it about?" |
*
* @param {Vc_Title_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_title_placeholder = /** @type {((inputs?: Vc_Title_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Title_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_title_placeholder(inputs)
	return __ja.vc_title_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Back to list" |
*
* @param {Vc_To_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_to_list = /** @type {((inputs?: Vc_To_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_To_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_to_list(inputs)
	return __ja.vc_to_list(inputs)
});
/**
* | output |
* | --- |
* | "Former member" |
*
* @param {Vc_Unknown_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_unknown_member = /** @type {((inputs?: Vc_Unknown_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Unknown_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_unknown_member(inputs)
	return __ja.vc_unknown_member(inputs)
});
/**
* | output |
* | --- |
* | "Unmute" |
*
* @param {Vc_UnmuteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_unmute = /** @type {((inputs?: Vc_UnmuteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_UnmuteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_unmute(inputs)
	return __ja.vc_unmute(inputs)
});
/**
* | output |
* | --- |
* | "Waiting for video" |
*
* @param {Vc_Waiting_VideoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const vc_waiting_video = /** @type {((inputs?: Vc_Waiting_VideoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Waiting_VideoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.vc_waiting_video(inputs)
	return __ja.vc_waiting_video(inputs)
});
/**
* | output |
* | --- |
* | "Space" |
*
* @param {Wd_Col_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_col_space = /** @type {((inputs?: Wd_Col_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Col_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_col_space(inputs)
	return __ja.wd_col_space(inputs)
});
/**
* | output |
* | --- |
* | "Dataset" |
*
* @param {Wd_DatasetsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets = /** @type {((inputs?: Wd_DatasetsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_DatasetsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets(inputs)
	return __ja.wd_datasets(inputs)
});
/**
* | output |
* | --- |
* | "Back to Documents" |
*
* @param {Wd_Datasets_BackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_back = /** @type {((inputs?: Wd_Datasets_BackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_BackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_back(inputs)
	return __ja.wd_datasets_back(inputs)
});
/**
* | output |
* | --- |
* | "Create" |
*
* @param {Wd_Datasets_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_create = /** @type {((inputs?: Wd_Datasets_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_create(inputs)
	return __ja.wd_datasets_create(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't create the dataset" |
*
* @param {Wd_Datasets_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_create_failed = /** @type {((inputs?: Wd_Datasets_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_create_failed(inputs)
	return __ja.wd_datasets_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "No datasets yet." |
*
* @param {Wd_Datasets_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_empty = /** @type {((inputs?: Wd_Datasets_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_empty(inputs)
	return __ja.wd_datasets_empty(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load the datasets" |
*
* @param {Wd_Datasets_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_load_failed = /** @type {((inputs?: Wd_Datasets_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_load_failed(inputs)
	return __ja.wd_datasets_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "New dataset" |
*
* @param {Wd_Datasets_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_new = /** @type {((inputs?: Wd_Datasets_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_new(inputs)
	return __ja.wd_datasets_new(inputs)
});
/**
* | output |
* | --- |
* | "Keeps the JSON rows that scripts and agents send. Fields are guessed from the rows received; ask an agent to set fields or a retention period ahead." |
*
* @param {Wd_Datasets_New_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_new_note = /** @type {((inputs?: Wd_Datasets_New_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_New_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_new_note(inputs)
	return __ja.wd_datasets_new_note(inputs)
});
/**
* | output |
* | --- |
* | "No datasets match." |
*
* @param {Wd_Datasets_None_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_none_match = /** @type {((inputs?: Wd_Datasets_None_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_None_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_none_match(inputs)
	return __ja.wd_datasets_none_match(inputs)
});
/**
* | output |
* | --- |
* | "{count} rows" |
*
* @param {Wd_Datasets_RowsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_rows = /** @type {((inputs: Wd_Datasets_RowsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_RowsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_rows(inputs)
	return __ja.wd_datasets_rows(inputs)
});
/**
* | output |
* | --- |
* | "Space" |
*
* @param {Wd_Datasets_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_space = /** @type {((inputs?: Wd_Datasets_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_space(inputs)
	return __ja.wd_datasets_space(inputs)
});
/**
* | output |
* | --- |
* | "No datasets yet." |
*
* @param {Wd_Datasets_Space_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_space_empty = /** @type {((inputs?: Wd_Datasets_Space_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_Space_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_space_empty(inputs)
	return __ja.wd_datasets_space_empty(inputs)
});
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Wd_Datasets_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_datasets_title = /** @type {((inputs?: Wd_Datasets_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Datasets_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_datasets_title(inputs)
	return __ja.wd_datasets_title(inputs)
});
/**
* | output |
* | --- |
* | "No documents yet." |
*
* @param {Wd_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_empty = /** @type {((inputs?: Wd_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_empty(inputs)
	return __ja.wd_empty(inputs)
});
/**
* | output |
* | --- |
* | "Could not load the documents" |
*
* @param {Wd_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_load_failed = /** @type {((inputs?: Wd_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_load_failed(inputs)
	return __ja.wd_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Could not move “{title}”" |
*
* @param {Wd_Move_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_move_failed = /** @type {((inputs: Wd_Move_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Move_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_move_failed(inputs)
	return __ja.wd_move_failed(inputs)
});
/**
* | output |
* | --- |
* | "Only those who see the space it moves to will see it." |
*
* @param {Wd_Move_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_move_hint = /** @type {((inputs?: Wd_Move_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Move_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_move_hint(inputs)
	return __ja.wd_move_hint(inputs)
});
/**
* | output |
* | --- |
* | "Move “{title}” to another space" |
*
* @param {Wd_Move_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_move_title = /** @type {((inputs: Wd_Move_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Move_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_move_title(inputs)
	return __ja.wd_move_title(inputs)
});
/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Wd_NavInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_nav = /** @type {((inputs?: Wd_NavInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_NavInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_nav(inputs)
	return __ja.wd_nav(inputs)
});
/**
* | output |
* | --- |
* | "Space to make it in" |
*
* @param {Wd_New_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_new_in = /** @type {((inputs?: Wd_New_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_New_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_new_in(inputs)
	return __ja.wd_new_in(inputs)
});
/**
* | output |
* | --- |
* | "No space can hold documents." |
*
* @param {Wd_No_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_no_space = /** @type {((inputs?: Wd_No_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_No_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_no_space(inputs)
	return __ja.wd_no_space(inputs)
});
/**
* | output |
* | --- |
* | "No documents match." |
*
* @param {Wd_None_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_none_match = /** @type {((inputs?: Wd_None_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_None_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_none_match(inputs)
	return __ja.wd_none_match(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the pin of “{title}”" |
*
* @param {Wd_Pin_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_pin_failed = /** @type {((inputs: Wd_Pin_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Pin_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_pin_failed(inputs)
	return __ja.wd_pin_failed(inputs)
});
/**
* | output |
* | --- |
* | "Move to a workspace" |
*
* @param {Wd_ReleaseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_release = /** @type {((inputs?: Wd_ReleaseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_ReleaseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_release(inputs)
	return __ja.wd_release(inputs)
});
/**
* | output |
* | --- |
* | "Move" |
*
* @param {Wd_Release_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_release_action = /** @type {((inputs?: Wd_Release_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Release_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_release_action(inputs)
	return __ja.wd_release_action(inputs)
});
/**
* | output |
* | --- |
* | "Once moved, those who see the chosen space can read it and those who may write documents in the workspace can write it. It leaves your indexes and its public..." |
*
* @param {Wd_Release_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_release_body = /** @type {((inputs?: Wd_Release_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Release_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_release_body(inputs)
	return __ja.wd_release_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not move “{title}”" |
*
* @param {Wd_Release_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_release_failed = /** @type {((inputs: Wd_Release_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Release_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_release_failed(inputs)
	return __ja.wd_release_failed(inputs)
});
/**
* | output |
* | --- |
* | "This workspace has no space where you can write documents." |
*
* @param {Wd_Release_No_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_release_no_space = /** @type {((inputs?: Wd_Release_No_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Release_No_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_release_no_space(inputs)
	return __ja.wd_release_no_space(inputs)
});
/**
* | output |
* | --- |
* | "No workspace to move it to." |
*
* @param {Wd_Release_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_release_none = /** @type {((inputs?: Wd_Release_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Release_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_release_none(inputs)
	return __ja.wd_release_none(inputs)
});
/**
* | output |
* | --- |
* | "Space" |
*
* @param {Wd_Release_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_release_space = /** @type {((inputs?: Wd_Release_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Release_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_release_space(inputs)
	return __ja.wd_release_space(inputs)
});
/**
* | output |
* | --- |
* | "Move “{title}” to a workspace" |
*
* @param {Wd_Release_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_release_title = /** @type {((inputs: Wd_Release_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Release_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_release_title(inputs)
	return __ja.wd_release_title(inputs)
});
/**
* | output |
* | --- |
* | "Workspace" |
*
* @param {Wd_Release_WorkspaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_release_workspace = /** @type {((inputs?: Wd_Release_WorkspaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Release_WorkspaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_release_workspace(inputs)
	return __ja.wd_release_workspace(inputs)
});
/**
* | output |
* | --- |
* | "Moved “{title}” to {workspace}" |
*
* @param {Wd_ReleasedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_released = /** @type {((inputs: Wd_ReleasedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_ReleasedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_released(inputs)
	return __ja.wd_released(inputs)
});
/**
* | output |
* | --- |
* | "No documents yet." |
*
* @param {Wd_Space_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const wd_space_empty = /** @type {((inputs?: Wd_Space_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Space_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.wd_space_empty(inputs)
	return __ja.wd_space_empty(inputs)
});
/**
* | output |
* | --- |
* | "Pages only for the people who run trameria." |
*
* @param {Web_Admin_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_description = /** @type {((inputs?: Web_Admin_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_description(inputs)
	return __ja.web_admin_description(inputs)
});
/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Web_Admin_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_title = /** @type {((inputs?: Web_Admin_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_title(inputs)
	return __ja.web_admin_title(inputs)
});
/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Web_Admin_Waitlist_ApproveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_approve = /** @type {((inputs?: Web_Admin_Waitlist_ApproveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_ApproveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_approve(inputs)
	return __ja.web_admin_waitlist_approve(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't approve" |
*
* @param {Web_Admin_Waitlist_Approve_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_approve_failed = /** @type {((inputs?: Web_Admin_Waitlist_Approve_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_Approve_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_approve_failed(inputs)
	return __ja.web_admin_waitlist_approve_failed(inputs)
});
/**
* | output |
* | --- |
* | "Approved {count} and mailed them" |
*
* @param {Web_Admin_Waitlist_Approved_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_approved_done = /** @type {((inputs: Web_Admin_Waitlist_Approved_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_Approved_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_approved_done(inputs)
	return __ja.web_admin_waitlist_approved_done(inputs)
});
/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Web_Admin_Waitlist_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_clear = /** @type {((inputs?: Web_Admin_Waitlist_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_clear(inputs)
	return __ja.web_admin_waitlist_clear(inputs)
});
/**
* | output |
* | --- |
* | "Email" |
*
* @param {Web_Admin_Waitlist_Col_EmailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_col_email = /** @type {((inputs?: Web_Admin_Waitlist_Col_EmailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_Col_EmailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_col_email(inputs)
	return __ja.web_admin_waitlist_col_email(inputs)
});
/**
* | output |
* | --- |
* | "Joined" |
*
* @param {Web_Admin_Waitlist_Col_JoinedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_col_joined = /** @type {((inputs?: Web_Admin_Waitlist_Col_JoinedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_Col_JoinedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_col_joined(inputs)
	return __ja.web_admin_waitlist_col_joined(inputs)
});
/**
* | output |
* | --- |
* | "Via" |
*
* @param {Web_Admin_Waitlist_Col_ViaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_col_via = /** @type {((inputs?: Web_Admin_Waitlist_Col_ViaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_Col_ViaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_col_via(inputs)
	return __ja.web_admin_waitlist_col_via(inputs)
});
/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Web_Admin_Waitlist_Confirm_ApproveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_confirm_approve = /** @type {((inputs?: Web_Admin_Waitlist_Confirm_ApproveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_Confirm_ApproveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_confirm_approve(inputs)
	return __ja.web_admin_waitlist_confirm_approve(inputs)
});
/**
* | output |
* | --- |
* | "This mails {count} people that they can sign in" |
*
* @param {Web_Admin_Waitlist_Confirm_TextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_confirm_text = /** @type {((inputs: Web_Admin_Waitlist_Confirm_TextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_Confirm_TextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_confirm_text(inputs)
	return __ja.web_admin_waitlist_confirm_text(inputs)
});
/**
* | output |
* | --- |
* | "Approving mails the person that they can now sign in." |
*
* @param {Web_Admin_Waitlist_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_description = /** @type {((inputs?: Web_Admin_Waitlist_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_description(inputs)
	return __ja.web_admin_waitlist_description(inputs)
});
/**
* | output |
* | --- |
* | "Nobody is waiting" |
*
* @param {Web_Admin_Waitlist_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_empty = /** @type {((inputs?: Web_Admin_Waitlist_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_empty(inputs)
	return __ja.web_admin_waitlist_empty(inputs)
});
/**
* | output |
* | --- |
* | "Select all" |
*
* @param {Web_Admin_Waitlist_Select_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_select_all = /** @type {((inputs?: Web_Admin_Waitlist_Select_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_Select_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_select_all(inputs)
	return __ja.web_admin_waitlist_select_all(inputs)
});
/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Web_Admin_Waitlist_SelectedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_selected = /** @type {((inputs: Web_Admin_Waitlist_SelectedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_SelectedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_selected(inputs)
	return __ja.web_admin_waitlist_selected(inputs)
});
/**
* | output |
* | --- |
* | "Waitlist" |
*
* @param {Web_Admin_Waitlist_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_title = /** @type {((inputs?: Web_Admin_Waitlist_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_title(inputs)
	return __ja.web_admin_waitlist_title(inputs)
});
/**
* | output |
* | --- |
* | "Actions for the selection" |
*
* @param {Web_Admin_Waitlist_ToolbarInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_toolbar = /** @type {((inputs?: Web_Admin_Waitlist_ToolbarInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_ToolbarInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_toolbar(inputs)
	return __ja.web_admin_waitlist_toolbar(inputs)
});
/**
* | output |
* | --- |
* | "Email" |
*
* @param {Web_Admin_Waitlist_Via_EmailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_admin_waitlist_via_email = /** @type {((inputs?: Web_Admin_Waitlist_Via_EmailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Admin_Waitlist_Via_EmailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_admin_waitlist_via_email(inputs)
	return __ja.web_admin_waitlist_via_email(inputs)
});
/**
* | output |
* | --- |
* | "Load the new version" |
*
* @param {Web_App_Update_LoadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_app_update_load = /** @type {((inputs?: Web_App_Update_LoadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_App_Update_LoadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_app_update_load(inputs)
	return __ja.web_app_update_load(inputs)
});
/**
* | output |
* | --- |
* | "This account has been suspended. If you don't know why, contact the operator" |
*
* @param {Web_BannedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_banned = /** @type {((inputs?: Web_BannedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_BannedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_banned(inputs)
	return __ja.web_banned(inputs)
});
/**
* | output |
* | --- |
* | "The check failed. Try again" |
*
* @param {Web_Captcha_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_captcha_failed = /** @type {((inputs?: Web_Captcha_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Captcha_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_captcha_failed(inputs)
	return __ja.web_captcha_failed(inputs)
});
/**
* | output |
* | --- |
* | "Home screen icon" |
*
* @param {Web_Home_IconInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon = /** @type {((inputs?: Web_Home_IconInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_IconInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon(inputs)
	return __ja.web_home_icon(inputs)
});
/**
* | output |
* | --- |
* | "Black" |
*
* @param {Web_Home_Icon_BlackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_black = /** @type {((inputs?: Web_Home_Icon_BlackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_BlackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_black(inputs)
	return __ja.web_home_icon_black(inputs)
});
/**
* | output |
* | --- |
* | "Green" |
*
* @param {Web_Home_Icon_GreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_green = /** @type {((inputs?: Web_Home_Icon_GreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_GreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_green(inputs)
	return __ja.web_home_icon_green(inputs)
});
/**
* | output |
* | --- |
* | "Black ground" |
*
* @param {Web_Home_Icon_Ground_BlackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_ground_black = /** @type {((inputs?: Web_Home_Icon_Ground_BlackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_Ground_BlackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_ground_black(inputs)
	return __ja.web_home_icon_ground_black(inputs)
});
/**
* | output |
* | --- |
* | "White ground" |
*
* @param {Web_Home_Icon_Ground_WhiteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_ground_white = /** @type {((inputs?: Web_Home_Icon_Ground_WhiteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_Ground_WhiteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_ground_white(inputs)
	return __ja.web_home_icon_ground_white(inputs)
});
/**
* | output |
* | --- |
* | "Ink" |
*
* @param {Web_Home_Icon_InkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_ink = /** @type {((inputs?: Web_Home_Icon_InkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_InkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_ink(inputs)
	return __ja.web_home_icon_ink(inputs)
});
/**
* | output |
* | --- |
* | "The color and ground used when you add trameria to your home screen. Saved in this browser. Icons already added don't change; add it again after switching." |
*
* @param {Web_Home_Icon_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_note = /** @type {((inputs?: Web_Home_Icon_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_note(inputs)
	return __ja.web_home_icon_note(inputs)
});
/**
* | output |
* | --- |
* | "Purple" |
*
* @param {Web_Home_Icon_PurpleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_purple = /** @type {((inputs?: Web_Home_Icon_PurpleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_PurpleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_purple(inputs)
	return __ja.web_home_icon_purple(inputs)
});
/**
* | output |
* | --- |
* | "Standard" |
*
* @param {Web_Home_Icon_StandardInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_standard = /** @type {((inputs?: Web_Home_Icon_StandardInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_StandardInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_standard(inputs)
	return __ja.web_home_icon_standard(inputs)
});
/**
* | output |
* | --- |
* | "Vermilion" |
*
* @param {Web_Home_Icon_VermilionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_vermilion = /** @type {((inputs?: Web_Home_Icon_VermilionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_VermilionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_vermilion(inputs)
	return __ja.web_home_icon_vermilion(inputs)
});
/**
* | output |
* | --- |
* | "White" |
*
* @param {Web_Home_Icon_WhiteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_home_icon_white = /** @type {((inputs?: Web_Home_Icon_WhiteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Home_Icon_WhiteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_home_icon_white(inputs)
	return __ja.web_home_icon_white(inputs)
});
/**
* | output |
* | --- |
* | "Link" |
*
* @param {Web_Hub_AllowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_allow = /** @type {((inputs?: Web_Hub_AllowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_AllowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_allow(inputs)
	return __ja.web_hub_allow(inputs)
});
/**
* | output |
* | --- |
* | "The code your Vault or PC shows" |
*
* @param {Web_Hub_Code_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_code_label = /** @type {((inputs?: Web_Hub_Code_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Code_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_code_label(inputs)
	return __ja.web_hub_code_label(inputs)
});
/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Web_Hub_Code_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_code_next = /** @type {((inputs?: Web_Hub_Code_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Code_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_code_next(inputs)
	return __ja.web_hub_code_next(inputs)
});
/**
* | output |
* | --- |
* | "The Vault ({name}) asks to be linked to this account." |
*
* @param {Web_Hub_ConnectingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_connecting = /** @type {((inputs: Web_Hub_ConnectingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_ConnectingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_connecting(inputs)
	return __ja.web_hub_connecting(inputs)
});
/**
* | output |
* | --- |
* | "Denied. The Vault is not linked." |
*
* @param {Web_Hub_DeniedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_denied = /** @type {((inputs?: Web_Hub_DeniedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_DeniedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_denied(inputs)
	return __ja.web_hub_denied(inputs)
});
/**
* | output |
* | --- |
* | "Deny" |
*
* @param {Web_Hub_DenyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_deny = /** @type {((inputs?: Web_Hub_DenyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_DenyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_deny(inputs)
	return __ja.web_hub_deny(inputs)
});
/**
* | output |
* | --- |
* | "The PC “{name}” asks to be linked to this account." |
*
* @param {Web_Hub_Desktop_ConnectingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_desktop_connecting = /** @type {((inputs: Web_Hub_Desktop_ConnectingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Desktop_ConnectingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_desktop_connecting(inputs)
	return __ja.web_hub_desktop_connecting(inputs)
});
/**
* | output |
* | --- |
* | "Denied. The PC is not linked." |
*
* @param {Web_Hub_Desktop_DeniedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_desktop_denied = /** @type {((inputs?: Web_Hub_Desktop_DeniedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Desktop_DeniedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_desktop_denied(inputs)
	return __ja.web_hub_desktop_denied(inputs)
});
/**
* | output |
* | --- |
* | "Linked. Go back to your PC." |
*
* @param {Web_Hub_Desktop_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_desktop_done = /** @type {((inputs?: Web_Hub_Desktop_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Desktop_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_desktop_done(inputs)
	return __ja.web_hub_desktop_done(inputs)
});
/**
* | output |
* | --- |
* | "Once linked, this PC can use this account's Cloud by itself, until it signs out there." |
*
* @param {Web_Hub_Desktop_WhatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_desktop_what = /** @type {((inputs?: Web_Hub_Desktop_WhatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Desktop_WhatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_desktop_what(inputs)
	return __ja.web_hub_desktop_what(inputs)
});
/**
* | output |
* | --- |
* | "Linked. Go back to your Vault." |
*
* @param {Web_Hub_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_done = /** @type {((inputs?: Web_Hub_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_done(inputs)
	return __ja.web_hub_done(inputs)
});
/**
* | output |
* | --- |
* | "Could not link" |
*
* @param {Web_Hub_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_failed = /** @type {((inputs?: Web_Hub_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_failed(inputs)
	return __ja.web_hub_failed(inputs)
});
/**
* | output |
* | --- |
* | "The code was not found or has expired. Start again on the Vault or PC." |
*
* @param {Web_Hub_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_not_found = /** @type {((inputs?: Web_Hub_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_not_found(inputs)
	return __ja.web_hub_not_found(inputs)
});
/**
* | output |
* | --- |
* | "On a PC, enter the code shown on the Vault's screen in Trameria's \"Join a Vault\"." |
*
* @param {Web_Hub_Pair_PcInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_pair_pc = /** @type {((inputs?: Web_Hub_Pair_PcInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Pair_PcInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_pair_pc(inputs)
	return __ja.web_hub_pair_pc(inputs)
});
/**
* | output |
* | --- |
* | "On iPhone and iPad this opens in the Trameria app. If the app didn't open, install it and scan the QR code again." |
*
* @param {Web_Hub_Pair_PhoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_pair_phone = /** @type {((inputs?: Web_Hub_Pair_PhoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Pair_PhoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_pair_phone(inputs)
	return __ja.web_hub_pair_phone(inputs)
});
/**
* | output |
* | --- |
* | "Connect to a Vault" |
*
* @param {Web_Hub_Pair_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_pair_title = /** @type {((inputs?: Web_Hub_Pair_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Pair_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_pair_title(inputs)
	return __ja.web_hub_pair_title(inputs)
});
/**
* | output |
* | --- |
* | "Started: {time}" |
*
* @param {Web_Hub_Started_AtInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_started_at = /** @type {((inputs: Web_Hub_Started_AtInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Started_AtInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_started_at(inputs)
	return __ja.web_hub_started_at(inputs)
});
/**
* | output |
* | --- |
* | "From: {place}" |
*
* @param {Web_Hub_Started_FromInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_started_from = /** @type {((inputs: Web_Hub_Started_FromInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Started_FromInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_started_from(inputs)
	return __ja.web_hub_started_from(inputs)
});
/**
* | output |
* | --- |
* | "Link to your account" |
*
* @param {Web_Hub_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_title = /** @type {((inputs?: Web_Hub_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_title(inputs)
	return __ja.web_hub_title(inputs)
});
/**
* | output |
* | --- |
* | "This link was started somewhere other than the network you are on now. If you started it yourself, enter the code your Vault or PC shows." |
*
* @param {Web_Hub_Type_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_type_code = /** @type {((inputs?: Web_Hub_Type_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_Type_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_type_code(inputs)
	return __ja.web_hub_type_code(inputs)
});
/**
* | output |
* | --- |
* | "Don't link it unless you started this yourself" |
*
* @param {Web_Hub_WarningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_warning = /** @type {((inputs?: Web_Hub_WarningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_WarningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_warning(inputs)
	return __ja.web_hub_warning(inputs)
});
/**
* | output |
* | --- |
* | "Once linked, this account owns the Vault. Until it is unlinked on the Vault, it cannot be linked to another account." |
*
* @param {Web_Hub_WhatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_hub_what = /** @type {((inputs?: Web_Hub_WhatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Hub_WhatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_hub_what(inputs)
	return __ja.web_hub_what(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load" |
*
* @param {Web_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_load_failed = /** @type {((inputs?: Web_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_load_failed(inputs)
	return __ja.web_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't send the mail. Try again later" |
*
* @param {Web_Mail_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_mail_failed = /** @type {((inputs?: Web_Mail_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Mail_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_mail_failed(inputs)
	return __ja.web_mail_failed(inputs)
});
/**
* | output |
* | --- |
* | "Personal data is moving between the cloud and the Vault. Until it is done, personal data cannot be opened here. The workspaces work as before." |
*
* @param {Web_Me_Moving_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_me_moving_body = /** @type {((inputs?: Web_Me_Moving_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Me_Moving_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_me_moving_body(inputs)
	return __ja.web_me_moving_body(inputs)
});
/**
* | output |
* | --- |
* | "Open this PC's screen" |
*
* @param {Web_Me_Moving_Open_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_me_moving_open_here = /** @type {((inputs?: Web_Me_Moving_Open_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Me_Moving_Open_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_me_moving_open_here(inputs)
	return __ja.web_me_moving_open_here(inputs)
});
/**
* | output |
* | --- |
* | "Personal data is moving" |
*
* @param {Web_Me_Moving_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_me_moving_title = /** @type {((inputs?: Web_Me_Moving_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Me_Moving_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_me_moving_title(inputs)
	return __ja.web_me_moving_title(inputs)
});
/**
* | output |
* | --- |
* | "Personal data lives on the Vault ({hub}). Open it in a desktop connected to the Vault. The workspaces work here as before." |
*
* @param {Web_Me_On_Hub_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_me_on_hub_body = /** @type {((inputs: Web_Me_On_Hub_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Me_On_Hub_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_me_on_hub_body(inputs)
	return __ja.web_me_on_hub_body(inputs)
});
/**
* | output |
* | --- |
* | "Personal data lives on the Vault. Open it in a desktop connected to the Vault. The workspaces work here as before." |
*
* @param {Web_Me_On_Hub_Body_UnnamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_me_on_hub_body_unnamed = /** @type {((inputs?: Web_Me_On_Hub_Body_UnnamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Me_On_Hub_Body_UnnamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_me_on_hub_body_unnamed(inputs)
	return __ja.web_me_on_hub_body_unnamed(inputs)
});
/**
* | output |
* | --- |
* | "Personal data lives on the Vault" |
*
* @param {Web_Me_On_Hub_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_me_on_hub_title = /** @type {((inputs?: Web_Me_On_Hub_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Me_On_Hub_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_me_on_hub_title(inputs)
	return __ja.web_me_on_hub_title(inputs)
});
/**
* | output |
* | --- |
* | "Your personal data is on your Vault. Opening this PC's screen…" |
*
* @param {Web_Me_Opening_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_me_opening_here = /** @type {((inputs?: Web_Me_Opening_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Me_Opening_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_me_opening_here(inputs)
	return __ja.web_me_opening_here(inputs)
});
/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Web_Menu_AdminInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_menu_admin = /** @type {((inputs?: Web_Menu_AdminInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Menu_AdminInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_menu_admin(inputs)
	return __ja.web_menu_admin(inputs)
});
/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Web_Menu_Sign_OutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_menu_sign_out = /** @type {((inputs?: Web_Menu_Sign_OutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Menu_Sign_OutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_menu_sign_out(inputs)
	return __ja.web_menu_sign_out(inputs)
});
/**
* | output |
* | --- |
* | "Allow" |
*
* @param {Web_Oauth_AllowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_allow = /** @type {((inputs?: Web_Oauth_AllowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_AllowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_allow(inputs)
	return __ja.web_oauth_allow(inputs)
});
/**
* | output |
* | --- |
* | "It will be able to" |
*
* @param {Web_Oauth_Can_DoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_can_do = /** @type {((inputs?: Web_Oauth_Can_DoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_Can_DoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_can_do(inputs)
	return __ja.web_oauth_can_do(inputs)
});
/**
* | output |
* | --- |
* | "{client} wants to connect to trameria." |
*
* @param {Web_Oauth_ConnectingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_connecting = /** @type {((inputs: Web_Oauth_ConnectingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_ConnectingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_connecting(inputs)
	return __ja.web_oauth_connecting(inputs)
});
/**
* | output |
* | --- |
* | "Deny" |
*
* @param {Web_Oauth_DenyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_deny = /** @type {((inputs?: Web_Oauth_DenyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_DenyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_deny(inputs)
	return __ja.web_oauth_deny(inputs)
});
/**
* | output |
* | --- |
* | "Don't allow this unless you opened the app yourself" |
*
* @param {Web_Oauth_Desktop_WarningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_desktop_warning = /** @type {((inputs?: Web_Oauth_Desktop_WarningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_Desktop_WarningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_desktop_warning(inputs)
	return __ja.web_oauth_desktop_warning(inputs)
});
/**
* | output |
* | --- |
* | "Access goes to: {where}" |
*
* @param {Web_Oauth_DestinationInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_destination = /** @type {((inputs: Web_Oauth_DestinationInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_DestinationInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_destination(inputs)
	return __ja.web_oauth_destination(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't allow the connection" |
*
* @param {Web_Oauth_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_failed = /** @type {((inputs?: Web_Oauth_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_failed(inputs)
	return __ja.web_oauth_failed(inputs)
});
/**
* | output |
* | --- |
* | "This page opens when an MCP client (claude.ai, Claude Code) starts connecting to trameria." |
*
* @param {Web_Oauth_Outside_FlowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_outside_flow = /** @type {((inputs?: Web_Oauth_Outside_FlowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_Outside_FlowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_outside_flow(inputs)
	return __ja.web_oauth_outside_flow(inputs)
});
/**
* | output |
* | --- |
* | "Let the app on this computer or phone sign in to trameria as you" |
*
* @param {Web_Oauth_Scope_DesktopInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_scope_desktop = /** @type {((inputs?: Web_Oauth_Scope_DesktopInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_Scope_DesktopInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_scope_desktop(inputs)
	return __ja.web_oauth_scope_desktop(inputs)
});
/**
* | output |
* | --- |
* | "Stay connected (even after you sign out, until you disconnect it in Settings → Connected apps)" |
*
* @param {Web_Oauth_Scope_OfflineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_scope_offline = /** @type {((inputs?: Web_Oauth_Scope_OfflineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_Scope_OfflineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_scope_offline(inputs)
	return __ja.web_oauth_scope_offline(inputs)
});
/**
* | output |
* | --- |
* | "Read (Cases, People, documents)" |
*
* @param {Web_Oauth_Scope_ReadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_scope_read = /** @type {((inputs?: Web_Oauth_Scope_ReadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_Scope_ReadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_scope_read(inputs)
	return __ja.web_oauth_scope_read(inputs)
});
/**
* | output |
* | --- |
* | "Write (create and update Cases, People, documents)" |
*
* @param {Web_Oauth_Scope_WriteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_scope_write = /** @type {((inputs?: Web_Oauth_Scope_WriteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_Scope_WriteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_scope_write(inputs)
	return __ja.web_oauth_scope_write(inputs)
});
/**
* | output |
* | --- |
* | "an app on this device ({where})" |
*
* @param {Web_Oauth_This_DeviceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_this_device = /** @type {((inputs: Web_Oauth_This_DeviceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_This_DeviceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_this_device(inputs)
	return __ja.web_oauth_this_device(inputs)
});
/**
* | output |
* | --- |
* | "Allow the connection" |
*
* @param {Web_Oauth_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_title = /** @type {((inputs?: Web_Oauth_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_title(inputs)
	return __ja.web_oauth_title(inputs)
});
/**
* | output |
* | --- |
* | "Unverified app. It chose its own name, and trameria has not checked it. Deny it unless you recognise where the access goes." |
*
* @param {Web_Oauth_UnverifiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_oauth_unverified = /** @type {((inputs?: Web_Oauth_UnverifiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Oauth_UnverifiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_oauth_unverified(inputs)
	return __ja.web_oauth_unverified(inputs)
});
/**
* | output |
* | --- |
* | "The code has expired. Send a new one" |
*
* @param {Web_Otp_ExpiredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_otp_expired = /** @type {((inputs?: Web_Otp_ExpiredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Otp_ExpiredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_otp_expired(inputs)
	return __ja.web_otp_expired(inputs)
});
/**
* | output |
* | --- |
* | "That code is wrong" |
*
* @param {Web_Otp_InvalidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_otp_invalid = /** @type {((inputs?: Web_Otp_InvalidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Otp_InvalidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_otp_invalid(inputs)
	return __ja.web_otp_invalid(inputs)
});
/**
* | output |
* | --- |
* | "Too many tries. Send a new code" |
*
* @param {Web_Otp_Too_ManyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_otp_too_many = /** @type {((inputs?: Web_Otp_Too_ManyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Otp_Too_ManyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_otp_too_many(inputs)
	return __ja.web_otp_too_many(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't sign in with a passkey" |
*
* @param {Web_Passkey_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_passkey_failed = /** @type {((inputs?: Web_Passkey_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Passkey_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_passkey_failed(inputs)
	return __ja.web_passkey_failed(inputs)
});
/**
* | output |
* | --- |
* | "Later" |
*
* @param {Web_Passkey_LaterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_passkey_later = /** @type {((inputs?: Web_Passkey_LaterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Passkey_LaterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_passkey_later(inputs)
	return __ja.web_passkey_later(inputs)
});
/**
* | output |
* | --- |
* | "You can also add one later in Settings → Sign-in and security." |
*
* @param {Web_Passkey_Later_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_passkey_later_note = /** @type {((inputs?: Web_Passkey_Later_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Passkey_Later_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_passkey_later_note(inputs)
	return __ja.web_passkey_later_note(inputs)
});
/**
* | output |
* | --- |
* | "Next time, sign in with just your fingerprint, face or PIN." |
*
* @param {Web_Passkey_LeadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_passkey_lead = /** @type {((inputs?: Web_Passkey_LeadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Passkey_LeadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_passkey_lead(inputs)
	return __ja.web_passkey_lead(inputs)
});
/**
* | output |
* | --- |
* | "This device has no passkey yet. Continue with your email" |
*
* @param {Web_Passkey_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_passkey_none = /** @type {((inputs?: Web_Passkey_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Passkey_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_passkey_none(inputs)
	return __ja.web_passkey_none(inputs)
});
/**
* | output |
* | --- |
* | "Add" |
*
* @param {Web_Passkey_RegisterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_passkey_register = /** @type {((inputs?: Web_Passkey_RegisterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Passkey_RegisterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_passkey_register(inputs)
	return __ja.web_passkey_register(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't add the passkey" |
*
* @param {Web_Passkey_Register_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_passkey_register_failed = /** @type {((inputs?: Web_Passkey_Register_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Passkey_Register_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_passkey_register_failed(inputs)
	return __ja.web_passkey_register_failed(inputs)
});
/**
* | output |
* | --- |
* | "Add a passkey" |
*
* @param {Web_Passkey_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_passkey_title = /** @type {((inputs?: Web_Passkey_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Passkey_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_passkey_title(inputs)
	return __ja.web_passkey_title(inputs)
});
/**
* | output |
* | --- |
* | "Wait a moment and try again" |
*
* @param {Web_Rate_LimitedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_rate_limited = /** @type {((inputs?: Web_Rate_LimitedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Rate_LimitedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_rate_limited(inputs)
	return __ja.web_rate_limited(inputs)
});
/**
* | output |
* | --- |
* | "Too soon to send again" |
*
* @param {Web_Resend_Too_SoonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_resend_too_soon = /** @type {((inputs?: Web_Resend_Too_SoonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Resend_Too_SoonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_resend_too_soon(inputs)
	return __ja.web_resend_too_soon(inputs)
});
/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Web_RetryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_retry = /** @type {((inputs?: Web_RetryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_RetryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_retry(inputs)
	return __ja.web_retry(inputs)
});
/**
* | output |
* | --- |
* | "Connected apps" |
*
* @param {Web_Settings_AppsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps = /** @type {((inputs?: Web_Settings_AppsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_AppsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps(inputs)
	return __ja.web_settings_apps(inputs)
});
/**
* | output |
* | --- |
* | "Allow connected apps in {name}" |
*
* @param {Web_Settings_Apps_Allow_WorkspaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_allow_workspace = /** @type {((inputs: Web_Settings_Apps_Allow_WorkspaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Allow_WorkspaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_allow_workspace(inputs)
	return __ja.web_settings_apps_allow_workspace(inputs)
});
/**
* | output |
* | --- |
* | "{scopes} · allowed {granted}" |
*
* @param {Web_Settings_Apps_App_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_app_description = /** @type {((inputs: Web_Settings_Apps_App_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_App_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_app_description(inputs)
	return __ja.web_settings_apps_app_description(inputs)
});
/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Web_Settings_Apps_CopiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_copied = /** @type {((inputs?: Web_Settings_Apps_CopiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_CopiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_copied(inputs)
	return __ja.web_settings_apps_copied(inputs)
});
/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Web_Settings_Apps_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_copy = /** @type {((inputs?: Web_Settings_Apps_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_copy(inputs)
	return __ja.web_settings_apps_copy(inputs)
});
/**
* | output |
* | --- |
* | "Apps outside trameria (Claude and others) that use it for you." |
*
* @param {Web_Settings_Apps_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_description = /** @type {((inputs?: Web_Settings_Apps_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_description(inputs)
	return __ja.web_settings_apps_description(inputs)
});
/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Web_Settings_Apps_DisconnectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_disconnect = /** @type {((inputs?: Web_Settings_Apps_DisconnectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_DisconnectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_disconnect(inputs)
	return __ja.web_settings_apps_disconnect(inputs)
});
/**
* | output |
* | --- |
* | "Its next call will be refused. To use it again, connect again from the app." |
*
* @param {Web_Settings_Apps_Disconnect_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_disconnect_body = /** @type {((inputs?: Web_Settings_Apps_Disconnect_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Disconnect_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_disconnect_body(inputs)
	return __ja.web_settings_apps_disconnect_body(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't disconnect \"{name}\"" |
*
* @param {Web_Settings_Apps_Disconnect_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_disconnect_failed = /** @type {((inputs: Web_Settings_Apps_Disconnect_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Disconnect_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_disconnect_failed(inputs)
	return __ja.web_settings_apps_disconnect_failed(inputs)
});
/**
* | output |
* | --- |
* | "Disconnect \"{name}\"" |
*
* @param {Web_Settings_Apps_Disconnect_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_disconnect_title = /** @type {((inputs: Web_Settings_Apps_Disconnect_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Disconnect_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_disconnect_title(inputs)
	return __ja.web_settings_apps_disconnect_title(inputs)
});
/**
* | output |
* | --- |
* | "No app is connected." |
*
* @param {Web_Settings_Apps_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_empty = /** @type {((inputs?: Web_Settings_Apps_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_empty(inputs)
	return __ja.web_settings_apps_empty(inputs)
});
/**
* | output |
* | --- |
* | "Apps" |
*
* @param {Web_Settings_Apps_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_list = /** @type {((inputs?: Web_Settings_Apps_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_list(inputs)
	return __ja.web_settings_apps_list(inputs)
});
/**
* | output |
* | --- |
* | "You are not in any workspace." |
*
* @param {Web_Settings_Apps_No_WorkspacesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_no_workspaces = /** @type {((inputs?: Web_Settings_Apps_No_WorkspacesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_No_WorkspacesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_no_workspaces(inputs)
	return __ja.web_settings_apps_no_workspaces(inputs)
});
/**
* | output |
* | --- |
* | "An admin of this workspace has not allowed MCP" |
*
* @param {Web_Settings_Apps_Not_AllowedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_not_allowed = /** @type {((inputs?: Web_Settings_Apps_Not_AllowedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Not_AllowedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_not_allowed(inputs)
	return __ja.web_settings_apps_not_allowed(inputs)
});
/**
* | output |
* | --- |
* | "Desktop app" |
*
* @param {Web_Settings_Apps_Scope_DesktopInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_scope_desktop = /** @type {((inputs?: Web_Settings_Apps_Scope_DesktopInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Scope_DesktopInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_scope_desktop(inputs)
	return __ja.web_settings_apps_scope_desktop(inputs)
});
/**
* | output |
* | --- |
* | "Stay connected" |
*
* @param {Web_Settings_Apps_Scope_OfflineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_scope_offline = /** @type {((inputs?: Web_Settings_Apps_Scope_OfflineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Scope_OfflineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_scope_offline(inputs)
	return __ja.web_settings_apps_scope_offline(inputs)
});
/**
* | output |
* | --- |
* | "Read" |
*
* @param {Web_Settings_Apps_Scope_ReadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_scope_read = /** @type {((inputs?: Web_Settings_Apps_Scope_ReadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Scope_ReadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_scope_read(inputs)
	return __ja.web_settings_apps_scope_read(inputs)
});
/**
* | output |
* | --- |
* | "Write" |
*
* @param {Web_Settings_Apps_Scope_WriteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_scope_write = /** @type {((inputs?: Web_Settings_Apps_Scope_WriteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Scope_WriteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_scope_write(inputs)
	return __ja.web_settings_apps_scope_write(inputs)
});
/**
* | output |
* | --- |
* | "Server URL" |
*
* @param {Web_Settings_Apps_UrlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_url = /** @type {((inputs?: Web_Settings_Apps_UrlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_UrlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_url(inputs)
	return __ja.web_settings_apps_url(inputs)
});
/**
* | output |
* | --- |
* | "Paste this URL when adding a connector in Claude." |
*
* @param {Web_Settings_Apps_Url_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_url_note = /** @type {((inputs?: Web_Settings_Apps_Url_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Url_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_url_note(inputs)
	return __ja.web_settings_apps_url_note(inputs)
});
/**
* | output |
* | --- |
* | "Could not change access to {name}" |
*
* @param {Web_Settings_Apps_Workspace_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_workspace_failed = /** @type {((inputs: Web_Settings_Apps_Workspace_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Workspace_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_workspace_failed(inputs)
	return __ja.web_settings_apps_workspace_failed(inputs)
});
/**
* | output |
* | --- |
* | "Workspaces" |
*
* @param {Web_Settings_Apps_WorkspacesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_workspaces = /** @type {((inputs?: Web_Settings_Apps_WorkspacesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_WorkspacesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_workspaces(inputs)
	return __ja.web_settings_apps_workspaces(inputs)
});
/**
* | output |
* | --- |
* | "Connected apps can read and write only the workspaces you allow." |
*
* @param {Web_Settings_Apps_Workspaces_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_apps_workspaces_note = /** @type {((inputs?: Web_Settings_Apps_Workspaces_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Apps_Workspaces_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_apps_workspaces_note(inputs)
	return __ja.web_settings_apps_workspaces_note(inputs)
});
/**
* | output |
* | --- |
* | "Your personal settings, shared across all Workspaces." |
*
* @param {Web_Settings_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_description = /** @type {((inputs?: Web_Settings_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_description(inputs)
	return __ja.web_settings_description(inputs)
});
/**
* | output |
* | --- |
* | "Sign-in and security" |
*
* @param {Web_Settings_SecurityInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security = /** @type {((inputs?: Web_Settings_SecurityInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_SecurityInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security(inputs)
	return __ja.web_settings_security(inputs)
});
/**
* | output |
* | --- |
* | "Add a passkey" |
*
* @param {Web_Settings_Security_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_add = /** @type {((inputs?: Web_Settings_Security_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_add(inputs)
	return __ja.web_settings_security_add(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't add the passkey" |
*
* @param {Web_Settings_Security_Add_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_add_failed = /** @type {((inputs?: Web_Settings_Security_Add_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Add_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_add_failed(inputs)
	return __ja.web_settings_security_add_failed(inputs)
});
/**
* | output |
* | --- |
* | "You won't be able to sign in with this passkey any more." |
*
* @param {Web_Settings_Security_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_delete_body = /** @type {((inputs?: Web_Settings_Security_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_delete_body(inputs)
	return __ja.web_settings_security_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't delete \"{name}\"" |
*
* @param {Web_Settings_Security_Delete_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_delete_failed = /** @type {((inputs: Web_Settings_Security_Delete_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Delete_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_delete_failed(inputs)
	return __ja.web_settings_security_delete_failed(inputs)
});
/**
* | output |
* | --- |
* | "This is your last passkey. Without it, you'll sign in with a code by mail." |
*
* @param {Web_Settings_Security_Delete_Last_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_delete_last_body = /** @type {((inputs?: Web_Settings_Security_Delete_Last_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Delete_Last_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_delete_last_body(inputs)
	return __ja.web_settings_security_delete_last_body(inputs)
});
/**
* | output |
* | --- |
* | "Delete {name}" |
*
* @param {Web_Settings_Security_Delete_NamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_delete_named = /** @type {((inputs: Web_Settings_Security_Delete_NamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Delete_NamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_delete_named(inputs)
	return __ja.web_settings_security_delete_named(inputs)
});
/**
* | output |
* | --- |
* | "Delete the passkey \"{name}\"" |
*
* @param {Web_Settings_Security_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_delete_title = /** @type {((inputs: Web_Settings_Security_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_delete_title(inputs)
	return __ja.web_settings_security_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "How you sign in. With a passkey you don't need to type a code." |
*
* @param {Web_Settings_Security_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_description = /** @type {((inputs?: Web_Settings_Security_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_description(inputs)
	return __ja.web_settings_security_description(inputs)
});
/**
* | output |
* | --- |
* | "Email" |
*
* @param {Web_Settings_Security_EmailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_email = /** @type {((inputs?: Web_Settings_Security_EmailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_EmailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_email(inputs)
	return __ja.web_settings_security_email(inputs)
});
/**
* | output |
* | --- |
* | "Where sign-in codes go." |
*
* @param {Web_Settings_Security_Email_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_email_note = /** @type {((inputs?: Web_Settings_Security_Email_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Email_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_email_note(inputs)
	return __ja.web_settings_security_email_note(inputs)
});
/**
* | output |
* | --- |
* | "Google" |
*
* @param {Web_Settings_Security_GoogleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_google = /** @type {((inputs?: Web_Settings_Security_GoogleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_GoogleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_google(inputs)
	return __ja.web_settings_security_google(inputs)
});
/**
* | output |
* | --- |
* | "Link" |
*
* @param {Web_Settings_Security_Google_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_google_link = /** @type {((inputs?: Web_Settings_Security_Google_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Google_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_google_link(inputs)
	return __ja.web_settings_security_google_link(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't link Google" |
*
* @param {Web_Settings_Security_Google_Link_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_google_link_failed = /** @type {((inputs?: Web_Settings_Security_Google_Link_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Google_Link_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_google_link_failed(inputs)
	return __ja.web_settings_security_google_link_failed(inputs)
});
/**
* | output |
* | --- |
* | "Linked" |
*
* @param {Web_Settings_Security_Google_LinkedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_google_linked = /** @type {((inputs?: Web_Settings_Security_Google_LinkedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Google_LinkedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_google_linked(inputs)
	return __ja.web_settings_security_google_linked(inputs)
});
/**
* | output |
* | --- |
* | "Not available here" |
*
* @param {Web_Settings_Security_Google_Not_ConfiguredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_google_not_configured = /** @type {((inputs?: Web_Settings_Security_Google_Not_ConfiguredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Google_Not_ConfiguredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_google_not_configured(inputs)
	return __ja.web_settings_security_google_not_configured(inputs)
});
/**
* | output |
* | --- |
* | "Also sign in with your Google account." |
*
* @param {Web_Settings_Security_Google_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_google_note = /** @type {((inputs?: Web_Settings_Security_Google_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Google_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_google_note(inputs)
	return __ja.web_settings_security_google_note(inputs)
});
/**
* | output |
* | --- |
* | "Passkeys" |
*
* @param {Web_Settings_Security_PasskeysInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_passkeys = /** @type {((inputs?: Web_Settings_Security_PasskeysInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_PasskeysInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_passkeys(inputs)
	return __ja.web_settings_security_passkeys(inputs)
});
/**
* | output |
* | --- |
* | "Passkeys kept on your devices or in a password manager." |
*
* @param {Web_Settings_Security_Passkeys_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_passkeys_note = /** @type {((inputs?: Web_Settings_Security_Passkeys_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Passkeys_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_passkeys_note(inputs)
	return __ja.web_settings_security_passkeys_note(inputs)
});
/**
* | output |
* | --- |
* | "Added {date}" |
*
* @param {Web_Settings_Security_Registered_OnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_registered_on = /** @type {((inputs: Web_Settings_Security_Registered_OnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_Registered_OnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_registered_on(inputs)
	return __ja.web_settings_security_registered_on(inputs)
});
/**
* | output |
* | --- |
* | "Unnamed" |
*
* @param {Web_Settings_Security_UnnamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_security_unnamed = /** @type {((inputs?: Web_Settings_Security_UnnamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_Security_UnnamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_security_unnamed(inputs)
	return __ja.web_settings_security_unnamed(inputs)
});
/**
* | output |
* | --- |
* | "Account settings" |
*
* @param {Web_Settings_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_settings_title = /** @type {((inputs?: Web_Settings_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Settings_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_settings_title(inputs)
	return __ja.web_settings_title(inputs)
});
/**
* | output |
* | --- |
* | "Code" |
*
* @param {Web_Signin_Code_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_code_label = /** @type {((inputs?: Web_Signin_Code_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_Code_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_code_label(inputs)
	return __ja.web_signin_code_label(inputs)
});
/**
* | output |
* | --- |
* | "The code we sent to {email} a moment ago still works. It works for {minutes} minutes." |
*
* @param {Web_Signin_Code_ReusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_code_reused = /** @type {((inputs: Web_Signin_Code_ReusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_Code_ReusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_code_reused(inputs)
	return __ja.web_signin_code_reused(inputs)
});
/**
* | output |
* | --- |
* | "We sent a 6-digit code to {email}. It works for {minutes} minutes." |
*
* @param {Web_Signin_Code_SentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_code_sent = /** @type {((inputs: Web_Signin_Code_SentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_Code_SentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_code_sent(inputs)
	return __ja.web_signin_code_sent(inputs)
});
/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Web_Signin_ContinueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_continue = /** @type {((inputs?: Web_Signin_ContinueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_ContinueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_continue(inputs)
	return __ja.web_signin_continue(inputs)
});
/**
* | output |
* | --- |
* | "We'll email you a 6-digit code" |
*
* @param {Web_Signin_Email_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_email_hint = /** @type {((inputs?: Web_Signin_Email_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_Email_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_email_hint(inputs)
	return __ja.web_signin_email_hint(inputs)
});
/**
* | output |
* | --- |
* | "That doesn't look like an email address" |
*
* @param {Web_Signin_Email_InvalidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_email_invalid = /** @type {((inputs?: Web_Signin_Email_InvalidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_Email_InvalidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_email_invalid(inputs)
	return __ja.web_signin_email_invalid(inputs)
});
/**
* | output |
* | --- |
* | "Email" |
*
* @param {Web_Signin_Email_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_email_label = /** @type {((inputs?: Web_Signin_Email_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_Email_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_email_label(inputs)
	return __ja.web_signin_email_label(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't sign in" |
*
* @param {Web_Signin_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_failed = /** @type {((inputs?: Web_Signin_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_failed(inputs)
	return __ja.web_signin_failed(inputs)
});
/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Web_Signin_GoogleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_google = /** @type {((inputs?: Web_Signin_GoogleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_GoogleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_google(inputs)
	return __ja.web_signin_google(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't start signing in with Google" |
*
* @param {Web_Signin_Google_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_google_failed = /** @type {((inputs?: Web_Signin_Google_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_Google_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_google_failed(inputs)
	return __ja.web_signin_google_failed(inputs)
});
/**
* | output |
* | --- |
* | "Sign in again under Cloud in the app's settings. You sign in in your browser." |
*
* @param {Web_Signin_In_App_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_in_app_body = /** @type {((inputs?: Web_Signin_In_App_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_In_App_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_in_app_body(inputs)
	return __ja.web_signin_in_app_body(inputs)
});
/**
* | output |
* | --- |
* | "Signed out of the cloud" |
*
* @param {Web_Signin_In_App_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_in_app_title = /** @type {((inputs?: Web_Signin_In_App_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_In_App_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_in_app_title(inputs)
	return __ja.web_signin_in_app_title(inputs)
});
/**
* | output |
* | --- |
* | "Use another email" |
*
* @param {Web_Signin_Other_EmailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_other_email = /** @type {((inputs?: Web_Signin_Other_EmailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_Other_EmailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_other_email(inputs)
	return __ja.web_signin_other_email(inputs)
});
/**
* | output |
* | --- |
* | "Sign in with a passkey" |
*
* @param {Web_Signin_PasskeyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_passkey = /** @type {((inputs?: Web_Signin_PasskeyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_PasskeyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_passkey(inputs)
	return __ja.web_signin_passkey(inputs)
});
/**
* | output |
* | --- |
* | "Resend code" |
*
* @param {Web_Signin_ResendInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_resend = /** @type {((inputs?: Web_Signin_ResendInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_ResendInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_resend(inputs)
	return __ja.web_signin_resend(inputs)
});
/**
* | output |
* | --- |
* | "Sent again" |
*
* @param {Web_Signin_ResentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_resent = /** @type {((inputs?: Web_Signin_ResentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_ResentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_resent(inputs)
	return __ja.web_signin_resent(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't sign in. Wait a moment and try again" |
*
* @param {Web_Signin_RetryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_retry = /** @type {((inputs?: Web_Signin_RetryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_RetryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_retry(inputs)
	return __ja.web_signin_retry(inputs)
});
/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Web_Signin_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_signin_title = /** @type {((inputs?: Web_Signin_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Signin_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_signin_title(inputs)
	return __ja.web_signin_title(inputs)
});
/**
* | output |
* | --- |
* | "On a PC, enter the code shown under the QR code in \"Add a device\" under \"Device list\" in Trameria's app settings." |
*
* @param {Web_Trust_Approve_PcInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_trust_approve_pc = /** @type {((inputs?: Web_Trust_Approve_PcInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Trust_Approve_PcInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_trust_approve_pc(inputs)
	return __ja.web_trust_approve_pc(inputs)
});
/**
* | output |
* | --- |
* | "On iPhone and iPad this opens in the Trameria app. If the app didn't open, install it and scan the QR code again." |
*
* @param {Web_Trust_Approve_PhoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_trust_approve_phone = /** @type {((inputs?: Web_Trust_Approve_PhoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Trust_Approve_PhoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_trust_approve_phone(inputs)
	return __ja.web_trust_approve_phone(inputs)
});
/**
* | output |
* | --- |
* | "Add to the device list" |
*
* @param {Web_Trust_Approve_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_trust_approve_title = /** @type {((inputs?: Web_Trust_Approve_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Trust_Approve_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_trust_approve_title(inputs)
	return __ja.web_trust_approve_title(inputs)
});
/**
* | output |
* | --- |
* | "You're on the waitlist. We'll email {email} once you're approved. When the mail arrives, come back to this page to go on." |
*
* @param {Web_Waitlist_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_waitlist_body = /** @type {((inputs: Web_Waitlist_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Waitlist_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_waitlist_body(inputs)
	return __ja.web_waitlist_body(inputs)
});
/**
* | output |
* | --- |
* | "Sign in with another account" |
*
* @param {Web_Waitlist_SwitchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_waitlist_switch = /** @type {((inputs?: Web_Waitlist_SwitchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Waitlist_SwitchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_waitlist_switch(inputs)
	return __ja.web_waitlist_switch(inputs)
});
/**
* | output |
* | --- |
* | "Waitlist" |
*
* @param {Web_Waitlist_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const web_waitlist_title = /** @type {((inputs?: Web_Waitlist_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Web_Waitlist_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.web_waitlist_title(inputs)
	return __ja.web_waitlist_title(inputs)
});
/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Workspace_Default_Role_AdminInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const workspace_default_role_admin = /** @type {((inputs?: Workspace_Default_Role_AdminInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_Default_Role_AdminInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.workspace_default_role_admin(inputs)
	return __ja.workspace_default_role_admin(inputs)
});
/**
* | output |
* | --- |
* | "General" |
*
* @param {Workspace_Default_Space_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const workspace_default_space_name = /** @type {((inputs?: Workspace_Default_Space_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_Default_Space_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.workspace_default_space_name(inputs)
	return __ja.workspace_default_space_name(inputs)
});
/**
* | output |
* | --- |
* | "Unnamed" |
*
* @param {Workspace_Unnamed_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const workspace_unnamed_member = /** @type {((inputs?: Workspace_Unnamed_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_Unnamed_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.workspace_unnamed_member(inputs)
	return __ja.workspace_unnamed_member(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Ws_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_cancel = /** @type {((inputs?: Ws_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_cancel(inputs)
	return __ja.ws_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Case" |
*
* @param {Ws_Case_PanelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_case_panel = /** @type {((inputs?: Ws_Case_PanelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Case_PanelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_case_panel(inputs)
	return __ja.ws_case_panel(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Ws_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_delete = /** @type {((inputs?: Ws_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_delete(inputs)
	return __ja.ws_delete(inputs)
});
/**
* | output |
* | --- |
* | "Spaces" |
*
* @param {Ws_Dock_SpacesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_dock_spaces = /** @type {((inputs?: Ws_Dock_SpacesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Dock_SpacesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_dock_spaces(inputs)
	return __ja.ws_dock_spaces(inputs)
});
/**
* | output |
* | --- |
* | "Broadcast" |
*
* @param {Ws_Feature_BroadcastInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_broadcast = /** @type {((inputs?: Ws_Feature_BroadcastInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_BroadcastInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_broadcast(inputs)
	return __ja.ws_feature_broadcast(inputs)
});
/**
* | output |
* | --- |
* | "Announcements that reach everyone" |
*
* @param {Ws_Feature_Broadcast_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_broadcast_note = /** @type {((inputs?: Ws_Feature_Broadcast_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_Broadcast_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_broadcast_note(inputs)
	return __ja.ws_feature_broadcast_note(inputs)
});
/**
* | output |
* | --- |
* | "Cycles" |
*
* @param {Ws_Feature_CycleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_cycle = /** @type {((inputs?: Ws_Feature_CycleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_CycleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_cycle(inputs)
	return __ja.ws_feature_cycle(inputs)
});
/**
* | output |
* | --- |
* | "Periods that group issues" |
*
* @param {Ws_Feature_Cycle_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_cycle_note = /** @type {((inputs?: Ws_Feature_Cycle_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_Cycle_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_cycle_note(inputs)
	return __ja.ws_feature_cycle_note(inputs)
});
/**
* | output |
* | --- |
* | "DM" |
*
* @param {Ws_Feature_DmInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_dm = /** @type {((inputs?: Ws_Feature_DmInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_DmInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_dm(inputs)
	return __ja.ws_feature_dm(inputs)
});
/**
* | output |
* | --- |
* | "One-to-one talks" |
*
* @param {Ws_Feature_Dm_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_dm_note = /** @type {((inputs?: Ws_Feature_Dm_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_Dm_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_dm_note(inputs)
	return __ja.ws_feature_dm_note(inputs)
});
/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Ws_Feature_DocumentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_document = /** @type {((inputs?: Ws_Feature_DocumentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_DocumentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_document(inputs)
	return __ja.ws_feature_document(inputs)
});
/**
* | output |
* | --- |
* | "Documents written together" |
*
* @param {Ws_Feature_Document_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_document_note = /** @type {((inputs?: Ws_Feature_Document_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_Document_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_document_note(inputs)
	return __ja.ws_feature_document_note(inputs)
});
/**
* | output |
* | --- |
* | "Issues" |
*
* @param {Ws_Feature_IssueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_issue = /** @type {((inputs?: Ws_Feature_IssueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_IssueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_issue(inputs)
	return __ja.ws_feature_issue(inputs)
});
/**
* | output |
* | --- |
* | "Single tasks" |
*
* @param {Ws_Feature_Issue_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_issue_note = /** @type {((inputs?: Ws_Feature_Issue_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_Issue_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_issue_note(inputs)
	return __ja.ws_feature_issue_note(inputs)
});
/**
* | output |
* | --- |
* | "Journal" |
*
* @param {Ws_Feature_JournalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_journal = /** @type {((inputs?: Ws_Feature_JournalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_JournalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_journal(inputs)
	return __ja.ws_feature_journal(inputs)
});
/**
* | output |
* | --- |
* | "A timeline per person" |
*
* @param {Ws_Feature_Journal_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_journal_note = /** @type {((inputs?: Ws_Feature_Journal_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_Journal_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_journal_note(inputs)
	return __ja.ws_feature_journal_note(inputs)
});
/**
* | output |
* | --- |
* | "Projects" |
*
* @param {Ws_Feature_ProjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_project = /** @type {((inputs?: Ws_Feature_ProjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_ProjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_project(inputs)
	return __ja.ws_feature_project(inputs)
});
/**
* | output |
* | --- |
* | "Larger pieces of work" |
*
* @param {Ws_Feature_Project_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_project_note = /** @type {((inputs?: Ws_Feature_Project_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_Project_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_project_note(inputs)
	return __ja.ws_feature_project_note(inputs)
});
/**
* | output |
* | --- |
* | "Needs {feature}" |
*
* @param {Ws_Feature_RequiresInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_requires = /** @type {((inputs: Ws_Feature_RequiresInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_RequiresInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_requires(inputs)
	return __ja.ws_feature_requires(inputs)
});
/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Ws_Feature_TopicInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_topic = /** @type {((inputs?: Ws_Feature_TopicInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_TopicInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_topic(inputs)
	return __ja.ws_feature_topic(inputs)
});
/**
* | output |
* | --- |
* | "The space's conversations" |
*
* @param {Ws_Feature_Topic_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_topic_note = /** @type {((inputs?: Ws_Feature_Topic_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_Topic_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_topic_note(inputs)
	return __ja.ws_feature_topic_note(inputs)
});
/**
* | output |
* | --- |
* | "Calls" |
*
* @param {Ws_Feature_VoiceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_voice = /** @type {((inputs?: Ws_Feature_VoiceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_VoiceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_voice(inputs)
	return __ja.ws_feature_voice(inputs)
});
/**
* | output |
* | --- |
* | "Calls on the spot" |
*
* @param {Ws_Feature_Voice_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_feature_voice_note = /** @type {((inputs?: Ws_Feature_Voice_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Feature_Voice_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_feature_voice_note(inputs)
	return __ja.ws_feature_voice_note(inputs)
});
/**
* | output |
* | --- |
* | "Features in use" |
*
* @param {Ws_Features_EnabledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_features_enabled = /** @type {((inputs?: Ws_Features_EnabledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Features_EnabledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_features_enabled(inputs)
	return __ja.ws_features_enabled(inputs)
});
/**
* | output |
* | --- |
* | "Allow MCP from apps outside" |
*
* @param {Ws_Features_McpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_features_mcp = /** @type {((inputs?: Ws_Features_McpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Features_McpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_features_mcp(inputs)
	return __ja.ws_features_mcp(inputs)
});
/**
* | output |
* | --- |
* | "When off, members cannot read or write this workspace from apps outside. Agents on their devices are not affected" |
*
* @param {Ws_Features_Mcp_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_features_mcp_note = /** @type {((inputs?: Ws_Features_Mcp_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Features_Mcp_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_features_mcp_note(inputs)
	return __ja.ws_features_mcp_note(inputs)
});
/**
* | output |
* | --- |
* | "From outside" |
*
* @param {Ws_Features_OutsideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_features_outside = /** @type {((inputs?: Ws_Features_OutsideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Features_OutsideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_features_outside(inputs)
	return __ja.ws_features_outside(inputs)
});
/**
* | output |
* | --- |
* | "Allow publishing by link" |
*
* @param {Ws_Features_PublishInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_features_publish = /** @type {((inputs?: Ws_Features_PublishInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Features_PublishInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_features_publish(inputs)
	return __ja.ws_features_publish(inputs)
});
/**
* | output |
* | --- |
* | "Anyone with the link can read a published document" |
*
* @param {Ws_Features_Publish_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_features_publish_note = /** @type {((inputs?: Ws_Features_Publish_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Features_Publish_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_features_publish_note(inputs)
	return __ja.ws_features_publish_note(inputs)
});
/**
* | output |
* | --- |
* | "Turn off" |
*
* @param {Ws_Features_Publish_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_features_publish_off = /** @type {((inputs?: Ws_Features_Publish_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Features_Publish_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_features_publish_off(inputs)
	return __ja.ws_features_publish_off(inputs)
});
/**
* | output |
* | --- |
* | "Every published document stops, and its link no longer opens. Turning it on again does not bring them back." |
*
* @param {Ws_Features_Publish_Off_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_features_publish_off_body = /** @type {((inputs?: Ws_Features_Publish_Off_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Features_Publish_Off_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_features_publish_off_body(inputs)
	return __ja.ws_features_publish_off_body(inputs)
});
/**
* | output |
* | --- |
* | "Turn off publishing by link in {name}?" |
*
* @param {Ws_Features_Publish_Off_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_features_publish_off_title = /** @type {((inputs: Ws_Features_Publish_Off_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Features_Publish_Off_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_features_publish_off_title(inputs)
	return __ja.ws_features_publish_off_title(inputs)
});
/**
* | output |
* | --- |
* | "Icon" |
*
* @param {Ws_General_IconInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_general_icon = /** @type {((inputs?: Ws_General_IconInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_General_IconInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_general_icon(inputs)
	return __ja.ws_general_icon(inputs)
});
/**
* | output |
* | --- |
* | "The picture for this workspace on the rail and in menus. Without one, the first letter of its name shows" |
*
* @param {Ws_General_Icon_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_general_icon_note = /** @type {((inputs?: Ws_General_Icon_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_General_Icon_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_general_icon_note(inputs)
	return __ja.ws_general_icon_note(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Ws_General_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_general_name = /** @type {((inputs?: Ws_General_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_General_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_general_name(inputs)
	return __ja.ws_general_name(inputs)
});
/**
* | output |
* | --- |
* | "URL" |
*
* @param {Ws_General_UrlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_general_url = /** @type {((inputs?: Ws_General_UrlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_General_UrlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_general_url(inputs)
	return __ja.ws_general_url(inputs)
});
/**
* | output |
* | --- |
* | "Change" |
*
* @param {Ws_General_Url_ChangeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_general_url_change = /** @type {((inputs?: Ws_General_Url_ChangeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_General_Url_ChangeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_general_url_change(inputs)
	return __ja.ws_general_url_change(inputs)
});
/**
* | output |
* | --- |
* | "Change" |
*
* @param {Ws_General_Url_EditInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_general_url_edit = /** @type {((inputs?: Ws_General_Url_EditInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_General_Url_EditInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_general_url_edit(inputs)
	return __ja.ws_general_url_edit(inputs)
});
/**
* | output |
* | --- |
* | "Change the URL" |
*
* @param {Ws_General_Url_Edit_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_general_url_edit_title = /** @type {((inputs?: Ws_General_Url_Edit_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_General_Url_Edit_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_general_url_edit_title(inputs)
	return __ja.ws_general_url_edit_title(inputs)
});
/**
* | output |
* | --- |
* | "Links with the old URL stop working once it changes" |
*
* @param {Ws_General_Url_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_general_url_note = /** @type {((inputs?: Ws_General_Url_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_General_Url_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_general_url_note(inputs)
	return __ja.ws_general_url_note(inputs)
});
/**
* | output |
* | --- |
* | "Conversations, documents, issues and calls show up in the sidebar as each of them arrives. Your own Cases open from Cases." |
*
* @param {Ws_Home_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_home_empty = /** @type {((inputs?: Ws_Home_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Home_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_home_empty(inputs)
	return __ja.ws_home_empty(inputs)
});
/**
* | output |
* | --- |
* | "Could not join" |
*
* @param {Ws_Invite_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invite_failed = /** @type {((inputs?: Ws_Invite_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invite_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invite_failed(inputs)
	return __ja.ws_invite_failed(inputs)
});
/**
* | output |
* | --- |
* | "You join as a {kind}. You see only spaces open to everyone and the spaces you join." |
*
* @param {Ws_Invite_Guest_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invite_guest_note = /** @type {((inputs: Ws_Invite_Guest_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invite_Guest_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invite_guest_note(inputs)
	return __ja.ws_invite_guest_note(inputs)
});
/**
* | output |
* | --- |
* | "Join" |
*
* @param {Ws_Invite_JoinInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invite_join = /** @type {((inputs?: Ws_Invite_JoinInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invite_JoinInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invite_join(inputs)
	return __ja.ws_invite_join(inputs)
});
/**
* | output |
* | --- |
* | "Loading" |
*
* @param {Ws_Invite_LoadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invite_loading = /** @type {((inputs?: Ws_Invite_LoadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invite_LoadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invite_loading(inputs)
	return __ja.ws_invite_loading(inputs)
});
/**
* | output |
* | --- |
* | "This invite link was not found." |
*
* @param {Ws_Invite_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invite_not_found = /** @type {((inputs?: Ws_Invite_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invite_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invite_not_found(inputs)
	return __ja.ws_invite_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Sign in to join" |
*
* @param {Ws_Invite_Sign_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invite_sign_in = /** @type {((inputs?: Ws_Invite_Sign_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invite_Sign_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invite_sign_in(inputs)
	return __ja.ws_invite_sign_in(inputs)
});
/**
* | output |
* | --- |
* | "Invite" |
*
* @param {Ws_Invite_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invite_title = /** @type {((inputs?: Ws_Invite_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invite_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invite_title(inputs)
	return __ja.ws_invite_title(inputs)
});
/**
* | output |
* | --- |
* | "You are invited to {workspace}." |
*
* @param {Ws_Invite_ToInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invite_to = /** @type {((inputs: Ws_Invite_ToInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invite_ToInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invite_to(inputs)
	return __ja.ws_invite_to(inputs)
});
/**
* | output |
* | --- |
* | "This invite link to {workspace} has expired, been revoked or used up. Ask the person who invited you for a new one." |
*
* @param {Ws_Invite_UnusableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invite_unusable = /** @type {((inputs: Ws_Invite_UnusableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invite_UnusableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invite_unusable(inputs)
	return __ja.ws_invite_unusable(inputs)
});
/**
* | output |
* | --- |
* | "Active" |
*
* @param {Ws_Invites_ActiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_active = /** @type {((inputs?: Ws_Invites_ActiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_ActiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_active(inputs)
	return __ja.ws_invites_active(inputs)
});
/**
* | output |
* | --- |
* | "All" |
*
* @param {Ws_Invites_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_all = /** @type {((inputs?: Ws_Invites_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_all(inputs)
	return __ja.ws_invites_all(inputs)
});
/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Ws_Invites_CopiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_copied = /** @type {((inputs?: Ws_Invites_CopiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_CopiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_copied(inputs)
	return __ja.ws_invites_copied(inputs)
});
/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Ws_Invites_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_copy = /** @type {((inputs?: Ws_Invites_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_copy(inputs)
	return __ja.ws_invites_copy(inputs)
});
/**
* | output |
* | --- |
* | "Could not copy. Select the link and copy it" |
*
* @param {Ws_Invites_Copy_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_copy_failed = /** @type {((inputs?: Ws_Invites_Copy_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Copy_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_copy_failed(inputs)
	return __ja.ws_invites_copy_failed(inputs)
});
/**
* | output |
* | --- |
* | "Make the link" |
*
* @param {Ws_Invites_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_create = /** @type {((inputs?: Ws_Invites_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_create(inputs)
	return __ja.ws_invites_create(inputs)
});
/**
* | output |
* | --- |
* | "Could not make the link" |
*
* @param {Ws_Invites_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_create_failed = /** @type {((inputs?: Ws_Invites_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_create_failed(inputs)
	return __ja.ws_invites_create_failed(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "For {count} day" |
* | "other" | "For {count} days" |
*
* @param {Ws_Invites_DaysInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_days = /** @type {((inputs: Ws_Invites_DaysInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_DaysInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_days(inputs)
	return __ja.ws_invites_days(inputs)
});
/**
* | output |
* | --- |
* | "No links yet" |
*
* @param {Ws_Invites_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_empty = /** @type {((inputs?: Ws_Invites_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_empty(inputs)
	return __ja.ws_invites_empty(inputs)
});
/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Ws_Invites_ExpiredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_expired = /** @type {((inputs?: Ws_Invites_ExpiredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_ExpiredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_expired(inputs)
	return __ja.ws_invites_expired(inputs)
});
/**
* | output |
* | --- |
* | "Expires" |
*
* @param {Ws_Invites_ExpiresInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_expires = /** @type {((inputs?: Ws_Invites_ExpiresInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_ExpiresInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_expires(inputs)
	return __ja.ws_invites_expires(inputs)
});
/**
* | output |
* | --- |
* | "Filter the invite links" |
*
* @param {Ws_Invites_FilterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_filter = /** @type {((inputs?: Ws_Invites_FilterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_FilterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_filter(inputs)
	return __ja.ws_invites_filter(inputs)
});
/**
* | output |
* | --- |
* | "Joins as a guest, seeing only spaces open to everyone and the spaces they join. No roles." |
*
* @param {Ws_Invites_Guest_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_guest_note = /** @type {((inputs?: Ws_Invites_Guest_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Guest_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_guest_note(inputs)
	return __ja.ws_invites_guest_note(inputs)
});
/**
* | output |
* | --- |
* | "Joins as" |
*
* @param {Ws_Invites_Joins_AsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_joins_as = /** @type {((inputs?: Ws_Invites_Joins_AsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Joins_AsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_joins_as(inputs)
	return __ja.ws_invites_joins_as(inputs)
});
/**
* | output |
* | --- |
* | "Joins as" |
*
* @param {Ws_Invites_KindInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_kind = /** @type {((inputs?: Ws_Invites_KindInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_KindInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_kind(inputs)
	return __ja.ws_invites_kind(inputs)
});
/**
* | output |
* | --- |
* | "Invite link" |
*
* @param {Ws_Invites_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_link = /** @type {((inputs?: Ws_Invites_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_link(inputs)
	return __ja.ws_invites_link(inputs)
});
/**
* | output |
* | --- |
* | "Invite links" |
*
* @param {Ws_Invites_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_list = /** @type {((inputs?: Ws_Invites_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_list(inputs)
	return __ja.ws_invites_list(inputs)
});
/**
* | output |
* | --- |
* | "Uses" |
*
* @param {Ws_Invites_Max_UsesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_max_uses = /** @type {((inputs?: Ws_Invites_Max_UsesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Max_UsesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_max_uses(inputs)
	return __ja.ws_invites_max_uses(inputs)
});
/**
* | output |
* | --- |
* | "Joins as a member, with the permissions of @everyone and the role you choose." |
*
* @param {Ws_Invites_Member_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_member_note = /** @type {((inputs?: Ws_Invites_Member_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Member_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_member_note(inputs)
	return __ja.ws_invites_member_note(inputs)
});
/**
* | output |
* | --- |
* | "Never" |
*
* @param {Ws_Invites_NeverInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_never = /** @type {((inputs?: Ws_Invites_NeverInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_NeverInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_never(inputs)
	return __ja.ws_invites_never(inputs)
});
/**
* | output |
* | --- |
* | "New invite link" |
*
* @param {Ws_Invites_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_new = /** @type {((inputs?: Ws_Invites_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_new(inputs)
	return __ja.ws_invites_new(inputs)
});
/**
* | output |
* | --- |
* | "No active links" |
*
* @param {Ws_Invites_No_ActiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_no_active = /** @type {((inputs?: Ws_Invites_No_ActiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_No_ActiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_no_active(inputs)
	return __ja.ws_invites_no_active(inputs)
});
/**
* | output |
* | --- |
* | "This link was not found" |
*
* @param {Ws_Invites_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_not_found = /** @type {((inputs?: Ws_Invites_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_not_found(inputs)
	return __ja.ws_invites_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Revoke" |
*
* @param {Ws_Invites_RevokeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_revoke = /** @type {((inputs?: Ws_Invites_RevokeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_RevokeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_revoke(inputs)
	return __ja.ws_invites_revoke(inputs)
});
/**
* | output |
* | --- |
* | "Could not revoke the link" |
*
* @param {Ws_Invites_Revoke_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_revoke_failed = /** @type {((inputs?: Ws_Invites_Revoke_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Revoke_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_revoke_failed(inputs)
	return __ja.ws_invites_revoke_failed(inputs)
});
/**
* | output |
* | --- |
* | "No one can join with this link any more" |
*
* @param {Ws_Invites_Revoke_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_revoke_note = /** @type {((inputs?: Ws_Invites_Revoke_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Revoke_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_revoke_note(inputs)
	return __ja.ws_invites_revoke_note(inputs)
});
/**
* | output |
* | --- |
* | "Revoked" |
*
* @param {Ws_Invites_RevokedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_revoked = /** @type {((inputs?: Ws_Invites_RevokedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_RevokedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_revoked(inputs)
	return __ja.ws_invites_revoked(inputs)
});
/**
* | output |
* | --- |
* | "Role" |
*
* @param {Ws_Invites_RoleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_role = /** @type {((inputs?: Ws_Invites_RoleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_RoleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_role(inputs)
	return __ja.ws_invites_role(inputs)
});
/**
* | output |
* | --- |
* | "Roles below your own highest role" |
*
* @param {Ws_Invites_Role_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_role_note = /** @type {((inputs?: Ws_Invites_Role_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Role_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_role_note(inputs)
	return __ja.ws_invites_role_note(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Once" |
* | "other" | "Up to {count} times" |
*
* @param {Ws_Invites_TimesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_times = /** @type {((inputs: Ws_Invites_TimesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_TimesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_times(inputs)
	return __ja.ws_invites_times(inputs)
});
/**
* | output |
* | --- |
* | "No limit" |
*
* @param {Ws_Invites_UnlimitedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_unlimited = /** @type {((inputs?: Ws_Invites_UnlimitedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_UnlimitedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_unlimited(inputs)
	return __ja.ws_invites_unlimited(inputs)
});
/**
* | output |
* | --- |
* | "Until {date}" |
*
* @param {Ws_Invites_UntilInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_until = /** @type {((inputs: Ws_Invites_UntilInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_UntilInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_until(inputs)
	return __ja.ws_invites_until(inputs)
});
/**
* | output |
* | --- |
* | "Link" |
*
* @param {Ws_Invites_UrlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_url = /** @type {((inputs?: Ws_Invites_UrlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_UrlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_url(inputs)
	return __ja.ws_invites_url(inputs)
});
/**
* | output |
* | --- |
* | "This link gives a role you cannot give, so only the person who made it and the owner can see it" |
*
* @param {Ws_Invites_Url_HiddenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_url_hidden = /** @type {((inputs?: Ws_Invites_Url_HiddenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Url_HiddenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_url_hidden(inputs)
	return __ja.ws_invites_url_hidden(inputs)
});
/**
* | output |
* | --- |
* | "Whoever gets this link can join" |
*
* @param {Ws_Invites_Url_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_url_note = /** @type {((inputs?: Ws_Invites_Url_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Url_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_url_note(inputs)
	return __ja.ws_invites_url_note(inputs)
});
/**
* | output |
* | --- |
* | "Used {used} / {max}" |
*
* @param {Ws_Invites_UsageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_usage = /** @type {((inputs: Ws_Invites_UsageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_UsageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_usage(inputs)
	return __ja.ws_invites_usage(inputs)
});
/**
* | output |
* | --- |
* | "Used {used} / unlimited" |
*
* @param {Ws_Invites_Usage_UnlimitedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_usage_unlimited = /** @type {((inputs: Ws_Invites_Usage_UnlimitedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Usage_UnlimitedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_usage_unlimited(inputs)
	return __ja.ws_invites_usage_unlimited(inputs)
});
/**
* | output |
* | --- |
* | "Used up" |
*
* @param {Ws_Invites_Used_UpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_used_up = /** @type {((inputs?: Ws_Invites_Used_UpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Used_UpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_used_up(inputs)
	return __ja.ws_invites_used_up(inputs)
});
/**
* | output |
* | --- |
* | "Uses" |
*
* @param {Ws_Invites_UsesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_uses = /** @type {((inputs?: Ws_Invites_UsesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_UsesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_uses(inputs)
	return __ja.ws_invites_uses(inputs)
});
/**
* | output |
* | --- |
* | "{used} / {max}" |
*
* @param {Ws_Invites_Uses_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_uses_of = /** @type {((inputs: Ws_Invites_Uses_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Uses_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_uses_of(inputs)
	return __ja.ws_invites_uses_of(inputs)
});
/**
* | output |
* | --- |
* | "{used} / no limit" |
*
* @param {Ws_Invites_Uses_UnlimitedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_uses_unlimited = /** @type {((inputs: Ws_Invites_Uses_UnlimitedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_Uses_UnlimitedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_uses_unlimited(inputs)
	return __ja.ws_invites_uses_unlimited(inputs)
});
/**
* | output |
* | --- |
* | "Usable" |
*
* @param {Ws_Invites_ValidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_invites_valid = /** @type {((inputs?: Ws_Invites_ValidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Invites_ValidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_invites_valid(inputs)
	return __ja.ws_invites_valid(inputs)
});
/**
* | output |
* | --- |
* | "Guest" |
*
* @param {Ws_Kind_GuestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_kind_guest = /** @type {((inputs?: Ws_Kind_GuestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Kind_GuestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_kind_guest(inputs)
	return __ja.ws_kind_guest(inputs)
});
/**
* | output |
* | --- |
* | "Member" |
*
* @param {Ws_Kind_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_kind_member = /** @type {((inputs?: Ws_Kind_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Kind_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_kind_member(inputs)
	return __ja.ws_kind_member(inputs)
});
/**
* | output |
* | --- |
* | "Narrow the list" |
*
* @param {Ws_List_NarrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_list_narrow = /** @type {((inputs?: Ws_List_NarrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_List_NarrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_list_narrow(inputs)
	return __ja.ws_list_narrow(inputs)
});
/**
* | output |
* | --- |
* | "Narrow by name" |
*
* @param {Ws_List_Narrow_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_list_narrow_name = /** @type {((inputs?: Ws_List_Narrow_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_List_Narrow_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_list_narrow_name(inputs)
	return __ja.ws_list_narrow_name(inputs)
});
/**
* | output |
* | --- |
* | "Nothing matches" |
*
* @param {Ws_List_No_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_list_no_match = /** @type {((inputs?: Ws_List_No_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_List_No_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_list_no_match(inputs)
	return __ja.ws_list_no_match(inputs)
});
/**
* | output |
* | --- |
* | "Could not load" |
*
* @param {Ws_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_load_failed = /** @type {((inputs?: Ws_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_load_failed(inputs)
	return __ja.ws_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "All" |
*
* @param {Ws_Members_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_all = /** @type {((inputs?: Ws_Members_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_all(inputs)
	return __ja.ws_members_all(inputs)
});
/**
* | output |
* | --- |
* | "Actions on the selected people" |
*
* @param {Ws_Members_BulkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_bulk = /** @type {((inputs?: Ws_Members_BulkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_BulkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_bulk(inputs)
	return __ja.ws_members_bulk(inputs)
});
/**
* | output |
* | --- |
* | "Clear the selection" |
*
* @param {Ws_Members_Bulk_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_bulk_clear = /** @type {((inputs?: Ws_Members_Bulk_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Bulk_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_bulk_clear(inputs)
	return __ja.ws_members_bulk_clear(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Could not remove {count} person" |
* | "other" | "Could not remove {count} people" |
*
* @param {Ws_Members_Bulk_Remove_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_bulk_remove_failed = /** @type {((inputs: Ws_Members_Bulk_Remove_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Bulk_Remove_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_bulk_remove_failed(inputs)
	return __ja.ws_members_bulk_remove_failed(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Remove {count} person from this workspace?" |
* | "other" | "Remove {count} people from this workspace?" |
*
* @param {Ws_Members_Bulk_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_bulk_remove_title = /** @type {((inputs: Ws_Members_Bulk_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Bulk_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_bulk_remove_title(inputs)
	return __ja.ws_members_bulk_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Joined the workspace" |
*
* @param {Ws_Members_Col_JoinedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_col_joined = /** @type {((inputs?: Ws_Members_Col_JoinedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Col_JoinedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_col_joined(inputs)
	return __ja.ws_members_col_joined(inputs)
});
/**
* | output |
* | --- |
* | "Kind" |
*
* @param {Ws_Members_Col_KindInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_col_kind = /** @type {((inputs?: Ws_Members_Col_KindInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Col_KindInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_col_kind(inputs)
	return __ja.ws_members_col_kind(inputs)
});
/**
* | output |
* | --- |
* | "Last active" |
*
* @param {Ws_Members_Col_Last_ActiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_col_last_active = /** @type {((inputs?: Ws_Members_Col_Last_ActiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Col_Last_ActiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_col_last_active(inputs)
	return __ja.ws_members_col_last_active(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Ws_Members_Col_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_col_name = /** @type {((inputs?: Ws_Members_Col_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Col_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_col_name(inputs)
	return __ja.ws_members_col_name(inputs)
});
/**
* | output |
* | --- |
* | "Joined trameria" |
*
* @param {Ws_Members_Col_RegisteredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_col_registered = /** @type {((inputs?: Ws_Members_Col_RegisteredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Col_RegisteredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_col_registered(inputs)
	return __ja.ws_members_col_registered(inputs)
});
/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Ws_Members_Col_RolesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_col_roles = /** @type {((inputs?: Ws_Members_Col_RolesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Col_RolesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_col_roles(inputs)
	return __ja.ws_members_col_roles(inputs)
});
/**
* | output |
* | --- |
* | "No one yet" |
*
* @param {Ws_Members_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_empty = /** @type {((inputs?: Ws_Members_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_empty(inputs)
	return __ja.ws_members_empty(inputs)
});
/**
* | output |
* | --- |
* | "By kind and role" |
*
* @param {Ws_Members_FilterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_filter = /** @type {((inputs?: Ws_Members_FilterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_FilterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_filter(inputs)
	return __ja.ws_members_filter(inputs)
});
/**
* | output |
* | --- |
* | "A guest cannot hold roles." |
*
* @param {Ws_Members_Guest_No_RolesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_guest_no_roles = /** @type {((inputs?: Ws_Members_Guest_No_RolesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Guest_No_RolesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_guest_no_roles(inputs)
	return __ja.ws_members_guest_no_roles(inputs)
});
/**
* | output |
* | --- |
* | "Joined {date}" |
*
* @param {Ws_Members_JoinedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_joined = /** @type {((inputs: Ws_Members_JoinedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_JoinedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_joined(inputs)
	return __ja.ws_members_joined(inputs)
});
/**
* | output |
* | --- |
* | "Kind" |
*
* @param {Ws_Members_KindInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_kind = /** @type {((inputs?: Ws_Members_KindInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_KindInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_kind(inputs)
	return __ja.ws_members_kind(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the kind of {name}" |
*
* @param {Ws_Members_Kind_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_kind_failed = /** @type {((inputs: Ws_Members_Kind_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Kind_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_kind_failed(inputs)
	return __ja.ws_members_kind_failed(inputs)
});
/**
* | output |
* | --- |
* | "Members" |
*
* @param {Ws_Members_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_list = /** @type {((inputs?: Ws_Members_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_list(inputs)
	return __ja.ws_members_list(inputs)
});
/**
* | output |
* | --- |
* | "Make a guest" |
*
* @param {Ws_Members_Make_GuestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_make_guest = /** @type {((inputs?: Ws_Members_Make_GuestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Make_GuestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_make_guest(inputs)
	return __ja.ws_members_make_guest(inputs)
});
/**
* | output |
* | --- |
* | "Make a member" |
*
* @param {Ws_Members_Make_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_make_member = /** @type {((inputs?: Ws_Members_Make_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Make_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_make_member(inputs)
	return __ja.ws_members_make_member(inputs)
});
/**
* | output |
* | --- |
* | "No one matches" |
*
* @param {Ws_Members_No_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_no_match = /** @type {((inputs?: Ws_Members_No_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_No_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_no_match(inputs)
	return __ja.ws_members_no_match(inputs)
});
/**
* | output |
* | --- |
* | "There are no roles besides @everyone. Make one in Roles." |
*
* @param {Ws_Members_No_RolesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_no_roles = /** @type {((inputs?: Ws_Members_No_RolesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_No_RolesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_no_roles(inputs)
	return __ja.ws_members_no_roles(inputs)
});
/**
* | output |
* | --- |
* | "This person is not in this workspace" |
*
* @param {Ws_Members_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_not_found = /** @type {((inputs?: Ws_Members_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_not_found(inputs)
	return __ja.ws_members_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Ws_Members_OwnerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_owner = /** @type {((inputs?: Ws_Members_OwnerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_OwnerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_owner(inputs)
	return __ja.ws_members_owner(inputs)
});
/**
* | output |
* | --- |
* | "The owner of this workspace. Made it on {date}" |
*
* @param {Ws_Members_Owner_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_owner_note = /** @type {((inputs: Ws_Members_Owner_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Owner_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_owner_note(inputs)
	return __ja.ws_members_owner_note(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Ws_Members_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_remove = /** @type {((inputs?: Ws_Members_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_remove(inputs)
	return __ja.ws_members_remove(inputs)
});
/**
* | output |
* | --- |
* | "They also lose their roles and leave every space as member and manager. Coming back needs an invite." |
*
* @param {Ws_Members_Remove_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_remove_body = /** @type {((inputs?: Ws_Members_Remove_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Remove_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_remove_body(inputs)
	return __ja.ws_members_remove_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not remove {name}" |
*
* @param {Ws_Members_Remove_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_remove_failed = /** @type {((inputs: Ws_Members_Remove_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Remove_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_remove_failed(inputs)
	return __ja.ws_members_remove_failed(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Ws_Members_Remove_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_remove_label = /** @type {((inputs?: Ws_Members_Remove_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Remove_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_remove_label(inputs)
	return __ja.ws_members_remove_label(inputs)
});
/**
* | output |
* | --- |
* | "Removes them from this workspace" |
*
* @param {Ws_Members_Remove_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_remove_note = /** @type {((inputs?: Ws_Members_Remove_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Remove_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_remove_note(inputs)
	return __ja.ws_members_remove_note(inputs)
});
/**
* | output |
* | --- |
* | "Remove {name} from this workspace?" |
*
* @param {Ws_Members_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_remove_title = /** @type {((inputs: Ws_Members_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_remove_title(inputs)
	return __ja.ws_members_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Ws_Members_RolesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_roles = /** @type {((inputs?: Ws_Members_RolesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_RolesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_roles(inputs)
	return __ja.ws_members_roles(inputs)
});
/**
* | output |
* | --- |
* | "You can give only roles below your own highest role." |
*
* @param {Ws_Members_Roles_AboveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_roles_above = /** @type {((inputs?: Ws_Members_Roles_AboveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Roles_AboveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_roles_above(inputs)
	return __ja.ws_members_roles_above(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the roles of {name}" |
*
* @param {Ws_Members_Roles_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_roles_failed = /** @type {((inputs: Ws_Members_Roles_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Roles_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_roles_failed(inputs)
	return __ja.ws_members_roles_failed(inputs)
});
/**
* | output |
* | --- |
* | "Giving roles needs the permission to make, change and give roles." |
*
* @param {Ws_Members_Roles_Not_AllowedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_roles_not_allowed = /** @type {((inputs?: Ws_Members_Roles_Not_AllowedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Roles_Not_AllowedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_roles_not_allowed(inputs)
	return __ja.ws_members_roles_not_allowed(inputs)
});
/**
* | output |
* | --- |
* | "Narrow by name" |
*
* @param {Ws_Members_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_search = /** @type {((inputs?: Ws_Members_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_search(inputs)
	return __ja.ws_members_search(inputs)
});
/**
* | output |
* | --- |
* | "Select {name}" |
*
* @param {Ws_Members_SelectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_select = /** @type {((inputs: Ws_Members_SelectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_SelectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_select(inputs)
	return __ja.ws_members_select(inputs)
});
/**
* | output |
* | --- |
* | "Select all" |
*
* @param {Ws_Members_Select_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_select_all = /** @type {((inputs?: Ws_Members_Select_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_Select_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_select_all(inputs)
	return __ja.ws_members_select_all(inputs)
});
/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Ws_Members_SelectedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_selected = /** @type {((inputs: Ws_Members_SelectedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_SelectedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_selected(inputs)
	return __ja.ws_members_selected(inputs)
});
/**
* | output |
* | --- |
* | "Their roles and space management are taken away, and they leave the spaces they can no longer see. Making them a member again does not give these back." |
*
* @param {Ws_Members_To_Guest_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_to_guest_body = /** @type {((inputs?: Ws_Members_To_Guest_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_To_Guest_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_to_guest_body(inputs)
	return __ja.ws_members_to_guest_body(inputs)
});
/**
* | output |
* | --- |
* | "A guest sees only spaces open to everyone and the spaces they joined" |
*
* @param {Ws_Members_To_Guest_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_to_guest_note = /** @type {((inputs?: Ws_Members_To_Guest_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_To_Guest_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_to_guest_note(inputs)
	return __ja.ws_members_to_guest_note(inputs)
});
/**
* | output |
* | --- |
* | "Make {name} a guest?" |
*
* @param {Ws_Members_To_Guest_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_to_guest_title = /** @type {((inputs: Ws_Members_To_Guest_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_To_Guest_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_to_guest_title(inputs)
	return __ja.ws_members_to_guest_title(inputs)
});
/**
* | output |
* | --- |
* | "As a member they see the members' spaces again" |
*
* @param {Ws_Members_To_Member_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_members_to_member_note = /** @type {((inputs?: Ws_Members_To_Member_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Members_To_Member_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_members_to_member_note(inputs)
	return __ja.ws_members_to_member_note(inputs)
});
/**
* | output |
* | --- |
* | "Menu of {name}" |
*
* @param {Ws_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_menu = /** @type {((inputs: Ws_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_menu(inputs)
	return __ja.ws_menu(inputs)
});
/**
* | output |
* | --- |
* | "Invite" |
*
* @param {Ws_Menu_InviteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_menu_invite = /** @type {((inputs?: Ws_Menu_InviteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Menu_InviteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_menu_invite(inputs)
	return __ja.ws_menu_invite(inputs)
});
/**
* | output |
* | --- |
* | "Make a workspace" |
*
* @param {Ws_Menu_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_menu_new = /** @type {((inputs?: Ws_Menu_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Menu_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_menu_new(inputs)
	return __ja.ws_menu_new(inputs)
});
/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Ws_Menu_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_menu_settings = /** @type {((inputs?: Ws_Menu_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Menu_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_menu_settings(inputs)
	return __ja.ws_menu_settings(inputs)
});
/**
* | output |
* | --- |
* | "This workspace does not exist, or you are not in it yet. An invite link lets you join." |
*
* @param {Ws_Missing_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_missing_body = /** @type {((inputs?: Ws_Missing_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Missing_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_missing_body(inputs)
	return __ja.ws_missing_body(inputs)
});
/**
* | output |
* | --- |
* | "Workspace not found" |
*
* @param {Ws_Missing_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_missing_title = /** @type {((inputs?: Ws_Missing_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Missing_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_missing_title(inputs)
	return __ja.ws_missing_title(inputs)
});
/**
* | output |
* | --- |
* | "My Cases" |
*
* @param {Ws_My_CasesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_my_cases = /** @type {((inputs?: Ws_My_CasesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_My_CasesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_my_cases(inputs)
	return __ja.ws_my_cases(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} of my Cases links here" |
* | "other" | "{count} of my Cases link here" |
*
* @param {Ws_My_Cases_ChipInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_my_cases_chip = /** @type {((inputs: Ws_My_Cases_ChipInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_My_Cases_ChipInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_my_cases_chip(inputs)
	return __ja.ws_my_cases_chip(inputs)
});
/**
* | output |
* | --- |
* | "Make" |
*
* @param {Ws_New_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_new_create = /** @type {((inputs?: Ws_New_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_New_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_new_create(inputs)
	return __ja.ws_new_create(inputs)
});
/**
* | output |
* | --- |
* | "Where a team keeps its conversations, documents and issues. You become its owner." |
*
* @param {Ws_New_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_new_description = /** @type {((inputs?: Ws_New_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_New_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_new_description(inputs)
	return __ja.ws_new_description(inputs)
});
/**
* | output |
* | --- |
* | "Could not make the workspace" |
*
* @param {Ws_New_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_new_failed = /** @type {((inputs?: Ws_New_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_New_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_new_failed(inputs)
	return __ja.ws_new_failed(inputs)
});
/**
* | output |
* | --- |
* | "Make a workspace" |
*
* @param {Ws_New_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_new_title = /** @type {((inputs?: Ws_New_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_New_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_new_title(inputs)
	return __ja.ws_new_title(inputs)
});
/**
* | output |
* | --- |
* | "Add emoji" |
*
* @param {Ws_Perm_Emoji_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_emoji_create = /** @type {((inputs?: Ws_Perm_Emoji_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Emoji_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_emoji_create(inputs)
	return __ja.ws_perm_emoji_create(inputs)
});
/**
* | output |
* | --- |
* | "Delete anyone's emoji" |
*
* @param {Ws_Perm_Emoji_ManageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_emoji_manage = /** @type {((inputs?: Ws_Perm_Emoji_ManageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Emoji_ManageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_emoji_manage(inputs)
	return __ja.ws_perm_emoji_manage(inputs)
});
/**
* | output |
* | --- |
* | "Manage issues and projects" |
*
* @param {Ws_Perm_Issue_ManageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_issue_manage = /** @type {((inputs?: Ws_Perm_Issue_ManageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Issue_ManageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_issue_manage(inputs)
	return __ja.ws_perm_issue_manage(inputs)
});
/**
* | output |
* | --- |
* | "Remove members and change their kind" |
*
* @param {Ws_Perm_Member_ManageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_member_manage = /** @type {((inputs?: Ws_Perm_Member_ManageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Member_ManageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_member_manage(inputs)
	return __ja.ws_perm_member_manage(inputs)
});
/**
* | output |
* | --- |
* | "Write in conversations" |
*
* @param {Ws_Perm_Message_WriteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_message_write = /** @type {((inputs?: Ws_Perm_Message_WriteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Message_WriteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_message_write(inputs)
	return __ja.ws_perm_message_write(inputs)
});
/**
* | output |
* | --- |
* | "Make and write documents" |
*
* @param {Ws_Perm_Page_WriteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_page_write = /** @type {((inputs?: Ws_Perm_Page_WriteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Page_WriteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_page_write(inputs)
	return __ja.ws_perm_page_write(inputs)
});
/**
* | output |
* | --- |
* | "Make, change and give roles" |
*
* @param {Ws_Perm_Role_ManageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_role_manage = /** @type {((inputs?: Ws_Perm_Role_ManageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Role_ManageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_role_manage(inputs)
	return __ja.ws_perm_role_manage(inputs)
});
/**
* | output |
* | --- |
* | "Make spaces" |
*
* @param {Ws_Perm_Space_ManageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_space_manage = /** @type {((inputs?: Ws_Perm_Space_ManageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Space_ManageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_space_manage(inputs)
	return __ja.ws_perm_space_manage(inputs)
});
/**
* | output |
* | --- |
* | "Make and revoke invite links" |
*
* @param {Ws_Perm_Workspace_InviteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_workspace_invite = /** @type {((inputs?: Ws_Perm_Workspace_InviteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Workspace_InviteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_workspace_invite(inputs)
	return __ja.ws_perm_workspace_invite(inputs)
});
/**
* | output |
* | --- |
* | "Change the workspace's name, URL and features" |
*
* @param {Ws_Perm_Workspace_ManageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_perm_workspace_manage = /** @type {((inputs?: Ws_Perm_Workspace_ManageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Perm_Workspace_ManageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_perm_workspace_manage(inputs)
	return __ja.ws_perm_workspace_manage(inputs)
});
/**
* | output |
* | --- |
* | "Picture" |
*
* @param {Ws_Profile_AvatarInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_profile_avatar = /** @type {((inputs?: Ws_Profile_AvatarInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Profile_AvatarInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_profile_avatar(inputs)
	return __ja.ws_profile_avatar(inputs)
});
/**
* | output |
* | --- |
* | "A picture for this workspace only. Without one, your account's picture shows" |
*
* @param {Ws_Profile_Avatar_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_profile_avatar_note = /** @type {((inputs?: Ws_Profile_Avatar_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Profile_Avatar_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_profile_avatar_note(inputs)
	return __ja.ws_profile_avatar_note(inputs)
});
/**
* | output |
* | --- |
* | "Same as account" |
*
* @param {Ws_Profile_Avatar_ResetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_profile_avatar_reset = /** @type {((inputs?: Ws_Profile_Avatar_ResetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Profile_Avatar_ResetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_profile_avatar_reset(inputs)
	return __ja.ws_profile_avatar_reset(inputs)
});
/**
* | output |
* | --- |
* | "Display name" |
*
* @param {Ws_Profile_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_profile_name = /** @type {((inputs?: Ws_Profile_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Profile_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_profile_name(inputs)
	return __ja.ws_profile_name(inputs)
});
/**
* | output |
* | --- |
* | "The name people in this workspace see" |
*
* @param {Ws_Profile_Name_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_profile_name_note = /** @type {((inputs?: Ws_Profile_Name_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Profile_Name_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_profile_name_note(inputs)
	return __ja.ws_profile_name_note(inputs)
});
/**
* | output |
* | --- |
* | "Workspaces" |
*
* @param {Ws_RailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_rail = /** @type {((inputs?: Ws_RailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_RailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_rail(inputs)
	return __ja.ws_rail(inputs)
});
/**
* | output |
* | --- |
* | "Make a workspace" |
*
* @param {Ws_Rail_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_rail_new = /** @type {((inputs?: Ws_Rail_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Rail_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_rail_new(inputs)
	return __ja.ws_rail_new(inputs)
});
/**
* | output |
* | --- |
* | "You cannot change a role at or above your own highest role." |
*
* @param {Ws_Roles_Above_YouInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_above_you = /** @type {((inputs?: Ws_Roles_Above_YouInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Above_YouInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_above_you(inputs)
	return __ja.ws_roles_above_you(inputs)
});
/**
* | output |
* | --- |
* | "Make" |
*
* @param {Ws_Roles_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_create = /** @type {((inputs?: Ws_Roles_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_create(inputs)
	return __ja.ws_roles_create(inputs)
});
/**
* | output |
* | --- |
* | "Could not make the role" |
*
* @param {Ws_Roles_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_create_failed = /** @type {((inputs?: Ws_Roles_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_create_failed(inputs)
	return __ja.ws_roles_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "The role everyone has. Its name and position stay, and it cannot be deleted." |
*
* @param {Ws_Roles_Default_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_default_note = /** @type {((inputs?: Ws_Roles_Default_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Default_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_default_note(inputs)
	return __ja.ws_roles_default_note(inputs)
});
/**
* | output |
* | --- |
* | "Default (everyone)" |
*
* @param {Ws_Roles_Default_SubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_default_sub = /** @type {((inputs?: Ws_Roles_Default_SubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Default_SubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_default_sub(inputs)
	return __ja.ws_roles_default_sub(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "The {count} person with it loses it, and invite links that give it are deleted too." |
* | "other" | "The {count} people with it lose it, and invite links that give it are deleted too." |
*
* @param {Ws_Roles_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_delete_body = /** @type {((inputs: Ws_Roles_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_delete_body(inputs)
	return __ja.ws_roles_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not delete the role {name}" |
*
* @param {Ws_Roles_Delete_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_delete_failed = /** @type {((inputs: Ws_Roles_Delete_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Delete_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_delete_failed(inputs)
	return __ja.ws_roles_delete_failed(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Ws_Roles_Delete_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_delete_label = /** @type {((inputs?: Ws_Roles_Delete_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Delete_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_delete_label(inputs)
	return __ja.ws_roles_delete_label(inputs)
});
/**
* | output |
* | --- |
* | "Deletes this role" |
*
* @param {Ws_Roles_Delete_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_delete_note = /** @type {((inputs?: Ws_Roles_Delete_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Delete_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_delete_note(inputs)
	return __ja.ws_roles_delete_note(inputs)
});
/**
* | output |
* | --- |
* | "Delete the role {name}?" |
*
* @param {Ws_Roles_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_delete_title = /** @type {((inputs: Ws_Roles_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_delete_title(inputs)
	return __ja.ws_roles_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Ws_Roles_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_list = /** @type {((inputs?: Ws_Roles_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_list(inputs)
	return __ja.ws_roles_list(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Ws_Roles_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_name = /** @type {((inputs?: Ws_Roles_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_name(inputs)
	return __ja.ws_roles_name(inputs)
});
/**
* | output |
* | --- |
* | "e.g. Editor" |
*
* @param {Ws_Roles_Name_ExampleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_name_example = /** @type {((inputs?: Ws_Roles_Name_ExampleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Name_ExampleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_name_example(inputs)
	return __ja.ws_roles_name_example(inputs)
});
/**
* | output |
* | --- |
* | "New role" |
*
* @param {Ws_Roles_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_new = /** @type {((inputs?: Ws_Roles_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_new(inputs)
	return __ja.ws_roles_new(inputs)
});
/**
* | output |
* | --- |
* | "Changing roles needs the permission to make, change and give roles." |
*
* @param {Ws_Roles_Not_AllowedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_not_allowed = /** @type {((inputs?: Ws_Roles_Not_AllowedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Not_AllowedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_not_allowed(inputs)
	return __ja.ws_roles_not_allowed(inputs)
});
/**
* | output |
* | --- |
* | "This role was not found" |
*
* @param {Ws_Roles_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_not_found = /** @type {((inputs?: Ws_Roles_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_not_found(inputs)
	return __ja.ws_roles_not_found(inputs)
});
/**
* | output |
* | --- |
* | "What people with this role may do." |
*
* @param {Ws_Roles_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_note = /** @type {((inputs?: Ws_Roles_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_note(inputs)
	return __ja.ws_roles_note(inputs)
});
/**
* | output |
* | --- |
* | "You can give only permissions you hold." |
*
* @param {Ws_Roles_Only_YoursInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_only_yours = /** @type {((inputs?: Ws_Roles_Only_YoursInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Only_YoursInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_only_yours(inputs)
	return __ja.ws_roles_only_yours(inputs)
});
/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Ws_Roles_PermissionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_permissions = /** @type {((inputs?: Ws_Roles_PermissionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_PermissionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_permissions(inputs)
	return __ja.ws_roles_permissions(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the permissions of {name}" |
*
* @param {Ws_Roles_Permissions_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_permissions_failed = /** @type {((inputs: Ws_Roles_Permissions_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Permissions_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_permissions_failed(inputs)
	return __ja.ws_roles_permissions_failed(inputs)
});
/**
* | output |
* | --- |
* | "Position" |
*
* @param {Ws_Roles_PositionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_position = /** @type {((inputs?: Ws_Roles_PositionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_PositionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_position(inputs)
	return __ja.ws_roles_position(inputs)
});
/**
* | output |
* | --- |
* | "Higher is stronger, up to just below your own highest role" |
*
* @param {Ws_Roles_Position_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_position_note = /** @type {((inputs?: Ws_Roles_Position_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Position_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_position_note(inputs)
	return __ja.ws_roles_position_note(inputs)
});
/**
* | output |
* | --- |
* | "Level {position}" |
*
* @param {Ws_Roles_Position_SubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_roles_position_sub = /** @type {((inputs: Ws_Roles_Position_SubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Roles_Position_SubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_roles_position_sub(inputs)
	return __ja.ws_roles_position_sub(inputs)
});
/**
* | output |
* | --- |
* | "Could not save" |
*
* @param {Ws_Save_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_save_failed = /** @type {((inputs?: Ws_Save_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Save_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_save_failed(inputs)
	return __ja.ws_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Ws_Settings_AdminInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_admin = /** @type {((inputs?: Ws_Settings_AdminInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_AdminInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_admin(inputs)
	return __ja.ws_settings_admin(inputs)
});
/**
* | output |
* | --- |
* | "Back" |
*
* @param {Ws_Settings_BackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_back = /** @type {((inputs?: Ws_Settings_BackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_BackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_back(inputs)
	return __ja.ws_settings_back(inputs)
});
/**
* | output |
* | --- |
* | "Features" |
*
* @param {Ws_Settings_FeaturesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_features = /** @type {((inputs?: Ws_Settings_FeaturesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_FeaturesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_features(inputs)
	return __ja.ws_settings_features(inputs)
});
/**
* | output |
* | --- |
* | "What this workspace uses, and how it is reached from outside. A feature turned off goes from everyone's screen." |
*
* @param {Ws_Settings_Features_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_features_description = /** @type {((inputs?: Ws_Settings_Features_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_Features_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_features_description(inputs)
	return __ja.ws_settings_features_description(inputs)
});
/**
* | output |
* | --- |
* | "General" |
*
* @param {Ws_Settings_GeneralInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_general = /** @type {((inputs?: Ws_Settings_GeneralInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_GeneralInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_general(inputs)
	return __ja.ws_settings_general(inputs)
});
/**
* | output |
* | --- |
* | "The workspace's icon, name and URL." |
*
* @param {Ws_Settings_General_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_general_description = /** @type {((inputs?: Ws_Settings_General_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_General_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_general_description(inputs)
	return __ja.ws_settings_general_description(inputs)
});
/**
* | output |
* | --- |
* | "Your own settings in this Workspace, and Workspace administration." |
*
* @param {Ws_Settings_Index_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_index_description = /** @type {((inputs?: Ws_Settings_Index_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_Index_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_index_description(inputs)
	return __ja.ws_settings_index_description(inputs)
});
/**
* | output |
* | --- |
* | "Invites" |
*
* @param {Ws_Settings_InvitesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_invites = /** @type {((inputs?: Ws_Settings_InvitesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_InvitesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_invites(inputs)
	return __ja.ws_settings_invites(inputs)
});
/**
* | output |
* | --- |
* | "Links to join with, limited in uses and time as you choose." |
*
* @param {Ws_Settings_Invites_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_invites_description = /** @type {((inputs?: Ws_Settings_Invites_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_Invites_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_invites_description(inputs)
	return __ja.ws_settings_invites_description(inputs)
});
/**
* | output |
* | --- |
* | "Members" |
*
* @param {Ws_Settings_MembersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_members = /** @type {((inputs?: Ws_Settings_MembersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_MembersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_members(inputs)
	return __ja.ws_settings_members(inputs)
});
/**
* | output |
* | --- |
* | "The people in this workspace. Change their roles and kind, or remove them." |
*
* @param {Ws_Settings_Members_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_members_description = /** @type {((inputs?: Ws_Settings_Members_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_Members_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_members_description(inputs)
	return __ja.ws_settings_members_description(inputs)
});
/**
* | output |
* | --- |
* | "You may not open this setting." |
*
* @param {Ws_Settings_Not_AllowedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_not_allowed = /** @type {((inputs?: Ws_Settings_Not_AllowedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_Not_AllowedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_not_allowed(inputs)
	return __ja.ws_settings_not_allowed(inputs)
});
/**
* | output |
* | --- |
* | "Settings of {name}" |
*
* @param {Ws_Settings_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_of = /** @type {((inputs: Ws_Settings_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_of(inputs)
	return __ja.ws_settings_of(inputs)
});
/**
* | output |
* | --- |
* | "Personal" |
*
* @param {Ws_Settings_PersonalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_personal = /** @type {((inputs?: Ws_Settings_PersonalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_PersonalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_personal(inputs)
	return __ja.ws_settings_personal(inputs)
});
/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Ws_Settings_ProfileInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_profile = /** @type {((inputs?: Ws_Settings_ProfileInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_ProfileInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_profile(inputs)
	return __ja.ws_settings_profile(inputs)
});
/**
* | output |
* | --- |
* | "The name and picture you use in this workspace. Each workspace has its own." |
*
* @param {Ws_Settings_Profile_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_profile_description = /** @type {((inputs?: Ws_Settings_Profile_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_Profile_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_profile_description(inputs)
	return __ja.ws_settings_profile_description(inputs)
});
/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Ws_Settings_RolesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_roles = /** @type {((inputs?: Ws_Settings_RolesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_RolesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_roles(inputs)
	return __ja.ws_settings_roles(inputs)
});
/**
* | output |
* | --- |
* | "Sets of what people may do. Higher roles are stronger, and you can change only roles below your own." |
*
* @param {Ws_Settings_Roles_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_roles_description = /** @type {((inputs?: Ws_Settings_Roles_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_Roles_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_roles_description(inputs)
	return __ja.ws_settings_roles_description(inputs)
});
/**
* | output |
* | --- |
* | "Spaces" |
*
* @param {Ws_Settings_SpacesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_spaces = /** @type {((inputs?: Ws_Settings_SpacesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_SpacesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_spaces(inputs)
	return __ja.ws_settings_spaces(inputs)
});
/**
* | output |
* | --- |
* | "Where conversations and documents live. Each space decides who sees it and what it uses." |
*
* @param {Ws_Settings_Spaces_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_spaces_description = /** @type {((inputs?: Ws_Settings_Spaces_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_Spaces_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_spaces_description(inputs)
	return __ja.ws_settings_spaces_description(inputs)
});
/**
* | output |
* | --- |
* | "Workspace settings" |
*
* @param {Ws_Settings_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_settings_title = /** @type {((inputs?: Ws_Settings_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Settings_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_settings_title(inputs)
	return __ja.ws_settings_title(inputs)
});
/**
* | output |
* | --- |
* | "Use 3 to 32 lowercase letters, digits or -, starting and ending with a letter or digit" |
*
* @param {Ws_Slug_FormatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_slug_format = /** @type {((inputs?: Ws_Slug_FormatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Slug_FormatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_slug_format(inputs)
	return __ja.ws_slug_format(inputs)
});
/**
* | output |
* | --- |
* | "This URL cannot be used" |
*
* @param {Ws_Slug_ReservedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_slug_reserved = /** @type {((inputs?: Ws_Slug_ReservedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Slug_ReservedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_slug_reserved(inputs)
	return __ja.ws_slug_reserved(inputs)
});
/**
* | output |
* | --- |
* | "This URL is taken" |
*
* @param {Ws_Slug_TakenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_slug_taken = /** @type {((inputs?: Ws_Slug_TakenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Slug_TakenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_slug_taken(inputs)
	return __ja.ws_slug_taken(inputs)
});
/**
* | output |
* | --- |
* | "Add a manager" |
*
* @param {Ws_Spaces_Add_ManagerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_add_manager = /** @type {((inputs?: Ws_Spaces_Add_ManagerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Add_ManagerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_add_manager(inputs)
	return __ja.ws_spaces_add_manager(inputs)
});
/**
* | output |
* | --- |
* | "Add a member" |
*
* @param {Ws_Spaces_Add_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_add_member = /** @type {((inputs?: Ws_Spaces_Add_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Add_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_add_member(inputs)
	return __ja.ws_spaces_add_member(inputs)
});
/**
* | output |
* | --- |
* | "Everyone in this workspace sees it, guests too" |
*
* @param {Ws_Spaces_Anyone_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_anyone_note = /** @type {((inputs?: Ws_Spaces_Anyone_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Anyone_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_anyone_note(inputs)
	return __ja.ws_spaces_anyone_note(inputs)
});
/**
* | output |
* | --- |
* | "Archive" |
*
* @param {Ws_Spaces_ArchiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_archive = /** @type {((inputs?: Ws_Spaces_ArchiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_ArchiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_archive(inputs)
	return __ja.ws_spaces_archive(inputs)
});
/**
* | output |
* | --- |
* | "Archive and delete" |
*
* @param {Ws_Spaces_Archive_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_archive_label = /** @type {((inputs?: Ws_Spaces_Archive_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Archive_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_archive_label(inputs)
	return __ja.ws_spaces_archive_label(inputs)
});
/**
* | output |
* | --- |
* | "Takes it out of the sidebar and keeps what is in it" |
*
* @param {Ws_Spaces_Archive_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_archive_note = /** @type {((inputs?: Ws_Spaces_Archive_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Archive_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_archive_note(inputs)
	return __ja.ws_spaces_archive_note(inputs)
});
/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Ws_Spaces_ArchivedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_archived = /** @type {((inputs?: Ws_Spaces_ArchivedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_ArchivedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_archived(inputs)
	return __ja.ws_spaces_archived(inputs)
});
/**
* | output |
* | --- |
* | "Archived. Not shown in the sidebar" |
*
* @param {Ws_Spaces_Archived_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_archived_note = /** @type {((inputs?: Ws_Spaces_Archived_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Archived_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_archived_note(inputs)
	return __ja.ws_spaces_archived_note(inputs)
});
/**
* | output |
* | --- |
* | "Make" |
*
* @param {Ws_Spaces_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_create = /** @type {((inputs?: Ws_Spaces_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_create(inputs)
	return __ja.ws_spaces_create(inputs)
});
/**
* | output |
* | --- |
* | "Could not make the space" |
*
* @param {Ws_Spaces_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_create_failed = /** @type {((inputs?: Ws_Spaces_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_create_failed(inputs)
	return __ja.ws_spaces_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "Making spaces needs the permission to make spaces." |
*
* @param {Ws_Spaces_Create_Not_AllowedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_create_not_allowed = /** @type {((inputs?: Ws_Spaces_Create_Not_AllowedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Create_Not_AllowedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_create_not_allowed(inputs)
	return __ja.ws_spaces_create_not_allowed(inputs)
});
/**
* | output |
* | --- |
* | "Its conversations, documents and issues can no longer be seen, and its members and managers leave it." |
*
* @param {Ws_Spaces_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_delete_body = /** @type {((inputs?: Ws_Spaces_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_delete_body(inputs)
	return __ja.ws_spaces_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not delete the space {name}" |
*
* @param {Ws_Spaces_Delete_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_delete_failed = /** @type {((inputs: Ws_Spaces_Delete_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Delete_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_delete_failed(inputs)
	return __ja.ws_spaces_delete_failed(inputs)
});
/**
* | output |
* | --- |
* | "Deletes this space" |
*
* @param {Ws_Spaces_Delete_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_delete_note = /** @type {((inputs?: Ws_Spaces_Delete_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Delete_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_delete_note(inputs)
	return __ja.ws_spaces_delete_note(inputs)
});
/**
* | output |
* | --- |
* | "Delete the space {name}?" |
*
* @param {Ws_Spaces_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_delete_title = /** @type {((inputs: Ws_Spaces_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_delete_title(inputs)
	return __ja.ws_spaces_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "Description" |
*
* @param {Ws_Spaces_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_description = /** @type {((inputs?: Ws_Spaces_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_description(inputs)
	return __ja.ws_spaces_description(inputs)
});
/**
* | output |
* | --- |
* | "What the space is for" |
*
* @param {Ws_Spaces_Description_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_description_placeholder = /** @type {((inputs?: Ws_Spaces_Description_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Description_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_description_placeholder(inputs)
	return __ja.ws_spaces_description_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Features in use" |
*
* @param {Ws_Spaces_FeaturesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_features = /** @type {((inputs?: Ws_Spaces_FeaturesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_FeaturesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_features(inputs)
	return __ja.ws_spaces_features(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the features of {name}" |
*
* @param {Ws_Spaces_Features_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_features_failed = /** @type {((inputs: Ws_Spaces_Features_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Features_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_features_failed(inputs)
	return __ja.ws_spaces_features_failed(inputs)
});
/**
* | output |
* | --- |
* | "Spaces" |
*
* @param {Ws_Spaces_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_list = /** @type {((inputs?: Ws_Spaces_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_list(inputs)
	return __ja.ws_spaces_list(inputs)
});
/**
* | output |
* | --- |
* | "Managers" |
*
* @param {Ws_Spaces_ManagersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_managers = /** @type {((inputs?: Ws_Spaces_ManagersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_ManagersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_managers(inputs)
	return __ja.ws_spaces_managers(inputs)
});
/**
* | output |
* | --- |
* | "Members" |
*
* @param {Ws_Spaces_MembersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_members = /** @type {((inputs?: Ws_Spaces_MembersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_MembersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_members(inputs)
	return __ja.ws_spaces_members(inputs)
});
/**
* | output |
* | --- |
* | "Members see it. Guests do not" |
*
* @param {Ws_Spaces_Members_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_members_note = /** @type {((inputs?: Ws_Spaces_Members_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Members_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_members_note(inputs)
	return __ja.ws_spaces_members_note(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Ws_Spaces_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_name = /** @type {((inputs?: Ws_Spaces_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_name(inputs)
	return __ja.ws_spaces_name(inputs)
});
/**
* | output |
* | --- |
* | "Change" |
*
* @param {Ws_Spaces_NarrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_narrow = /** @type {((inputs?: Ws_Spaces_NarrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_NarrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_narrow(inputs)
	return __ja.ws_spaces_narrow(inputs)
});
/**
* | output |
* | --- |
* | "Guests stop seeing this space at once." |
*
* @param {Ws_Spaces_Narrow_Members_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_narrow_members_body = /** @type {((inputs?: Ws_Spaces_Narrow_Members_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Narrow_Members_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_narrow_members_body(inputs)
	return __ja.ws_spaces_narrow_members_body(inputs)
});
/**
* | output |
* | --- |
* | "Those who are not its members stop seeing this space at once. Its managers and you become its members." |
*
* @param {Ws_Spaces_Narrow_Private_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_narrow_private_body = /** @type {((inputs?: Ws_Spaces_Narrow_Private_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Narrow_Private_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_narrow_private_body(inputs)
	return __ja.ws_spaces_narrow_private_body(inputs)
});
/**
* | output |
* | --- |
* | "Make {name} \"{visibility}\"?" |
*
* @param {Ws_Spaces_Narrow_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_narrow_title = /** @type {((inputs: Ws_Spaces_Narrow_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Narrow_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_narrow_title(inputs)
	return __ja.ws_spaces_narrow_title(inputs)
});
/**
* | output |
* | --- |
* | "New space" |
*
* @param {Ws_Spaces_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_new = /** @type {((inputs?: Ws_Spaces_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_new(inputs)
	return __ja.ws_spaces_new(inputs)
});
/**
* | output |
* | --- |
* | "No managers" |
*
* @param {Ws_Spaces_No_ManagersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_no_managers = /** @type {((inputs?: Ws_Spaces_No_ManagersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_No_ManagersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_no_managers(inputs)
	return __ja.ws_spaces_no_managers(inputs)
});
/**
* | output |
* | --- |
* | "No members yet" |
*
* @param {Ws_Spaces_No_MembersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_no_members = /** @type {((inputs?: Ws_Spaces_No_MembersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_No_MembersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_no_members(inputs)
	return __ja.ws_spaces_no_members(inputs)
});
/**
* | output |
* | --- |
* | "Only the space's managers and those who manage the workspace can change it." |
*
* @param {Ws_Spaces_Not_AllowedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_not_allowed = /** @type {((inputs?: Ws_Spaces_Not_AllowedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Not_AllowedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_not_allowed(inputs)
	return __ja.ws_spaces_not_allowed(inputs)
});
/**
* | output |
* | --- |
* | "This space was not found" |
*
* @param {Ws_Spaces_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_not_found = /** @type {((inputs?: Ws_Spaces_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_not_found(inputs)
	return __ja.ws_spaces_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Only its members see it" |
*
* @param {Ws_Spaces_Private_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_private_note = /** @type {((inputs?: Ws_Spaces_Private_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Private_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_private_note(inputs)
	return __ja.ws_spaces_private_note(inputs)
});
/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Ws_Spaces_Remove_PersonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_remove_person = /** @type {((inputs: Ws_Spaces_Remove_PersonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Remove_PersonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_remove_person(inputs)
	return __ja.ws_spaces_remove_person(inputs)
});
/**
* | output |
* | --- |
* | "Could not remove {name}" |
*
* @param {Ws_Spaces_Remove_Person_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_remove_person_failed = /** @type {((inputs: Ws_Spaces_Remove_Person_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Remove_Person_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_remove_person_failed(inputs)
	return __ja.ws_spaces_remove_person_failed(inputs)
});
/**
* | output |
* | --- |
* | "Restore" |
*
* @param {Ws_Spaces_UnarchiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_unarchive = /** @type {((inputs?: Ws_Spaces_UnarchiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_UnarchiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_unarchive(inputs)
	return __ja.ws_spaces_unarchive(inputs)
});
/**
* | output |
* | --- |
* | "Puts it back in the sidebar" |
*
* @param {Ws_Spaces_Unarchive_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_unarchive_note = /** @type {((inputs?: Ws_Spaces_Unarchive_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_Unarchive_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_unarchive_note(inputs)
	return __ja.ws_spaces_unarchive_note(inputs)
});
/**
* | output |
* | --- |
* | "Who sees it" |
*
* @param {Ws_Spaces_VisibilityInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_spaces_visibility = /** @type {((inputs?: Ws_Spaces_VisibilityInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Spaces_VisibilityInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_spaces_visibility(inputs)
	return __ja.ws_spaces_visibility(inputs)
});
/**
* | output |
* | --- |
* | "Everyone" |
*
* @param {Ws_Visibility_AnyoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_visibility_anyone = /** @type {((inputs?: Ws_Visibility_AnyoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Visibility_AnyoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_visibility_anyone(inputs)
	return __ja.ws_visibility_anyone(inputs)
});
/**
* | output |
* | --- |
* | "Members only" |
*
* @param {Ws_Visibility_MembersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_visibility_members = /** @type {((inputs?: Ws_Visibility_MembersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Visibility_MembersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_visibility_members(inputs)
	return __ja.ws_visibility_members(inputs)
});
/**
* | output |
* | --- |
* | "Its members only" |
*
* @param {Ws_Visibility_PrivateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const ws_visibility_private = /** @type {((inputs?: Ws_Visibility_PrivateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Visibility_PrivateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.ws_visibility_private(inputs)
	return __ja.ws_visibility_private(inputs)
});